/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any }
}

export type AllImageVersion = {
  __typename?: 'AllImageVersion'
  createdAt: Scalars['ISO8601DateTime']['output']
  newDocumentationMarkdownText: Scalars['String']['output']
}

export type Answer = {
  __typename?: 'Answer'
  answer: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  externalUserName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isDirectMessage: Scalars['Boolean']['output']
  markedUnhelpful: Scalars['Boolean']['output']
  messageActualThreadExternalId?: Maybe<Scalars['String']['output']>
  prettifiedQuestion: Scalars['String']['output']
  question: Scalars['String']['output']
  sources: Array<Scalars['String']['output']>
}

export type AnswerMessageType = {
  __typename?: 'AnswerMessageType'
  answerId?: Maybe<Scalars['ID']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  hasIncorrectAnswerFeedback?: Maybe<Scalars['Boolean']['output']>
  message: Scalars['String']['output']
  sources?: Maybe<Array<Scalars['String']['output']>>
  userName: Scalars['String']['output']
}

export enum AnswerTypeEnum {
  Codebase = 'CODEBASE',
  CodebaseCommitMessages = 'CODEBASE_COMMIT_MESSAGES',
  Confluence = 'CONFLUENCE',
  Document360 = 'DOCUMENT360',
  Featurebase = 'FEATUREBASE',
  Front = 'FRONT',
  GithubDocs = 'GITHUB_DOCS',
  HelpScout = 'HELP_SCOUT',
  Hubspot = 'HUBSPOT',
  Intercom = 'INTERCOM',
  Jira = 'JIRA',
  Linear = 'LINEAR',
  Notion = 'NOTION',
  Pylon = 'PYLON',
  ScreenSteps = 'SCREEN_STEPS',
  Slack = 'SLACK',
  Teamsupport = 'TEAMSUPPORT',
  Website = 'WEBSITE',
  Zendesk = 'ZENDESK',
}

export enum AuthProviderTypeEnum {
  Google = 'GOOGLE',
}

export type AuthResponse = {
  __typename?: 'AuthResponse'
  token?: Maybe<Scalars['ID']['output']>
  user?: Maybe<Users>
}

export enum AutoApproveFeatureFlagEnum {
  DontConsider = 'DONT_CONSIDER',
  FullyOn = 'FULLY_ON',
  PartiallyOn = 'PARTIALLY_ON',
}

export type BillingPlan = {
  __typename?: 'BillingPlan'
  billingType: BillingTypeEnum
  id: Scalars['ID']['output']
  perUnit: Scalars['Int']['output']
}

export enum BillingTypeEnum {
  FlatFee = 'FLAT_FEE',
  PerQuestion = 'PER_QUESTION',
  PerUser = 'PER_USER',
}

export type BrowserFlow = {
  __typename?: 'BrowserFlow'
  browserFlowRuns: Array<BrowserFlowRun>
  browserFlowSteps: Array<BrowserFlowStep>
  createdAt: Scalars['ISO8601DateTime']['output']
  flowType: BrowserFlowType
  id: Scalars['ID']['output']
  imageFlow?: Maybe<ImageFlow>
  mostRecentCompletedBrowserFlowRun?: Maybe<BrowserFlowRun>
  name?: Maybe<Scalars['String']['output']>
  startUrl?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Autogenerated return type of BrowserFlowImage. */
export type BrowserFlowImagePayload = {
  __typename?: 'BrowserFlowImagePayload'
  browserFlowId: Scalars['ID']['output']
  browserFlowRunId: Scalars['ID']['output']
  imageUrl?: Maybe<Scalars['String']['output']>
  lastRun?: Maybe<Scalars['Boolean']['output']>
  status: Scalars['String']['output']
}

export type BrowserFlowRun = {
  __typename?: 'BrowserFlowRun'
  createdAt: Scalars['ISO8601DateTime']['output']
  imageUrl?: Maybe<Scalars['String']['output']>
  sessionReplayUrl?: Maybe<Scalars['String']['output']>
  sessionReplayUrls: Array<Scalars['String']['output']>
  status: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type BrowserFlowStep = {
  __typename?: 'BrowserFlowStep'
  createdAt: Scalars['ISO8601DateTime']['output']
  flowExecutionType: Scalars['String']['output']
  id: Scalars['ID']['output']
  position: Scalars['Int']['output']
  rawJsCode?: Maybe<Scalars['String']['output']>
  referencedFlow?: Maybe<BrowserFlow>
  stepDescription?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum BrowserFlowType {
  Helper = 'HELPER',
  Login = 'LOGIN',
  TopLevel = 'TOP_LEVEL',
}

export type Business = {
  __typename?: 'Business'
  activeReleaseNoteLabels?: Maybe<Array<ReleaseNoteLabel>>
  allPendingChangeReasons?: Maybe<Array<Scalars['String']['output']>>
  appliedToAllTemplate?: Maybe<BusinessTemplate>
  appliedToAllVoice?: Maybe<BusinessVoice>
  autoApproveFeatureFlag?: Maybe<AutoApproveFeatureFlagEnum>
  autoApprovePrompt?: Maybe<Scalars['String']['output']>
  availableChatSources: Array<AnswerTypeEnum>
  availableChatSourcesAndCommitHistory: Array<AnswerTypeEnum>
  availableDocumentationSources: Array<AnswerTypeEnum>
  billingPlans: Array<BillingPlan>
  bitbucketConnected: Scalars['Boolean']['output']
  branchNamesAcceptedDocumentationReviewRunTextsInGithub: Array<Scalars['String']['output']>
  chatTemplate?: Maybe<BusinessTemplate>
  chatVoice?: Maybe<BusinessVoice>
  codeConnected: Scalars['Boolean']['output']
  codeIndexing: Scalars['Boolean']['output']
  confluenceConnected: Scalars['Boolean']['output']
  confluenceIndexing: Scalars['Boolean']['output']
  defaultChatSources: Array<AnswerTypeEnum>
  defaultDocumentationForExternalReleaseNoteApprovals?: Maybe<Documentation>
  disableManualReleaseNotesGeneration: Scalars['Boolean']['output']
  documentationCodeConnected: Scalars['Boolean']['output']
  documentationCodeIndexing: Scalars['Boolean']['output']
  documentationCssString?: Maybe<Scalars['String']['output']>
  documentationProjects: Array<DocumentationProject>
  documentationRepoNamePath?: Maybe<Scalars['String']['output']>
  enableAutoApproveDocumentation: Scalars['Boolean']['output']
  enableCoverageFeature: Scalars['Boolean']['output']
  enableExternalForReleaseNoteApprovals: Scalars['Boolean']['output']
  enableManualDocumentationAuditing: Scalars['Boolean']['output']
  externalDocumentationTemplate?: Maybe<BusinessTemplate>
  externalDocumentationVoice?: Maybe<BusinessVoice>
  featureFlagFullLink?: Maybe<Scalars['String']['output']>
  featurebaseCollections?: Maybe<Array<FeaturebaseExternalCollection>>
  featurebaseConnected: Scalars['Boolean']['output']
  frontConnected: Scalars['Boolean']['output']
  githubConnected: Scalars['Boolean']['output']
  gitlabConnected: Scalars['Boolean']['output']
  hasDocumentationStyleGuide: Scalars['Boolean']['output']
  hasSeenDemoScreen: Scalars['Boolean']['output']
  hasTranslatedDocumentation: Scalars['Boolean']['output']
  hideReleaseNoteItemHeaders: Scalars['Boolean']['output']
  hubspotConnected: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  imageFlowInstructions?: Maybe<Scalars['String']['output']>
  intercomConnected: Scalars['Boolean']['output']
  intercomIndexing: Scalars['Boolean']['output']
  jiraConnected: Scalars['Boolean']['output']
  launchdarklyConnected: Scalars['Boolean']['output']
  linearConnected: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  notionConnected: Scalars['Boolean']['output']
  notionIndexing: Scalars['Boolean']['output']
  paymentMethods?: Maybe<Array<PaymentMethod>>
  pendingDocumentationReviewRunTextsFeatureFlags: Array<Scalars['String']['output']>
  pendoConnected: Scalars['Boolean']['output']
  plan: SubscriptionPlanEnum
  releaseNoteLabels?: Maybe<Array<ReleaseNoteLabel>>
  releaseNotesTemplate?: Maybe<BusinessTemplate>
  releaseNotesVoice?: Maybe<BusinessVoice>
  screenStepsConnected: Scalars['Boolean']['output']
  showCodeSources: Scalars['Boolean']['output']
  showEnableBulkAcceptAllDocumentationReview: Scalars['Boolean']['output']
  showExpert: Scalars['Boolean']['output']
  showVerifyAnswer: Scalars['Boolean']['output']
  skipDocumentationFindingStepForTasks: Scalars['Boolean']['output']
  slackConnected: Scalars['Boolean']['output']
  succinctMode?: Maybe<Scalars['Boolean']['output']>
  testModeAutoApproveDocumentation: Scalars['Boolean']['output']
  users?: Maybe<Array<Users>>
  verifiedUsers?: Maybe<Array<Users>>
  zendeskConnected: Scalars['Boolean']['output']
  zendeskIndexing: Scalars['Boolean']['output']
}

export type BusinessTemplate = {
  __typename?: 'BusinessTemplate'
  applyToAll: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  template: Scalars['String']['output']
  templateType: TemplateTypeEnum
}

export type BusinessVoice = {
  __typename?: 'BusinessVoice'
  applyToAll: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  voice: Scalars['String']['output']
  voiceType: VoiceTypeEnum
}

/** Autogenerated return type of ChatAnswered. */
export type ChatAnsweredPayload = {
  __typename?: 'ChatAnsweredPayload'
  answer: Scalars['String']['output']
  answerId: Scalars['ID']['output']
  chatId: Scalars['ID']['output']
  sources?: Maybe<Array<Scalars['String']['output']>>
}

export type ChatConfiguration = {
  __typename?: 'ChatConfiguration'
  indexSlack: Scalars['Boolean']['output']
  showCodeSources: Scalars['Boolean']['output']
  showExpert: Scalars['Boolean']['output']
  showVerifyAnswer: Scalars['Boolean']['output']
  succinctMode?: Maybe<Scalars['Boolean']['output']>
}

/** Autogenerated return type of Chat. */
export type ChatPayload = {
  __typename?: 'ChatPayload'
  chatId: Scalars['ID']['output']
  content: Scalars['String']['output']
  final: Scalars['Boolean']['output']
  i?: Maybe<Scalars['Int']['output']>
  initial: Scalars['Boolean']['output']
  requestId: Scalars['String']['output']
}

export type Document = {
  __typename?: 'Document'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type Document360ExternalCollection = {
  __typename?: 'Document360ExternalCollection'
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  projectId?: Maybe<Scalars['String']['output']>
  projectName?: Maybe<Scalars['String']['output']>
  workspaceId?: Maybe<Scalars['String']['output']>
  workspaceName?: Maybe<Scalars['String']['output']>
}

export type Documentation = {
  __typename?: 'Documentation'
  activeDocumentationCommentAnchors: Array<DocumentationCommentAnchor>
  activeDocumentationProjects: Array<DocumentationProject>
  archivedInSolo: Scalars['Boolean']['output']
  authorName?: Maybe<Scalars['String']['output']>
  containsZendeskContentBlockTexts: Scalars['Boolean']['output']
  content?: Maybe<Scalars['String']['output']>
  contentLastCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  contentUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  documentationCssString?: Maybe<Scalars['String']['output']>
  documentationFilesJson: Array<DocumentationAttachment>
  documentationsToReview?: Maybe<Array<DocumentationToReview>>
  editUrl?: Maybe<Scalars['String']['output']>
  externalContent?: Maybe<Scalars['String']['output']>
  externalContentType?: Maybe<Scalars['String']['output']>
  externalCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  externalPageId?: Maybe<Scalars['String']['output']>
  findForOutOfDate: Scalars['Boolean']['output']
  hasContentEditedVersion: Scalars['Boolean']['output']
  hasDraft: Scalars['Boolean']['output']
  helpCenterName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  instruction?: Maybe<Scalars['String']['output']>
  isGeneratingContent: Scalars['Boolean']['output']
  isPublished: Scalars['Boolean']['output']
  isTranslated?: Maybe<Scalars['Boolean']['output']>
  lastUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  manuallyWrite: Scalars['Boolean']['output']
  needsReview: Scalars['Boolean']['output']
  numPendingDocumentationReviewRunTextsNotSnoozed: Scalars['Int']['output']
  pageCollections: Array<Scalars['String']['output']>
  parentCollectionName?: Maybe<Scalars['String']['output']>
  prUrl?: Maybe<Scalars['String']['output']>
  sections?: Maybe<Scalars['String']['output']>
  source: DocumentationsSourceEnum
  sourceType?: Maybe<DocumentationsSourceTypeEnum>
  topic: Scalars['String']['output']
  uniqueId?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

/** Autogenerated return type of DocumentationAttachedToProject. */
export type DocumentationAttachedToProjectPayload = {
  __typename?: 'DocumentationAttachedToProjectPayload'
  documentationProjectId: Scalars['ID']['output']
}

/** Autogenerated return type of DocumentationAttachedToReleaseNoteItem. */
export type DocumentationAttachedToReleaseNoteItemPayload = {
  __typename?: 'DocumentationAttachedToReleaseNoteItemPayload'
  relatedDocumentations: Array<Documentation>
  releaseNoteItemId: Scalars['ID']['output']
}

/** Autogenerated return type of DocumentationAttachedToTask. */
export type DocumentationAttachedToTaskPayload = {
  __typename?: 'DocumentationAttachedToTaskPayload'
  documentationTaskId: Scalars['ID']['output']
}

export type DocumentationAttachment = {
  __typename?: 'DocumentationAttachment'
  contentType: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type DocumentationComment = {
  __typename?: 'DocumentationComment'
  content: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  user: Users
}

export type DocumentationCommentAnchor = {
  __typename?: 'DocumentationCommentAnchor'
  documentation: Documentation
  documentationComments: Array<DocumentationComment>
  endOffset: Scalars['Int']['output']
  id: Scalars['ID']['output']
  originalText: Scalars['String']['output']
  orphaned: Scalars['Boolean']['output']
  prefixContext?: Maybe<Scalars['String']['output']>
  resolved: Scalars['Boolean']['output']
  startOffset: Scalars['Int']['output']
  suffixContext?: Maybe<Scalars['String']['output']>
}

/** Autogenerated return type of DocumentationContentUpdated. */
export type DocumentationContentUpdatedPayload = {
  __typename?: 'DocumentationContentUpdatedPayload'
  objId: Scalars['String']['output']
  responseAcknowledgingUsersInstruction: Scalars['String']['output']
  updatedDocumentationText: Scalars['String']['output']
}

/** Autogenerated return type of Documentation. */
export type DocumentationPayload = {
  __typename?: 'DocumentationPayload'
  objId: Scalars['String']['output']
}

export type DocumentationProject = {
  __typename?: 'DocumentationProject'
  createdAt: Scalars['ISO8601DateTime']['output']
  description?: Maybe<Scalars['String']['output']>
  documentationFilesJson: Array<DocumentationProjectAttachment>
  documentations: Array<Documentation>
  id: Scalars['ID']['output']
  knowledgeBaseAudit: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  numDocumentation: Scalars['Int']['output']
  numPendingDocumentationReviewRunTexts: Scalars['Int']['output']
  projectLinks: Array<Scalars['String']['output']>
  status: DocumentationProjectStatusType
  user: Users
}

export type DocumentationProjectAttachment = {
  __typename?: 'DocumentationProjectAttachment'
  contentType: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  url: Scalars['String']['output']
}

export enum DocumentationProjectStatusType {
  CodingStarted = 'CODING_STARTED',
  Completed = 'COMPLETED',
  Started = 'STARTED',
}

export enum DocumentationSortByEnum {
  HasDraft = 'HAS_DRAFT',
  IsTranslated = 'IS_TRANSLATED',
  LastUpdatedAt = 'LAST_UPDATED_AT',
}

export type DocumentationTask = {
  __typename?: 'DocumentationTask'
  createdAt: Scalars['ISO8601DateTime']['output']
  description?: Maybe<Scalars['String']['output']>
  documentationTaskFilesJson: Array<DocumentationTaskAttachment>
  documentationTaskSummaries: Array<DocumentationTaskSummary>
  documentations: Array<Documentation>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  numAllDocumentationReviewRunTexts: Scalars['Int']['output']
  numPendingDocumentationReviewRunTexts: Scalars['Int']['output']
  pullFromCodebase: Scalars['Boolean']['output']
  status: DocumentationTaskStatusType
  taskLinks: Array<Scalars['String']['output']>
  user?: Maybe<Users>
}

export type DocumentationTaskAttachment = {
  __typename?: 'DocumentationTaskAttachment'
  contentType: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  url: Scalars['String']['output']
}

export enum DocumentationTaskStatusType {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Started = 'STARTED',
}

export type DocumentationTaskSummary = {
  __typename?: 'DocumentationTaskSummary'
  documentation: Documentation
  id: Scalars['ID']['output']
  numPendingDocumentationReviewRunTexts: Scalars['Int']['output']
  summary: Scalars['String']['output']
}

export type DocumentationToReview = {
  __typename?: 'DocumentationToReview'
  allImageVersions?: Maybe<Array<AllImageVersion>>
  assignee?: Maybe<Users>
  autoApproveConditionsMet?: Maybe<Array<Scalars['String']['output']>>
  autoApproveConditionsNotMet?: Maybe<Array<Scalars['String']['output']>>
  autoApproveFeatureFlagStatus?: Maybe<Scalars['String']['output']>
  blockLink: Scalars['String']['output']
  browserFlow?: Maybe<BrowserFlow>
  createdAt: Scalars['ISO8601DateTime']['output']
  didFindBlocks: Scalars['Boolean']['output']
  didFindBlocksPublished: Scalars['Boolean']['output']
  disableImageRecording: Scalars['Boolean']['output']
  documentation: Documentation
  documentationProjects: Array<DocumentationProject>
  documentationReviewComments?: Maybe<Array<DocumentationToReviewComment>>
  documentationTask?: Maybe<DocumentationTask>
  eligibleForAutoApprove: Scalars['Boolean']['output']
  externalCustomerConversation?: Maybe<ExternalCustomerConversation>
  externalTaskIssues: Array<ExternalTaskIssue>
  featureFlags?: Maybe<Array<Scalars['String']['output']>>
  githubPrUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isAccepting: Scalars['Boolean']['output']
  isAutoApproved: Scalars['Boolean']['output']
  isSnoozed: Scalars['Boolean']['output']
  labels: Array<ReleaseNoteLabel>
  linkedExternalTaskIssues: Array<ExternalTaskIssue>
  newDocumentationMarkdownText?: Maybe<Scalars['String']['output']>
  oldDocumentationMarkdownText?: Maybe<Scalars['String']['output']>
  previewText?: Maybe<Scalars['String']['output']>
  rejectionReason?: Maybe<Scalars['String']['output']>
  reviewType: DocumentationToReviewReviewType
  showMobileReleaseUx: Scalars['Boolean']['output']
  sourceLinkAuthors?: Maybe<Array<Scalars['String']['output']>>
  sourceLinkCommitMessages?: Maybe<Array<Scalars['String']['output']>>
  sourceLinkDates?: Maybe<Array<Maybe<Scalars['ISO8601DateTime']['output']>>>
  sourceLinks?: Maybe<Array<Scalars['String']['output']>>
  status: DocumentationToReviewStatusEnum
  suggestionReason?: Maybe<Scalars['String']['output']>
  suggestionType: DocumentationToReviewSuggestionType
  summarizedChange?: Maybe<Scalars['String']['output']>
  userActivity?: Maybe<UserActivity>
}

export type DocumentationToReviewComment = {
  __typename?: 'DocumentationToReviewComment'
  comment: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  user: Users
}

export enum DocumentationToReviewReviewType {
  CodeChanged = 'CODE_CHANGED',
  CustomerConversation = 'CUSTOMER_CONVERSATION',
  Task = 'TASK',
}

export enum DocumentationToReviewStatusEnum {
  Approved = 'APPROVED',
  Outdated = 'OUTDATED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export enum DocumentationToReviewSuggestionType {
  ImgTagPotentiallyOutdated = 'IMG_TAG_POTENTIALLY_OUTDATED',
  TextUpdate = 'TEXT_UPDATE',
}

export type DocumentationVersion = {
  __typename?: 'DocumentationVersion'
  content: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  user?: Maybe<Users>
}

export enum DocumentationsSourceEnum {
  Created = 'CREATED',
  Imported = 'IMPORTED',
}

export enum DocumentationsSourceTypeEnum {
  Confluence = 'CONFLUENCE',
  Document360 = 'DOCUMENT360',
  Featurebase = 'FEATUREBASE',
  Front = 'FRONT',
  GithubDocs = 'GITHUB_DOCS',
  HelpScout = 'HELP_SCOUT',
  Hubspot = 'HUBSPOT',
  Intercom = 'INTERCOM',
  Notion = 'NOTION',
  Pylon = 'PYLON',
  ScreenSteps = 'SCREEN_STEPS',
  Teamsupport = 'TEAMSUPPORT',
  Zendesk = 'ZENDESK',
}

export type ExternalCustomerConversation = {
  __typename?: 'ExternalCustomerConversation'
  conversationCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  externalCustomerQuestion: ExternalCustomerQuestion
  externalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  sourceType: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type ExternalCustomerQuestion = {
  __typename?: 'ExternalCustomerQuestion'
  externalCustomerConversation: ExternalCustomerConversation
  id: Scalars['ID']['output']
  summarizedAnswer?: Maybe<Scalars['String']['output']>
  summarizedQuestion?: Maybe<Scalars['String']['output']>
}

export type ExternalIntegration = {
  __typename?: 'ExternalIntegration'
  externalBusinessId: Scalars['String']['output']
  externalBusinessName: Scalars['String']['output']
  externalIntegrationType: Scalars['String']['output']
  id: Scalars['ID']['output']
  slackChannelConfigurations: Array<SlackConfiguration>
}

export type ExternalSlack = {
  __typename?: 'ExternalSlack'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type ExternalSubtopic = {
  __typename?: 'ExternalSubtopic'
  archived: Scalars['Boolean']['output']
  documentation?: Maybe<Documentation>
  id: Scalars['ID']['output']
  subtopic: Scalars['String']['output']
  topic: Scalars['String']['output']
}

export type ExternalTaskIssue = {
  __typename?: 'ExternalTaskIssue'
  externalIdentifier: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  sourceType: ExternalTaskIssueSourceTypeEnum
  url: Scalars['String']['output']
}

export enum ExternalTaskIssueSourceTypeEnum {
  Jira = 'JIRA',
  Linear = 'LINEAR',
}

export type ExternalTopic = {
  __typename?: 'ExternalTopic'
  archived: Scalars['Boolean']['output']
  documentation?: Maybe<Documentation>
  id: Scalars['ID']['output']
  topic: Scalars['String']['output']
}

export enum FeatureFlagStatus {
  FullyOn = 'FULLY_ON',
  NotFullyOn = 'NOT_FULLY_ON',
  PartiallyOn = 'PARTIALLY_ON',
}

export type FeatureFlagsInfo = {
  __typename?: 'FeatureFlagsInfo'
  fullyOnFeatureFlags: Array<Scalars['String']['output']>
  notFullyOnFeatureFlags: Array<Scalars['String']['output']>
  partiallyOnFeatureFlags: Array<Scalars['String']['output']>
}

export type FeaturebaseExternalCollection = {
  __typename?: 'FeaturebaseExternalCollection'
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type FrontExternalCategory = {
  __typename?: 'FrontExternalCategory'
  id?: Maybe<Scalars['String']['output']>
  knowledgeBaseName?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type HelpScoutExternalCollection = {
  __typename?: 'HelpScoutExternalCollection'
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  siteName?: Maybe<Scalars['String']['output']>
}

export type HubspotExternalCollection = {
  __typename?: 'HubspotExternalCollection'
  id?: Maybe<Scalars['String']['output']>
  knowledgeBaseId?: Maybe<Scalars['String']['output']>
  language?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  parentCategoryId?: Maybe<Scalars['String']['output']>
  parentCategoryName?: Maybe<Scalars['String']['output']>
}

export type ImageFlow = {
  __typename?: 'ImageFlow'
  browserFlow: BrowserFlow
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  imageSource: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type IntercomExternalCollection = {
  __typename?: 'IntercomExternalCollection'
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type MarkdownTextLabel = {
  __typename?: 'MarkdownTextLabel'
  labelName: Scalars['String']['output']
  labelText: Scalars['String']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  acceptAllDocumentationReviewForDocumentation: Documentation
  acceptDocumentationReview: Documentation
  acceptDocumentationReviewSlack?: Maybe<Documentation>
  acceptNewContentDocumentation: Documentation
  addBrowserFlowStep: BrowserFlowStep
  addCommentToDocumentationReview: Documentation
  addCommentToExistingAnchor: DocumentationCommentAnchor
  addCommentToReleaseNoteItem: TypedReleaseNote
  addNewContentToDocumentation: Documentation
  answerQuestion?: Maybe<Scalars['String']['output']>
  approveReleaseNote: TypedReleaseNote
  archiveDocument: Document
  archiveDocumentationProject: Scalars['String']['output']
  archiveDocumentationTask: DocumentationTask
  archiveInSolo: Documentation
  archiveOpportunityTheme: Scalars['String']['output']
  authPasswordResetRequest: Scalars['String']['output']
  authProviderAuthenticate: AuthResponse
  authResetPassword: Scalars['String']['output']
  authSignIn: AuthResponse
  authSignUp: AuthResponse
  beginPendoMcpIntegration: Scalars['String']['output']
  billingPortalUrl: Scalars['String']['output']
  bulkAcceptAllDocumentationReview: Scalars['String']['output']
  cancelDocumentationDraft: Documentation
  correctAnswerFeedback: Scalars['String']['output']
  createBitbucketExternalIntegration: ExternalIntegration
  createBrowserFlow: BrowserFlow
  createConfluenceExternalIntegration: ExternalIntegration
  createDocumentation: Documentation
  createDocumentationAnchorAndAddComment: DocumentationCommentAnchor
  createDocumentationProject: DocumentationProject
  createDocumentationTask: DocumentationTask
  createDocumentationTaskFromSlackThread?: Maybe<DocumentationTask>
  createExternalIntegration: ExternalIntegration
  createFrontExternalIntegration: ExternalIntegration
  createGithubDocsExternalIntegration?: Maybe<ExternalIntegration>
  createGithubExternalIntegration?: Maybe<ExternalIntegration>
  createGitlabExternalIntegration: ExternalIntegration
  createHubspotExternalIntegration: ExternalIntegration
  createIntercomExternalIntegration: ExternalIntegration
  createJiraExternalIntegration: ExternalIntegration
  createLaunchdarklyExternalIntegration: ExternalIntegration
  createLinearExternalIntegration: ExternalIntegration
  createNotionExternalIntegration: ExternalIntegration
  createPendoMcpIntegration: Business
  createReleaseNoteLabel: Array<ReleaseNoteLabel>
  createRepository: Repository
  createSlackChannelConfiguration: SlackConfiguration
  createZendeskExternalIntegration: ExternalIntegration
  deleteReleaseNoteItem: TypedReleaseNote
  deleteReleaseNoteItems: TypedReleaseNote
  deleteReleaseNoteLabel: ReleaseNoteLabel
  disconnectSlackExternalIntegration: Scalars['String']['output']
  editDocumentationReview: Documentation
  excludeImageDocumentationReview: Documentation
  exportReleaseNotesToCsv?: Maybe<Scalars['String']['output']>
  exportToCsv?: Maybe<Scalars['String']['output']>
  fetchExistingRecentQuestion?: Maybe<Answer>
  findDocumentationForProjects: Scalars['String']['output']
  findDocumentationForReleaseNoteItem?: Maybe<Scalars['String']['output']>
  findDocumentationForTask: Scalars['String']['output']
  generateDocumentation: Documentation
  generateTypedReleaseNote: TypedReleaseNote
  getDocumentationRepoImage: Scalars['String']['output']
  getExpert?: Maybe<Array<Scalars['String']['output']>>
  hasSeenDemoScreen: Business
  includeImageDocumentationReview: Documentation
  incorrectAnswerFeedback?: Maybe<Scalars['String']['output']>
  incorrectInChat?: Maybe<Scalars['String']['output']>
  intercomManualSync: Scalars['String']['output']
  linkDocumentationReviewToExistingExternalTaskIssues: Documentation
  linkDocumentationReviewToNewExternalTaskIssue: Documentation
  manuallyAddReleaseNoteItem: TypedReleaseNoteItem
  manuallyCreateTypedReleaseNote: TypedReleaseNote
  markForFindForOutOfDateDocumentation: Documentation
  markOutdatedDocumentationReview: Documentation
  markOutdatedDocumentationReviewForDocumentation: Documentation
  markOutdatedDocumentationReviewSlack?: Maybe<Documentation>
  markReadUsersActivities: Scalars['Boolean']['output']
  patchDocumentation: Documentation
  paymentsCollect: Scalars['String']['output']
  publishDocumentation: Documentation
  publishDocumentationDraft: Documentation
  publishReleaseNoteExternally: Documentation
  rejectAllDocumentationReviewForDocumentation: Documentation
  rejectDocumentationReview: Documentation
  rejectDocumentationReviewSlack?: Maybe<Documentation>
  releaseNoteItemAskQuestion: TypedReleaseNote
  removeDocumentationFile: Documentation
  removeReleaseNoteItemAttachment: TypedReleaseNote
  reorderReleaseNoteItems: Scalars['String']['output']
  reorderReleaseNoteLabels: Array<ReleaseNoteLabel>
  rephraseContentDocumentation: Documentation
  replaceDocumentationReviewImage: Documentation
  resolveCommentAnchor: DocumentationCommentAnchor
  resolveExternallyOpportunityTheme: Scalars['String']['output']
  runBrowserFlow: BrowserFlow
  slackIndexEntireChannel?: Maybe<Scalars['String']['output']>
  slackIndexMessage?: Maybe<Scalars['String']['output']>
  slackQuestion?: Maybe<Answer>
  snoozeDocumentationReview: Documentation
  snoozeReleaseNoteItem: TypedReleaseNote
  unmarkForFindForOutOfDateDocumentation: Documentation
  unsnoozeDocumentationReview: Documentation
  updateAssigneeDocumentationReview: Documentation
  updateAssigneeReleaseNoteLabels: ReleaseNoteLabel
  updateBusiness: Business
  updateDocumentation: Documentation
  updateDocumentationContent: Documentation
  updateDocumentationManuallyAndRunTask: DocumentationTask
  updateDocumentationManuallyForProject: DocumentationProject
  updateDocumentationProject: DocumentationProject
  updateDocumentationRepo: Scalars['String']['output']
  updateDocumentationTask: DocumentationTask
  updateHiddenDraftContent: Documentation
  updateHtmlText: TypedReleaseNote
  updateLabelsDocumentationReview: Documentation
  updateMessageExternalId?: Maybe<Answer>
  updateReleaseNoteItem: TypedReleaseNoteItem
  updateReleaseNoteLabel: ReleaseNoteLabel
  updateRepository: Scalars['String']['output']
  updateSlackChannelConfiguration: SlackConfiguration
  updateTypedReleaseNote: TypedReleaseNote
  updateUser: Users
  updateZendeskSubdomain: Business
  uploadDocument: Document
  uploadDocumentationFiles: Documentation
  uploadImagesAndVideo: TypedReleaseNote
  upsertImageFlowWithCode: ImageFlow
  upsertLoginFlowWithCode: BrowserFlow
  upsertReleaseNoteSchedule: ReleaseNoteSchedule
  userChangeRole?: Maybe<Users>
  userEmailVerify: AuthResponse
  userExchangeGoogleOauthCode: AuthResponse
  userInvite?: Maybe<Users>
  userRemove?: Maybe<Scalars['Boolean']['output']>
  zendeskManualSync: Scalars['String']['output']
}

export type MutationAcceptAllDocumentationReviewForDocumentationArgs = {
  applyToDraft?: InputMaybe<Scalars['Boolean']['input']>
  branchName?: InputMaybe<Scalars['String']['input']>
  documentationId: Scalars['ID']['input']
  documentationReviewRunTextIds: Array<Scalars['ID']['input']>
}

export type MutationAcceptDocumentationReviewArgs = {
  applyToDraft?: InputMaybe<Scalars['Boolean']['input']>
  branchName?: InputMaybe<Scalars['String']['input']>
  documentationReviewRunTextId: Scalars['ID']['input']
}

export type MutationAcceptDocumentationReviewSlackArgs = {
  applyToDraft?: InputMaybe<Scalars['Boolean']['input']>
  branchName?: InputMaybe<Scalars['String']['input']>
  channelId?: InputMaybe<Scalars['String']['input']>
  documentationReviewRunTextId: Scalars['ID']['input']
  externalBusinessId: Scalars['ID']['input']
  externalUserId?: InputMaybe<Scalars['String']['input']>
  messageThreadId?: InputMaybe<Scalars['String']['input']>
}

export type MutationAcceptNewContentDocumentationArgs = {
  documentationId: Scalars['ID']['input']
  updatedDocumentationText: Scalars['String']['input']
}

export type MutationAddBrowserFlowStepArgs = {
  browserFlowId: Scalars['ID']['input']
  rawJsCode: Scalars['String']['input']
}

export type MutationAddCommentToDocumentationReviewArgs = {
  comment: Scalars['String']['input']
  documentationReviewRunTextId: Scalars['ID']['input']
}

export type MutationAddCommentToExistingAnchorArgs = {
  comment: Scalars['String']['input']
  documentationCommentAnchorId: Scalars['ID']['input']
  documentationId: Scalars['ID']['input']
}

export type MutationAddCommentToReleaseNoteItemArgs = {
  comment: Scalars['String']['input']
  releaseNoteItemId: Scalars['ID']['input']
}

export type MutationAddNewContentToDocumentationArgs = {
  documentationId: Scalars['ID']['input']
  instruction: Scalars['String']['input']
}

export type MutationAnswerQuestionArgs = {
  answerTypes?: InputMaybe<Array<AnswerTypeEnum>>
  chatId: Scalars['String']['input']
  question: Scalars['String']['input']
  useStyleGuideAsContext?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationApproveReleaseNoteArgs = {
  forcePublish?: InputMaybe<Scalars['Boolean']['input']>
  typedReleaseNoteId: Scalars['ID']['input']
}

export type MutationArchiveDocumentArgs = {
  documentId: Scalars['ID']['input']
}

export type MutationArchiveDocumentationProjectArgs = {
  id: Scalars['ID']['input']
}

export type MutationArchiveDocumentationTaskArgs = {
  id: Scalars['ID']['input']
}

export type MutationArchiveInSoloArgs = {
  documentationId: Scalars['ID']['input']
}

export type MutationArchiveOpportunityThemeArgs = {
  id: Scalars['ID']['input']
}

export type MutationAuthPasswordResetRequestArgs = {
  email: Scalars['String']['input']
}

export type MutationAuthProviderAuthenticateArgs = {
  data: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  provider: AuthProviderTypeEnum
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationAuthResetPasswordArgs = {
  newPassword: Scalars['String']['input']
  resetPasswordToken: Scalars['String']['input']
}

export type MutationAuthSignInArgs = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type MutationAuthSignUpArgs = {
  email: Scalars['String']['input']
  emailVerifyFromUrl?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationBulkAcceptAllDocumentationReviewArgs = {
  branchName?: InputMaybe<Scalars['String']['input']>
}

export type MutationCancelDocumentationDraftArgs = {
  documentationId: Scalars['ID']['input']
}

export type MutationCorrectAnswerFeedbackArgs = {
  externalBusinessId: Scalars['ID']['input']
  externalUserId?: InputMaybe<Scalars['ID']['input']>
  messageExternalId: Scalars['ID']['input']
}

export type MutationCreateBitbucketExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationCreateBrowserFlowArgs = {
  flowType: BrowserFlowType
}

export type MutationCreateConfluenceExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationCreateDocumentationArgs = {
  instruction?: InputMaybe<Scalars['String']['input']>
  manuallyWrite?: InputMaybe<Scalars['Boolean']['input']>
  repoNames?: InputMaybe<Array<Scalars['String']['input']>>
  sections?: InputMaybe<Scalars['String']['input']>
  topic: Scalars['String']['input']
  uploadSignedIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationCreateDocumentationAnchorAndAddCommentArgs = {
  comment: Scalars['String']['input']
  documentationId: Scalars['ID']['input']
  endOffset: Scalars['Int']['input']
  startOffset: Scalars['Int']['input']
}

export type MutationCreateDocumentationProjectArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  knowledgeBaseAudit?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  projectLinks?: InputMaybe<Array<Scalars['String']['input']>>
  uploadSignedIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationCreateDocumentationTaskArgs = {
  description?: InputMaybe<Scalars['String']['input']>
  documentationId?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  pullFromCodebase?: InputMaybe<Scalars['Boolean']['input']>
  releaseNoteItemId?: InputMaybe<Scalars['ID']['input']>
  taskLinks?: InputMaybe<Array<Scalars['String']['input']>>
  uploadSignedIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type MutationCreateDocumentationTaskFromSlackThreadArgs = {
  externalBusinessId: Scalars['ID']['input']
  externalChannelId: Scalars['ID']['input']
  externalUserId: Scalars['ID']['input']
  messageExternalId: Scalars['ID']['input']
  taskDescription?: InputMaybe<Scalars['String']['input']>
  taskName?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationCreateFrontExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationCreateGithubDocsExternalIntegrationArgs = {
  code: Scalars['String']['input']
  installationId?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateGithubExternalIntegrationArgs = {
  code: Scalars['String']['input']
  installationId?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateGitlabExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationCreateHubspotExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationCreateIntercomExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationCreateJiraExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationCreateLaunchdarklyExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationCreateLinearExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationCreateNotionExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationCreatePendoMcpIntegrationArgs = {
  code: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type MutationCreateReleaseNoteLabelArgs = {
  releaseNoteLabels?: InputMaybe<Array<ReleaseNoteLabelInputObject>>
}

export type MutationCreateRepositoryArgs = {
  accessToken: Scalars['String']['input']
  branchName: Scalars['String']['input']
  repoName: Scalars['String']['input']
}

export type MutationCreateSlackChannelConfigurationArgs = {
  channelId: Scalars['String']['input']
  channelName: Scalars['String']['input']
  chatSources?: InputMaybe<Array<AnswerTypeEnum>>
  externalIntegrationId: Scalars['ID']['input']
  repoNames: Array<Scalars['String']['input']>
  showCodeSources: Scalars['Boolean']['input']
  showExpert: Scalars['Boolean']['input']
  showVerifyAnswer: Scalars['Boolean']['input']
  succinctMode: Scalars['Boolean']['input']
}

export type MutationCreateZendeskExternalIntegrationArgs = {
  code: Scalars['String']['input']
}

export type MutationDeleteReleaseNoteItemArgs = {
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemId: Scalars['ID']['input']
}

export type MutationDeleteReleaseNoteItemsArgs = {
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemIds: Array<Scalars['ID']['input']>
}

export type MutationDeleteReleaseNoteLabelArgs = {
  id: Scalars['ID']['input']
}

export type MutationDisconnectSlackExternalIntegrationArgs = {
  externalIntegrationId: Scalars['ID']['input']
}

export type MutationEditDocumentationReviewArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
  newDocumentationMarkdownText: Scalars['String']['input']
}

export type MutationExcludeImageDocumentationReviewArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
}

export type MutationExportReleaseNotesToCsvArgs = {
  typedReleaseNoteId: Scalars['ID']['input']
}

export type MutationExportToCsvArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type MutationFetchExistingRecentQuestionArgs = {
  externalBusinessId: Scalars['ID']['input']
  externalChannelId?: InputMaybe<Scalars['String']['input']>
  messageThreadExternalId?: InputMaybe<Scalars['ID']['input']>
  questionTs: Scalars['ID']['input']
}

export type MutationFindDocumentationForProjectsArgs = {
  id: Scalars['ID']['input']
}

export type MutationFindDocumentationForReleaseNoteItemArgs = {
  releaseNoteItemId: Scalars['ID']['input']
}

export type MutationFindDocumentationForTaskArgs = {
  id: Scalars['ID']['input']
}

export type MutationGenerateDocumentationArgs = {
  documentationId: Scalars['ID']['input']
  regenerating?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationGenerateTypedReleaseNoteArgs = {
  typedReleaseNoteId: Scalars['ID']['input']
}

export type MutationGetDocumentationRepoImageArgs = {
  imagePath: Scalars['String']['input']
}

export type MutationGetExpertArgs = {
  externalBusinessId: Scalars['ID']['input']
  messageExternalId: Scalars['ID']['input']
}

export type MutationIncludeImageDocumentationReviewArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
}

export type MutationIncorrectAnswerFeedbackArgs = {
  correctedAnswer?: InputMaybe<Scalars['String']['input']>
  externalBusinessId: Scalars['ID']['input']
  externalUserId?: InputMaybe<Scalars['ID']['input']>
  messageExternalId: Scalars['ID']['input']
  whyIncorrect?: InputMaybe<Scalars['String']['input']>
}

export type MutationIncorrectInChatArgs = {
  answerId: Scalars['ID']['input']
}

export type MutationLinkDocumentationReviewToExistingExternalTaskIssuesArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
  externalTaskIssueIds: Array<Scalars['ID']['input']>
}

export type MutationLinkDocumentationReviewToNewExternalTaskIssueArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
}

export type MutationManuallyAddReleaseNoteItemArgs = {
  releaseNoteId: Scalars['ID']['input']
}

export type MutationManuallyCreateTypedReleaseNoteArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  repoNames?: InputMaybe<Array<Scalars['String']['input']>>
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type MutationMarkForFindForOutOfDateDocumentationArgs = {
  documentationId: Scalars['ID']['input']
}

export type MutationMarkOutdatedDocumentationReviewArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
}

export type MutationMarkOutdatedDocumentationReviewForDocumentationArgs = {
  documentationId: Scalars['ID']['input']
  documentationReviewRunTextIds: Array<Scalars['ID']['input']>
}

export type MutationMarkOutdatedDocumentationReviewSlackArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
  externalBusinessId: Scalars['ID']['input']
  externalUserId?: InputMaybe<Scalars['String']['input']>
}

export type MutationPatchDocumentationArgs = {
  documentationId: Scalars['ID']['input']
}

export type MutationPublishDocumentationArgs = {
  documentationId: Scalars['ID']['input']
  documentationSource: AnswerTypeEnum
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']>>
  parentPageId: Scalars['String']['input']
  relatedArticleIds?: InputMaybe<Array<Scalars['String']['input']>>
  slug?: InputMaybe<Scalars['String']['input']>
}

export type MutationPublishDocumentationDraftArgs = {
  branchName?: InputMaybe<Scalars['String']['input']>
  documentationId: Scalars['ID']['input']
}

export type MutationPublishReleaseNoteExternallyArgs = {
  documentationId: Scalars['ID']['input']
  typedReleaseNoteId: Scalars['ID']['input']
}

export type MutationRejectAllDocumentationReviewForDocumentationArgs = {
  documentationId: Scalars['ID']['input']
  documentationReviewRunTextIds: Array<Scalars['ID']['input']>
}

export type MutationRejectDocumentationReviewArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
  rejectionReason?: InputMaybe<Scalars['String']['input']>
}

export type MutationRejectDocumentationReviewSlackArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
  externalBusinessId: Scalars['ID']['input']
  externalUserId?: InputMaybe<Scalars['String']['input']>
  rejectionReason?: InputMaybe<Scalars['String']['input']>
}

export type MutationReleaseNoteItemAskQuestionArgs = {
  previousMessages?: InputMaybe<Array<Scalars['String']['input']>>
  question: Scalars['String']['input']
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemId: Scalars['ID']['input']
}

export type MutationRemoveDocumentationFileArgs = {
  documentationId: Scalars['ID']['input']
  fileId: Scalars['ID']['input']
}

export type MutationRemoveReleaseNoteItemAttachmentArgs = {
  attachmentId: Scalars['ID']['input']
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemId: Scalars['ID']['input']
}

export type MutationReorderReleaseNoteItemsArgs = {
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemPositionInputs: Array<ReleaseNoteItemPositionInputObject>
}

export type MutationReorderReleaseNoteLabelsArgs = {
  releaseNoteLabelIds: Array<Scalars['ID']['input']>
}

export type MutationRephraseContentDocumentationArgs = {
  documentationId: Scalars['ID']['input']
  instruction: Scalars['String']['input']
}

export type MutationReplaceDocumentationReviewImageArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
  uploadSignedId: Scalars['ID']['input']
}

export type MutationResolveCommentAnchorArgs = {
  documentationCommentAnchorId: Scalars['ID']['input']
  documentationId: Scalars['ID']['input']
}

export type MutationResolveExternallyOpportunityThemeArgs = {
  id: Scalars['ID']['input']
}

export type MutationRunBrowserFlowArgs = {
  browserFlowId: Scalars['ID']['input']
}

export type MutationSlackIndexEntireChannelArgs = {
  channelId: Scalars['String']['input']
  externalBusinessId: Scalars['ID']['input']
}

export type MutationSlackIndexMessageArgs = {
  channelId: Scalars['String']['input']
  externalBusinessId: Scalars['ID']['input']
  messageExternalId: Scalars['String']['input']
}

export type MutationSlackQuestionArgs = {
  externalBusinessId: Scalars['ID']['input']
  externalChannelId?: InputMaybe<Scalars['String']['input']>
  externalUserId?: InputMaybe<Scalars['String']['input']>
  externalUserName?: InputMaybe<Scalars['String']['input']>
  isDirectMessage?: InputMaybe<Scalars['Boolean']['input']>
  messageThreadExternalId?: InputMaybe<Scalars['ID']['input']>
  previousMessages?: InputMaybe<Array<Scalars['String']['input']>>
  queryBase64Images?: InputMaybe<Array<Scalars['String']['input']>>
  questionTs: Scalars['ID']['input']
  succinctMode?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSnoozeDocumentationReviewArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
  snoozeUntilDate: Scalars['ISO8601DateTime']['input']
  snoozeUntilFlagChange?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationSnoozeReleaseNoteItemArgs = {
  releaseNoteItemId: Scalars['ID']['input']
  snoozeType: TypedReleaseNoteSnoozeTypeEnum
  snoozeUntilDate: Scalars['ISO8601DateTime']['input']
}

export type MutationUnmarkForFindForOutOfDateDocumentationArgs = {
  documentationId: Scalars['ID']['input']
}

export type MutationUnsnoozeDocumentationReviewArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
}

export type MutationUpdateAssigneeDocumentationReviewArgs = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>
  documentationReviewRunTextId: Scalars['ID']['input']
}

export type MutationUpdateAssigneeReleaseNoteLabelsArgs = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>
  releaseNoteLabelId: Scalars['ID']['input']
}

export type MutationUpdateBusinessArgs = {
  autoApproveFeatureFlag?: InputMaybe<AutoApproveFeatureFlagEnum>
  autoApprovePrompt?: InputMaybe<Scalars['String']['input']>
  enableAutoApproveDocumentation?: InputMaybe<Scalars['Boolean']['input']>
  externalDocumentationTemplate?: InputMaybe<Scalars['String']['input']>
  externalDocumentationVoice?: InputMaybe<Scalars['String']['input']>
  imageFlowInstructions?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  releaseNotesTemplate?: InputMaybe<Scalars['String']['input']>
  releaseNotesVoice?: InputMaybe<Scalars['String']['input']>
  showCodeSources?: InputMaybe<Scalars['Boolean']['input']>
  showExpert?: InputMaybe<Scalars['Boolean']['input']>
  showVerifyAnswer?: InputMaybe<Scalars['Boolean']['input']>
  succinctMode?: InputMaybe<Scalars['Boolean']['input']>
  testModeAutoApproveDocumentation?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationUpdateDocumentationArgs = {
  documentationId: Scalars['ID']['input']
  instruction?: InputMaybe<Scalars['String']['input']>
  sections?: InputMaybe<Scalars['String']['input']>
  topic?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdateDocumentationContentArgs = {
  content: Scalars['String']['input']
  documentationId: Scalars['ID']['input']
}

export type MutationUpdateDocumentationManuallyAndRunTaskArgs = {
  documentationIds: Array<Scalars['ID']['input']>
  id: Scalars['ID']['input']
  rerunTask?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationUpdateDocumentationManuallyForProjectArgs = {
  documentationIds: Array<Scalars['ID']['input']>
  id: Scalars['ID']['input']
}

export type MutationUpdateDocumentationProjectArgs = {
  description: Scalars['String']['input']
  existingBlobIds: Array<Scalars['ID']['input']>
  id: Scalars['ID']['input']
  knowledgeBaseAudit?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  projectLinks: Array<Scalars['String']['input']>
  uploadSignedIds: Array<Scalars['ID']['input']>
}

export type MutationUpdateDocumentationRepoArgs = {
  attributes: Array<RepositoryInputObject>
}

export type MutationUpdateDocumentationTaskArgs = {
  description: Scalars['String']['input']
  documentationId?: InputMaybe<Scalars['ID']['input']>
  existingBlobIds: Array<Scalars['ID']['input']>
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  pullFromCodebase?: InputMaybe<Scalars['Boolean']['input']>
  taskLinks: Array<Scalars['String']['input']>
  uploadSignedIds: Array<Scalars['ID']['input']>
}

export type MutationUpdateHiddenDraftContentArgs = {
  documentationId: Scalars['ID']['input']
  hiddenDraftContent: Scalars['String']['input']
}

export type MutationUpdateHtmlTextArgs = {
  htmlText: Scalars['String']['input']
  typedReleaseNoteId: Scalars['ID']['input']
}

export type MutationUpdateLabelsDocumentationReviewArgs = {
  documentationReviewRunTextId: Scalars['ID']['input']
  labelIds: Array<Scalars['ID']['input']>
}

export type MutationUpdateMessageExternalIdArgs = {
  answerId: Scalars['ID']['input']
  externalBusinessId: Scalars['ID']['input']
  messageExternalId: Scalars['ID']['input']
}

export type MutationUpdateReleaseNoteItemArgs = {
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemInput: ReleaseNoteItemInputObject
}

export type MutationUpdateReleaseNoteLabelArgs = {
  description: Scalars['String']['input']
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type MutationUpdateRepositoryArgs = {
  attributes: Array<RepositoryInputObject>
}

export type MutationUpdateSlackChannelConfigurationArgs = {
  channelId: Scalars['String']['input']
  channelName: Scalars['String']['input']
  repoNames: Array<Scalars['String']['input']>
  slackChannelConfigurationId: Scalars['ID']['input']
}

export type MutationUpdateTypedReleaseNoteArgs = {
  typedReleaseNoteInput: TypedReleaseNoteInputObject
}

export type MutationUpdateUserArgs = {
  attributes: UsersInputObject
}

export type MutationUpdateZendeskSubdomainArgs = {
  zendeskSubdomain: Scalars['String']['input']
}

export type MutationUploadDocumentArgs = {
  name: Scalars['String']['input']
  uploadSignedId: Scalars['ID']['input']
}

export type MutationUploadDocumentationFilesArgs = {
  documentationId: Scalars['ID']['input']
  uploadSignedId: Scalars['ID']['input']
}

export type MutationUploadImagesAndVideoArgs = {
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemId: Scalars['ID']['input']
  uploadSignedId: Scalars['ID']['input']
}

export type MutationUpsertImageFlowWithCodeArgs = {
  imageFlowId?: InputMaybe<Scalars['ID']['input']>
  imageSource: Scalars['String']['input']
  loginBrowserFlowId?: InputMaybe<Scalars['ID']['input']>
  rawJsCode?: InputMaybe<Scalars['String']['input']>
  startUrl?: InputMaybe<Scalars['String']['input']>
  stepDescription?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpsertLoginFlowWithCodeArgs = {
  browserFlowId?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  rawJsCode?: InputMaybe<Scalars['String']['input']>
  startUrl?: InputMaybe<Scalars['String']['input']>
  stepDescription?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpsertReleaseNoteScheduleArgs = {
  externalChannelId?: InputMaybe<Scalars['String']['input']>
  frequencyType: ReleaseNoteScheduleFrequencyTypeEnum
  id?: InputMaybe<Scalars['ID']['input']>
  ownersToNotify?: InputMaybe<Array<Scalars['String']['input']>>
  publishDelay?: InputMaybe<ReleaseNoteSchedulePublishDelayEnum>
  repoNames?: InputMaybe<Array<Scalars['String']['input']>>
  requireApproval?: InputMaybe<Scalars['Boolean']['input']>
  scheduleName?: InputMaybe<Scalars['String']['input']>
  startDate: Scalars['ISO8601DateTime']['input']
}

export type MutationUserChangeRoleArgs = {
  role: UsersRoleEnum
  userId: Scalars['ID']['input']
}

export type MutationUserEmailVerifyArgs = {
  emailVerificationCode: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type MutationUserExchangeGoogleOauthCodeArgs = {
  code: Scalars['String']['input']
}

export type MutationUserInviteArgs = {
  email: Scalars['String']['input']
  role?: InputMaybe<UsersRoleEnum>
}

export type MutationUserRemoveArgs = {
  userId: Scalars['ID']['input']
}

/** Autogenerated return type of Notes. */
export type NotesPayload = {
  __typename?: 'NotesPayload'
  content: Scalars['String']['output']
  final: Scalars['Boolean']['output']
  i?: Maybe<Scalars['Int']['output']>
  initial: Scalars['Boolean']['output']
  objId: Scalars['String']['output']
  requestId: Scalars['String']['output']
}

export type OpportunityTheme = {
  __typename?: 'OpportunityTheme'
  archived: Scalars['Boolean']['output']
  externalCustomerQuestions: Array<ExternalCustomerQuestion>
  externalSubtopic?: Maybe<ExternalSubtopic>
  externalTopic: ExternalTopic
  id: Scalars['ID']['output']
  numUniqueExternalCustomerQuestions: Scalars['Int']['output']
  themeDescription?: Maybe<Scalars['String']['output']>
  uniqueSourceTypes: Array<Scalars['String']['output']>
}

export type PaginatedAnswers = {
  __typename?: 'PaginatedAnswers'
  data: Array<Answer>
  pagination: Pagination
}

export type PaginatedDocumentationProjects = {
  __typename?: 'PaginatedDocumentationProjects'
  data: Array<DocumentationProject>
  pagination: Pagination
}

export type PaginatedDocumentationTasks = {
  __typename?: 'PaginatedDocumentationTasks'
  data: Array<DocumentationTask>
  pagination: Pagination
}

export type PaginatedDocumentationToReview = {
  __typename?: 'PaginatedDocumentationToReview'
  data: Array<DocumentationToReview>
  pagination: Pagination
}

export type PaginatedDocumentations = {
  __typename?: 'PaginatedDocumentations'
  data: Array<Documentation>
  pagination: Pagination
}

export type PaginatedOpportunityThemeConversations = {
  __typename?: 'PaginatedOpportunityThemeConversations'
  data: Array<ExternalCustomerQuestion>
  pagination: Pagination
}

export type PaginatedOpportunityThemes = {
  __typename?: 'PaginatedOpportunityThemes'
  data: Array<OpportunityTheme>
  pagination: Pagination
}

export type PaginatedSuccessfulCoverage = {
  __typename?: 'PaginatedSuccessfulCoverage'
  data: Array<SuccessfulCoverageRow>
  pagination: Pagination
}

export type PaginatedSuccessfulCoverageConversations = {
  __typename?: 'PaginatedSuccessfulCoverageConversations'
  data: Array<ExternalCustomerQuestion>
  pagination: Pagination
}

export type PaginatedTypedReleaseNotes = {
  __typename?: 'PaginatedTypedReleaseNotes'
  data: Array<TypedReleaseNote>
  pagination: Pagination
}

export type Pagination = {
  __typename?: 'Pagination'
  page: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  totalCount: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod'
  brand?: Maybe<Scalars['String']['output']>
  expMonth?: Maybe<Scalars['String']['output']>
  expYear?: Maybe<Scalars['String']['output']>
  last4?: Maybe<Scalars['String']['output']>
}

export type PylonExternalCollection = {
  __typename?: 'PylonExternalCollection'
  id?: Maybe<Scalars['String']['output']>
  knowledgeBaseName?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type Query = {
  __typename?: 'Query'
  business: Business
  chatConfiguration: ChatConfiguration
  chatMessages?: Maybe<Array<AnswerMessageType>>
  document360GetCollections?: Maybe<Array<Document360ExternalCollection>>
  documentationActionItems: Array<DocumentationToReview>
  documentationPreview?: Maybe<Documentation>
  documentationProject?: Maybe<DocumentationProject>
  documentationTask?: Maybe<DocumentationTask>
  documentationTaskExistsForSlackMessage: Scalars['Boolean']['output']
  documentationToReview: Array<DocumentationToReview>
  documentationVersions: Array<DocumentationVersion>
  documentations: Array<Documentation>
  documents: Array<Document>
  emailVerifyAllowed?: Maybe<Users>
  externalIntegrations: Array<ExternalIntegration>
  externalSlackChannels: Array<ExternalSlack>
  frontGetCategories?: Maybe<Array<FrontExternalCategory>>
  getBotAccessToken: Scalars['String']['output']
  getDocumentationRepoNamesByInstallationId: Array<Repository>
  getDocumentationToReview: DocumentationToReview
  getFeatureFlagInfo: FeatureFlagsInfo
  getImageFlowByImageSource?: Maybe<ImageFlow>
  getRepoNamesByInstallationId: Array<Repository>
  helpScoutGetCollections?: Maybe<Array<HelpScoutExternalCollection>>
  hubspotGetCollections?: Maybe<Array<HubspotExternalCollection>>
  imageFlow?: Maybe<ImageFlow>
  imageFlows: Array<ImageFlow>
  intercomGetCollections?: Maybe<Array<IntercomExternalCollection>>
  loginFlow?: Maybe<BrowserFlow>
  loginFlows: Array<BrowserFlow>
  nextDocumentationWithDocumentationReviewRunTextForUser?: Maybe<Scalars['String']['output']>
  paginatedDocumentationActionItems: PaginatedDocumentationToReview
  paginatedDocumentationProjects?: Maybe<PaginatedDocumentationProjects>
  paginatedDocumentationReport: PaginatedDocumentationToReview
  paginatedDocumentationTasks?: Maybe<PaginatedDocumentationTasks>
  paginatedDocumentations?: Maybe<PaginatedDocumentations>
  paginatedOpportunityThemeConversations?: Maybe<PaginatedOpportunityThemeConversations>
  paginatedOpportunityThemes?: Maybe<PaginatedOpportunityThemes>
  paginatedQuestions?: Maybe<PaginatedAnswers>
  paginatedSuccessfulCoverage?: Maybe<PaginatedSuccessfulCoverage>
  paginatedSuccessfulCoverageConversations?: Maybe<PaginatedSuccessfulCoverageConversations>
  paginatedTypedReleaseNotes?: Maybe<PaginatedTypedReleaseNotes>
  previousChats?: Maybe<Array<Answer>>
  pylonGetCollections?: Maybe<Array<PylonExternalCollection>>
  question?: Maybe<Answer>
  releaseNoteItem: TypedReleaseNoteItem
  releaseNoteItemComments: Array<ReleaseNoteItemComment>
  releaseNoteSchedule?: Maybe<ReleaseNoteSchedule>
  releaseNoteSchedules: Array<ReleaseNoteSchedule>
  repositories: Array<Repository>
  resetPasswordAllowed: Scalars['Boolean']['output']
  searchDocumentationTasks: Array<DocumentationTask>
  searchDocumentations: Array<Documentation>
  searchExternalTaskIssues: Array<ExternalTaskIssue>
  searchReleaseNotes?: Maybe<Array<TypedReleaseNoteItem>>
  teamsupportGetAllKnowledgeBaseCategories?: Maybe<Array<TeamsupportExternalKnowledgeBaseCategory>>
  typedReleaseNote: TypedReleaseNote
  user: Users
  zendeskGetSections?: Maybe<Array<ZendeskExternalSection>>
}

export type QueryBusinessArgs = {
  externalBusinessId: Scalars['ID']['input']
}

export type QueryChatConfigurationArgs = {
  externalBusinessId: Scalars['ID']['input']
  externalChannelId: Scalars['String']['input']
}

export type QueryChatMessagesArgs = {
  chatId: Scalars['String']['input']
}

export type QueryDocumentationActionItemsArgs = {
  sourceLinks?: InputMaybe<Array<Scalars['String']['input']>>
  sourceType?: InputMaybe<DocumentationsSourceTypeEnum>
}

export type QueryDocumentationPreviewArgs = {
  documentationUniqueId: Scalars['ID']['input']
}

export type QueryDocumentationProjectArgs = {
  documentationProjectId: Scalars['ID']['input']
}

export type QueryDocumentationTaskArgs = {
  documentationTaskId: Scalars['ID']['input']
}

export type QueryDocumentationTaskExistsForSlackMessageArgs = {
  externalBusinessId: Scalars['ID']['input']
  messageExternalId: Scalars['ID']['input']
}

export type QueryDocumentationToReviewArgs = {
  documentationId: Scalars['ID']['input']
  snoozedOnly?: InputMaybe<Scalars['Boolean']['input']>
  unreviewedOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryDocumentationVersionsArgs = {
  documentationId: Scalars['ID']['input']
}

export type QueryDocumentationsArgs = {
  documentationIds?: InputMaybe<Array<Scalars['ID']['input']>>
  sourceType?: InputMaybe<DocumentationsSourceTypeEnum>
}

export type QueryDocumentsArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryEmailVerifyAllowedArgs = {
  emailVerificationCode: Scalars['String']['input']
}

export type QueryExternalIntegrationsArgs = {
  externalIntegrationIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryExternalSlackChannelsArgs = {
  externalIntegrationId?: InputMaybe<Scalars['ID']['input']>
  searchQuery?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetBotAccessTokenArgs = {
  externalBusinessId: Scalars['ID']['input']
}

export type QueryGetDocumentationRepoNamesByInstallationIdArgs = {
  installationId: Scalars['String']['input']
}

export type QueryGetDocumentationToReviewArgs = {
  documentationToReviewId: Scalars['ID']['input']
}

export type QueryGetImageFlowByImageSourceArgs = {
  imageSource: Scalars['String']['input']
}

export type QueryGetRepoNamesByInstallationIdArgs = {
  installationId: Scalars['String']['input']
}

export type QueryImageFlowArgs = {
  imageFlowId: Scalars['ID']['input']
}

export type QueryLoginFlowArgs = {
  browserFlowId: Scalars['ID']['input']
}

export type QueryNextDocumentationWithDocumentationReviewRunTextForUserArgs = {
  documentationId: Scalars['ID']['input']
}

export type QueryPaginatedDocumentationActionItemsArgs = {
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>
  changeReasons?: InputMaybe<Array<Scalars['String']['input']>>
  documentationProjectIds?: InputMaybe<Array<Scalars['ID']['input']>>
  documentationTaskId?: InputMaybe<Scalars['ID']['input']>
  eligibleForAutoApproveOnly?: InputMaybe<Scalars['Boolean']['input']>
  featureFlagStatuses?: InputMaybe<Array<FeatureFlagStatus>>
  featureFlags?: InputMaybe<Array<Scalars['String']['input']>>
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  snoozedOnly?: InputMaybe<Scalars['Boolean']['input']>
  sortByCreatedAt?: InputMaybe<Scalars['Boolean']['input']>
  sourceType?: InputMaybe<DocumentationsSourceTypeEnum>
  suggestionType?: InputMaybe<DocumentationToReviewSuggestionType>
}

export type QueryPaginatedDocumentationProjectsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPaginatedDocumentationReportArgs = {
  actionDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>
  actionDateTo?: InputMaybe<Scalars['ISO8601Date']['input']>
  activityTypes?: InputMaybe<Array<UsersActivityTypeEnum>>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  suggestionType?: InputMaybe<DocumentationToReviewSuggestionType>
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryPaginatedDocumentationTasksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type QueryPaginatedDocumentationsArgs = {
  archivedInSolo?: InputMaybe<Scalars['Boolean']['input']>
  documentationProjectIds?: InputMaybe<Array<Scalars['ID']['input']>>
  needsReview?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<DocumentationSortByEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
  source?: InputMaybe<DocumentationsSourceEnum>
  sourceType?: InputMaybe<DocumentationsSourceTypeEnum>
}

export type QueryPaginatedOpportunityThemeConversationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  themeId: Scalars['ID']['input']
}

export type QueryPaginatedOpportunityThemesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPaginatedQuestionsArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type QueryPaginatedSuccessfulCoverageArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  startDate: Scalars['ISO8601DateTime']['input']
}

export type QueryPaginatedSuccessfulCoverageConversationsArgs = {
  externalSubtopicId: Scalars['ID']['input']
  externalTopicId: Scalars['ID']['input']
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPaginatedTypedReleaseNotesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  scheduleName?: InputMaybe<Scalars['String']['input']>
}

export type QueryQuestionArgs = {
  questionId: Scalars['ID']['input']
}

export type QueryReleaseNoteItemArgs = {
  releaseNoteItemId: Scalars['ID']['input']
}

export type QueryReleaseNoteItemCommentsArgs = {
  releaseNoteItemId: Scalars['ID']['input']
}

export type QueryRepositoriesArgs = {
  repositoryIds?: InputMaybe<Array<Scalars['ID']['input']>>
  sourceType?: InputMaybe<RepositoriesSourceTypeEnum>
}

export type QueryResetPasswordAllowedArgs = {
  resetPasswordToken: Scalars['String']['input']
}

export type QuerySearchDocumentationTasksArgs = {
  query: Scalars['String']['input']
}

export type QuerySearchDocumentationsArgs = {
  query: Scalars['String']['input']
  sourceType?: InputMaybe<DocumentationsSourceTypeEnum>
}

export type QuerySearchExternalTaskIssuesArgs = {
  query: Scalars['String']['input']
}

export type QuerySearchReleaseNotesArgs = {
  query: Scalars['String']['input']
}

export type QueryTypedReleaseNoteArgs = {
  typedReleaseNoteId: Scalars['ID']['input']
}

/** Autogenerated return type of ReleaseNoteItemAnswered. */
export type ReleaseNoteItemAnsweredPayload = {
  __typename?: 'ReleaseNoteItemAnsweredPayload'
  answer: Scalars['String']['output']
  objId: Scalars['String']['output']
}

export type ReleaseNoteItemComment = {
  __typename?: 'ReleaseNoteItemComment'
  comment: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  user: Users
}

export type ReleaseNoteItemInputObject = {
  change: Scalars['String']['input']
  id: Scalars['ID']['input']
  position: Scalars['Int']['input']
  releaseNoteLabelIds?: InputMaybe<Array<Scalars['ID']['input']>>
  summarizedTitle: Scalars['String']['input']
  whyItMatters?: InputMaybe<Scalars['String']['input']>
}

export type ReleaseNoteItemPositionInputObject = {
  id: Scalars['ID']['input']
  position: Scalars['Int']['input']
}

export type ReleaseNoteLabel = {
  __typename?: 'ReleaseNoteLabel'
  assignee?: Maybe<Users>
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ReleaseNoteLabelInputObject = {
  description: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type ReleaseNoteSchedule = {
  __typename?: 'ReleaseNoteSchedule'
  createdAt: Scalars['ISO8601DateTime']['output']
  externalChannelId?: Maybe<Scalars['String']['output']>
  frequencyType: ReleaseNoteScheduleFrequencyTypeEnum
  id: Scalars['ID']['output']
  ownersToNotifyUsers: Array<Users>
  publishDelay: ReleaseNoteSchedulePublishDelayEnum
  repoNames: Array<Scalars['String']['output']>
  requireApproval: Scalars['Boolean']['output']
  scheduleName?: Maybe<Scalars['String']['output']>
  startDate: Scalars['ISO8601DateTime']['output']
}

export enum ReleaseNoteScheduleFrequencyTypeEnum {
  Daily = 'DAILY',
  EveryThreeWeeks = 'EVERY_THREE_WEEKS',
  EveryTwoWeeks = 'EVERY_TWO_WEEKS',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export enum ReleaseNoteSchedulePublishDelayEnum {
  Instantly = 'INSTANTLY',
  OneDay = 'ONE_DAY',
  ThreeDays = 'THREE_DAYS',
  TwoDays = 'TWO_DAYS',
}

export enum RepositoriesSourceTypeEnum {
  Bitbucket = 'BITBUCKET',
  Github = 'GITHUB',
  Gitlab = 'GITLAB',
}

export type Repository = {
  __typename?: 'Repository'
  accessToken: Scalars['String']['output']
  branchName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  repoName: Scalars['String']['output']
  shaIndexed?: Maybe<Scalars['String']['output']>
}

export type RepositoryInputObject = {
  branchName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export type SlackConfiguration = {
  __typename?: 'SlackConfiguration'
  channelId: Scalars['String']['output']
  channelName: Scalars['String']['output']
  chatSources: Array<AnswerTypeEnum>
  id: Scalars['ID']['output']
  repoNames: Array<Scalars['String']['output']>
  showCodeSources: Scalars['Boolean']['output']
}

export enum SortByDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** The subscription root for the GraphQL schema */
export type Subscription = {
  __typename?: 'Subscription'
  browserFlowImage: BrowserFlowImagePayload
  chat: ChatPayload
  chatAnswered: ChatAnsweredPayload
  documentation: DocumentationPayload
  documentationAttachedToProject: DocumentationAttachedToProjectPayload
  documentationAttachedToReleaseNoteItem: DocumentationAttachedToReleaseNoteItemPayload
  documentationAttachedToTask: DocumentationAttachedToTaskPayload
  documentationContentUpdated: DocumentationContentUpdatedPayload
  notes: NotesPayload
  releaseNoteItemAnswered: ReleaseNoteItemAnsweredPayload
  typedReleaseNotesCreated: TypedReleaseNotesCreatedPayload
}

export enum SubscriptionPlanEnum {
  Basic = 'BASIC',
  Free = 'FREE',
  Hobby = 'HOBBY',
  Pro = 'PRO',
}

export type SuccessfulCoverageRow = {
  __typename?: 'SuccessfulCoverageRow'
  documentation?: Maybe<Documentation>
  subtopic: ExternalSubtopic
  topic: ExternalTopic
  uniqueConversationCount: Scalars['Int']['output']
  uniqueConversationSourceTypes: Array<Scalars['String']['output']>
}

export type TeamsupportExternalKnowledgeBaseCategory = {
  __typename?: 'TeamsupportExternalKnowledgeBaseCategory'
  description?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export enum TemplateTypeEnum {
  Chat = 'CHAT',
  ExternalDocumentation = 'EXTERNAL_DOCUMENTATION',
  ReleaseNotes = 'RELEASE_NOTES',
}

export type TypedReleaseNote = {
  __typename?: 'TypedReleaseNote'
  approversUserIds: Array<Scalars['String']['output']>
  endDate: Scalars['ISO8601DateTime']['output']
  hasApprovedUsersIds: Array<Scalars['String']['output']>
  hasBeenPublished: Scalars['Boolean']['output']
  htmlText?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  markdownText: Scalars['String']['output']
  markdownTextForSlack: Scalars['String']['output']
  markdownTextForSlackGroupedByLabel: Scalars['String']['output']
  markdownTextForSlackGroupedByLabelArray: Array<MarkdownTextLabel>
  markdownTextGroupedByLabel: Scalars['String']['output']
  markdownTextGroupedByLabelArray: Array<MarkdownTextLabel>
  releaseNoteItems: Array<TypedReleaseNoteItem>
  scheduleName?: Maybe<Scalars['String']['output']>
  startDate: Scalars['ISO8601DateTime']['output']
}

export type TypedReleaseNoteAttachment = {
  __typename?: 'TypedReleaseNoteAttachment'
  contentType: Scalars['String']['output']
  id: Scalars['ID']['output']
  url: Scalars['String']['output']
}

export type TypedReleaseNoteInputObject = {
  id: Scalars['ID']['input']
  releaseNoteItems: Array<ReleaseNoteItemInputObject>
}

export type TypedReleaseNoteItem = {
  __typename?: 'TypedReleaseNoteItem'
  change?: Maybe<Scalars['String']['output']>
  documentationProjects: Array<DocumentationProject>
  documentationsCoveringFeature: Array<Documentation>
  externalTaskIssues: Array<ExternalTaskIssue>
  featureFlags: Array<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isCoveredByDoc: Scalars['Boolean']['output']
  numPendingDocumentationReviewRunTexts: Scalars['Int']['output']
  position: Scalars['Int']['output']
  processedRelatedDocumentation: Scalars['Boolean']['output']
  relatedDocumentations: Array<Documentation>
  releaseNoteItemComments: Array<ReleaseNoteItemComment>
  releaseNoteItemImagesAndVideosJson: Array<TypedReleaseNoteAttachment>
  releaseNoteLabels: Array<ReleaseNoteLabel>
  showMobileReleaseUx: Scalars['Boolean']['output']
  sourceLinkAuthors: Array<Maybe<Scalars['String']['output']>>
  sourceLinks: Array<Scalars['String']['output']>
  summarizedTitle?: Maybe<Scalars['String']['output']>
  typedReleaseNote: TypedReleaseNote
  whyItMatters?: Maybe<Scalars['String']['output']>
}

export enum TypedReleaseNoteSnoozeTypeEnum {
  UntilDate = 'UNTIL_DATE',
  UntilNextReleaseNote = 'UNTIL_NEXT_RELEASE_NOTE',
}

/** Autogenerated return type of TypedReleaseNotesCreated. */
export type TypedReleaseNotesCreatedPayload = {
  __typename?: 'TypedReleaseNotesCreatedPayload'
  objId: Scalars['String']['output']
}

export type UserActivity = {
  __typename?: 'UserActivity'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  user: Users
}

export type Users = {
  __typename?: 'Users'
  business: Business
  email: Scalars['String']['output']
  emailVerifyFromUrl?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isSuperadmin: Scalars['Boolean']['output']
  lastName?: Maybe<Scalars['String']['output']>
  role: UsersRoleEnum
  uniqueId: Scalars['String']['output']
  unreadUsersActivitiesCount: Scalars['Int']['output']
  usersActivities: Array<UsersActivity>
  verified: Scalars['Boolean']['output']
}

export type UsersActivity = {
  __typename?: 'UsersActivity'
  activityType: UsersActivityTypeEnum
  createdAt: Scalars['ISO8601DateTime']['output']
  documentationReviewRunText?: Maybe<DocumentationToReview>
  id: Scalars['ID']['output']
  read: Scalars['Boolean']['output']
  releaseNoteItem?: Maybe<TypedReleaseNoteItem>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum UsersActivityTypeEnum {
  AcceptedDocumentationReviewRunText = 'ACCEPTED_DOCUMENTATION_REVIEW_RUN_TEXT',
  NewCommentOnDocumentationReviewRunText = 'NEW_COMMENT_ON_DOCUMENTATION_REVIEW_RUN_TEXT',
  NewCommentOnReleaseNoteItem = 'NEW_COMMENT_ON_RELEASE_NOTE_ITEM',
  RejectedDocumentationReviewRunText = 'REJECTED_DOCUMENTATION_REVIEW_RUN_TEXT',
  ResolvedExternallyDocumentationReviewRunText = 'RESOLVED_EXTERNALLY_DOCUMENTATION_REVIEW_RUN_TEXT',
  TaggedInDocumentationReviewRunText = 'TAGGED_IN_DOCUMENTATION_REVIEW_RUN_TEXT',
  TaggedInReleaseNoteItem = 'TAGGED_IN_RELEASE_NOTE_ITEM',
}

export type UsersInputObject = {
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
}

export enum UsersRoleEnum {
  Admin = 'ADMIN',
  Commentor = 'COMMENTOR',
  Regular = 'REGULAR',
}

export enum VoiceTypeEnum {
  Chat = 'CHAT',
  ExternalDocumentation = 'EXTERNAL_DOCUMENTATION',
  ReleaseNotes = 'RELEASE_NOTES',
}

export type ZendeskExternalSection = {
  __typename?: 'ZendeskExternalSection'
  categoryName?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type AddBusinessNameMutationVariables = Exact<{
  name: Scalars['String']['input']
}>

export type AddBusinessNameMutation = {
  __typename?: 'Mutation'
  updateBusiness: { __typename?: 'Business'; id: string; name: string }
}

export type ChatAnsweredSubscriptionVariables = Exact<{ [key: string]: never }>

export type ChatAnsweredSubscription = {
  __typename?: 'Subscription'
  chatAnswered: {
    __typename?: 'ChatAnsweredPayload'
    answerId: string
    chatId: string
    answer: string
    sources?: Array<string> | null
  }
}

export type Chat_AnswerQuestionMutationVariables = Exact<{
  question: Scalars['String']['input']
  chatId: Scalars['String']['input']
  answerTypes?: InputMaybe<Array<AnswerTypeEnum> | AnswerTypeEnum>
}>

export type Chat_AnswerQuestionMutation = {
  __typename?: 'Mutation'
  answerQuestion?: string | null
}

export type Chat_IncorrectInChatMutationVariables = Exact<{
  answerId: Scalars['ID']['input']
}>

export type Chat_IncorrectInChatMutation = {
  __typename?: 'Mutation'
  incorrectInChat?: string | null
}

export type Chat_ChatMessagesQueryVariables = Exact<{
  chatId: Scalars['String']['input']
}>

export type Chat_ChatMessagesQuery = {
  __typename?: 'Query'
  chatMessages?: Array<{
    __typename?: 'AnswerMessageType'
    answerId?: string | null
    message: string
    userName: string
    createdAt: any
    sources?: Array<string> | null
    hasIncorrectAnswerFeedback?: boolean | null
  }> | null
}

export type Chat_PreviousChatsQueryVariables = Exact<{ [key: string]: never }>

export type Chat_PreviousChatsQuery = {
  __typename?: 'Query'
  previousChats?: Array<{
    __typename?: 'Answer'
    id: string
    createdAt: any
    question: string
    messageActualThreadExternalId?: string | null
  }> | null
}

export type IntegrationExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type AllDocumentationToReview_GetDocumentationQueryVariables = Exact<{
  documentationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type AllDocumentationToReview_GetDocumentationQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    business: {
      __typename?: 'Business'
      id: string
      documentationCssString?: string | null
      activeReleaseNoteLabels?: Array<{
        __typename?: 'ReleaseNoteLabel'
        id: string
        name: string
      }> | null
    }
  }
  documentations: Array<{
    __typename?: 'Documentation'
    id: string
    uniqueId?: string | null
    topic: string
    instruction?: string | null
    content?: string | null
    contentLastCreatedAt?: any | null
    externalContent?: string | null
    externalContentType?: string | null
    lastUpdatedAt?: any | null
    url?: string | null
    editUrl?: string | null
    sourceType?: DocumentationsSourceTypeEnum | null
    source: DocumentationsSourceEnum
    externalPageId?: string | null
    hasDraft: boolean
    activeDocumentationCommentAnchors: Array<{
      __typename?: 'DocumentationCommentAnchor'
      id: string
      startOffset: number
      endOffset: number
      documentationComments: Array<{
        __typename?: 'DocumentationComment'
        id: string
        createdAt: any
        content: string
        user: {
          __typename?: 'Users'
          id: string
          firstName?: string | null
          lastName?: string | null
        }
      }>
    }>
    documentationsToReview?: Array<{
      __typename?: 'DocumentationToReview'
      id: string
      createdAt: any
      oldDocumentationMarkdownText?: string | null
      newDocumentationMarkdownText?: string | null
      status: DocumentationToReviewStatusEnum
      reviewType: DocumentationToReviewReviewType
      isSnoozed: boolean
      summarizedChange?: string | null
      suggestionType: DocumentationToReviewSuggestionType
      showMobileReleaseUx: boolean
      featureFlags?: Array<string> | null
      isAccepting: boolean
      documentation: { __typename?: 'Documentation'; id: string; url?: string | null }
      labels: Array<{ __typename?: 'ReleaseNoteLabel'; id: string; name: string }>
      assignee?: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      } | null
      documentationTask?: { __typename?: 'DocumentationTask'; id: string; name: string } | null
      linkedExternalTaskIssues: Array<{
        __typename?: 'ExternalTaskIssue'
        id: string
        externalIdentifier: string
        sourceType: ExternalTaskIssueSourceTypeEnum
        url: string
      }>
      externalTaskIssues: Array<{
        __typename?: 'ExternalTaskIssue'
        id: string
        externalIdentifier: string
        sourceType: ExternalTaskIssueSourceTypeEnum
        url: string
      }>
      externalCustomerConversation?: {
        __typename?: 'ExternalCustomerConversation'
        id: string
        externalId: string
        url?: string | null
      } | null
      documentationReviewComments?: Array<{
        __typename?: 'DocumentationToReviewComment'
        id: string
        createdAt: any
        comment: string
        user: {
          __typename?: 'Users'
          id: string
          email: string
          firstName?: string | null
          lastName?: string | null
        }
      }> | null
    }> | null
  }>
}

export type AllDocumentationToReview_DocumentationToReviewQueryVariables = Exact<{
  documentationId: Scalars['ID']['input']
  unreviewedOnly?: InputMaybe<Scalars['Boolean']['input']>
  snoozedOnly?: InputMaybe<Scalars['Boolean']['input']>
}>

export type AllDocumentationToReview_DocumentationToReviewQuery = {
  __typename?: 'Query'
  documentationToReview: Array<{
    __typename?: 'DocumentationToReview'
    id: string
    createdAt: any
    oldDocumentationMarkdownText?: string | null
    newDocumentationMarkdownText?: string | null
    status: DocumentationToReviewStatusEnum
    rejectionReason?: string | null
    reviewType: DocumentationToReviewReviewType
    isSnoozed: boolean
    previewText?: string | null
    summarizedChange?: string | null
    suggestionReason?: string | null
    suggestionType: DocumentationToReviewSuggestionType
    sourceLinks?: Array<string> | null
    didFindBlocksPublished: boolean
    showMobileReleaseUx: boolean
    disableImageRecording: boolean
    featureFlags?: Array<string> | null
    githubPrUrl?: string | null
    isAccepting: boolean
    eligibleForAutoApprove: boolean
    isAutoApproved: boolean
    autoApproveFeatureFlagStatus?: string | null
    autoApproveConditionsMet?: Array<string> | null
    autoApproveConditionsNotMet?: Array<string> | null
    documentation: {
      __typename?: 'Documentation'
      id: string
      url?: string | null
      sourceType?: DocumentationsSourceTypeEnum | null
    }
    labels: Array<{ __typename?: 'ReleaseNoteLabel'; id: string; name: string }>
    assignee?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
    externalTaskIssues: Array<{
      __typename?: 'ExternalTaskIssue'
      id: string
      externalIdentifier: string
      sourceType: ExternalTaskIssueSourceTypeEnum
      url: string
    }>
    linkedExternalTaskIssues: Array<{
      __typename?: 'ExternalTaskIssue'
      id: string
      externalIdentifier: string
      sourceType: ExternalTaskIssueSourceTypeEnum
      url: string
    }>
    externalCustomerConversation?: {
      __typename?: 'ExternalCustomerConversation'
      id: string
      externalId: string
      url?: string | null
    } | null
    documentationTask?: { __typename?: 'DocumentationTask'; id: string; name: string } | null
    browserFlow?: {
      __typename?: 'BrowserFlow'
      id: string
      imageFlow?: { __typename?: 'ImageFlow'; id: string } | null
      mostRecentCompletedBrowserFlowRun?: {
        __typename?: 'BrowserFlowRun'
        url?: string | null
        imageUrl?: string | null
      } | null
    } | null
    documentationReviewComments?: Array<{
      __typename?: 'DocumentationToReviewComment'
      id: string
      createdAt: any
      comment: string
      user: {
        __typename?: 'Users'
        id: string
        email: string
        firstName?: string | null
        lastName?: string | null
      }
    }> | null
  }>
}

export type AllDocumentationToReview_NextDocumentationWithDocumentationReviewRunTextForUserQueryVariables =
  Exact<{
    documentationId: Scalars['ID']['input']
  }>

export type AllDocumentationToReview_NextDocumentationWithDocumentationReviewRunTextForUserQuery = {
  __typename?: 'Query'
  nextDocumentationWithDocumentationReviewRunTextForUser?: string | null
}

export type AllDocumentationToReview_CancelDocumentationDraftMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
}>

export type AllDocumentationToReview_CancelDocumentationDraftMutation = {
  __typename?: 'Mutation'
  cancelDocumentationDraft: { __typename?: 'Documentation'; id: string }
}

export type AllDocumentationToReview_PublishDocumentationDraftMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  branchName?: InputMaybe<Scalars['String']['input']>
}>

export type AllDocumentationToReview_PublishDocumentationDraftMutation = {
  __typename?: 'Mutation'
  publishDocumentationDraft: { __typename?: 'Documentation'; id: string }
}

export type AllDocumentationToReview_AcceptAllDocumentationReviewForDocumentationMutationVariables =
  Exact<{
    branchName?: InputMaybe<Scalars['String']['input']>
    documentationId: Scalars['ID']['input']
    documentationReviewRunTextIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  }>

export type AllDocumentationToReview_AcceptAllDocumentationReviewForDocumentationMutation = {
  __typename?: 'Mutation'
  acceptAllDocumentationReviewForDocumentation: { __typename?: 'Documentation'; id: string }
}

export type AllDocumentationToReview_RejectAllDocumentationReviewForDocumentationMutationVariables =
  Exact<{
    documentationId: Scalars['ID']['input']
    documentationReviewRunTextIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  }>

export type AllDocumentationToReview_RejectAllDocumentationReviewForDocumentationMutation = {
  __typename?: 'Mutation'
  rejectAllDocumentationReviewForDocumentation: { __typename?: 'Documentation'; id: string }
}

export type AllDocumentationToReview_MarkOutdatedDocumentationReviewForDocumentationMutationVariables =
  Exact<{
    documentationId: Scalars['ID']['input']
    documentationReviewRunTextIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  }>

export type AllDocumentationToReview_MarkOutdatedDocumentationReviewForDocumentationMutation = {
  __typename?: 'Mutation'
  markOutdatedDocumentationReviewForDocumentation: { __typename?: 'Documentation'; id: string }
}

export type Documentation_GetDocumentationQueryVariables = Exact<{
  documentationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type Documentation_GetDocumentationQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    business: { __typename?: 'Business'; id: string; notionConnected: boolean }
  }
  documentations: Array<{
    __typename?: 'Documentation'
    id: string
    uniqueId?: string | null
    createdAt: any
    topic: string
    instruction?: string | null
    sections?: string | null
    content?: string | null
    url?: string | null
    editUrl?: string | null
    sourceType?: DocumentationsSourceTypeEnum | null
    source: DocumentationsSourceEnum
    externalPageId?: string | null
    externalContentType?: string | null
    findForOutOfDate: boolean
    containsZendeskContentBlockTexts: boolean
    prUrl?: string | null
    isGeneratingContent: boolean
    hasDraft: boolean
    manuallyWrite: boolean
    hasContentEditedVersion: boolean
    activeDocumentationCommentAnchors: Array<{
      __typename?: 'DocumentationCommentAnchor'
      id: string
      startOffset: number
      endOffset: number
      documentationComments: Array<{
        __typename?: 'DocumentationComment'
        id: string
        createdAt: any
        content: string
        user: {
          __typename?: 'Users'
          id: string
          firstName?: string | null
          lastName?: string | null
        }
      }>
    }>
    documentationFilesJson: Array<{
      __typename?: 'DocumentationAttachment'
      id: string
      name: string
      url: string
      contentType: string
    }>
  }>
}

export type Documentation_GenerateDocumentationMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  regenerating?: InputMaybe<Scalars['Boolean']['input']>
}>

export type Documentation_GenerateDocumentationMutation = {
  __typename?: 'Mutation'
  generateDocumentation: { __typename?: 'Documentation'; id: string }
}

export type Documentation_UpdateDocumentationMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  topic: Scalars['String']['input']
  instruction: Scalars['String']['input']
  sections?: InputMaybe<Scalars['String']['input']>
}>

export type Documentation_UpdateDocumentationMutation = {
  __typename?: 'Mutation'
  updateDocumentation: {
    __typename?: 'Documentation'
    id: string
    topic: string
    sections?: string | null
    instruction?: string | null
  }
}

export type Documentation_RemoveDocumentationFileMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  fileId: Scalars['ID']['input']
}>

export type Documentation_RemoveDocumentationFileMutation = {
  __typename?: 'Mutation'
  removeDocumentationFile: { __typename?: 'Documentation'; id: string }
}

export type Documentation_ArchiveDocumentationMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
}>

export type Documentation_ArchiveDocumentationMutation = {
  __typename?: 'Mutation'
  archiveInSolo: { __typename?: 'Documentation'; id: string }
}

export type Documentation_UpdateDocumentationContentMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  content: Scalars['String']['input']
}>

export type Documentation_UpdateDocumentationContentMutation = {
  __typename?: 'Mutation'
  updateDocumentationContent: { __typename?: 'Documentation'; id: string }
}

export type Documentation_UpdateDocumentationHiddenDraftContentMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  hiddenDraftContent: Scalars['String']['input']
}>

export type Documentation_UpdateDocumentationHiddenDraftContentMutation = {
  __typename?: 'Mutation'
  updateHiddenDraftContent: { __typename?: 'Documentation'; id: string }
}

export type Documentation_MarkForFindForOutOfDateDocumentationMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
}>

export type Documentation_MarkForFindForOutOfDateDocumentationMutation = {
  __typename?: 'Mutation'
  markForFindForOutOfDateDocumentation: { __typename?: 'Documentation'; id: string }
}

export type Documentation_UnmarkForFindForOutOfDateDocumentationMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
}>

export type Documentation_UnmarkForFindForOutOfDateDocumentationMutation = {
  __typename?: 'Mutation'
  unmarkForFindForOutOfDateDocumentation: { __typename?: 'Documentation'; id: string }
}

export type Documentation_CreateDocumentationAnchorAndAddCommentMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  startOffset: Scalars['Int']['input']
  endOffset: Scalars['Int']['input']
  comment: Scalars['String']['input']
}>

export type Documentation_CreateDocumentationAnchorAndAddCommentMutation = {
  __typename?: 'Mutation'
  createDocumentationAnchorAndAddComment: { __typename?: 'DocumentationCommentAnchor'; id: string }
}

export type Documentation_AddCommentToExistingAnchorMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  documentationCommentAnchorId: Scalars['ID']['input']
  comment: Scalars['String']['input']
}>

export type Documentation_AddCommentToExistingAnchorMutation = {
  __typename?: 'Mutation'
  addCommentToExistingAnchor: { __typename?: 'DocumentationCommentAnchor'; id: string }
}

export type Documentation_ResolveCommentAnchorMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  documentationCommentAnchorId: Scalars['ID']['input']
}>

export type Documentation_ResolveCommentAnchorMutation = {
  __typename?: 'Mutation'
  resolveCommentAnchor: { __typename?: 'DocumentationCommentAnchor'; id: string }
}

export type Documentation_PublishDocumentationMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  parentPageId: Scalars['String']['input']
  documentationSource: AnswerTypeEnum
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  relatedArticleIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
}>

export type Documentation_PublishDocumentationMutation = {
  __typename?: 'Mutation'
  publishDocumentation: { __typename?: 'Documentation'; id: string }
}

export type Documentation_AcceptDocumentationReviewMutationVariables = Exact<{
  documentationReviewRunTextId: Scalars['ID']['input']
  applyToDraft?: InputMaybe<Scalars['Boolean']['input']>
  branchName?: InputMaybe<Scalars['String']['input']>
}>

export type Documentation_AcceptDocumentationReviewMutation = {
  __typename?: 'Mutation'
  acceptDocumentationReview: { __typename?: 'Documentation'; id: string }
}

export type Documentation_RejectDocumentationReviewMutationVariables = Exact<{
  documentationReviewRunTextId: Scalars['ID']['input']
  rejectionReason?: InputMaybe<Scalars['String']['input']>
}>

export type Documentation_RejectDocumentationReviewMutation = {
  __typename?: 'Mutation'
  rejectDocumentationReview: { __typename?: 'Documentation'; id: string }
}

export type Documentation_MarkOutdatedDocumentationReviewMutationVariables = Exact<{
  documentationReviewRunTextId: Scalars['ID']['input']
}>

export type Documentation_MarkOutdatedDocumentationReviewMutation = {
  __typename?: 'Mutation'
  markOutdatedDocumentationReview: { __typename?: 'Documentation'; id: string }
}

export type DocumentationSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>

export type DocumentationSubscriptionSubscription = {
  __typename?: 'Subscription'
  documentation: { __typename?: 'DocumentationPayload'; objId: string }
}

export type DocumentationToReviewComponent_EditDocumentationReviewMutationVariables = Exact<{
  documentationReviewRunTextId: Scalars['ID']['input']
  newDocumentationMarkdownText: Scalars['String']['input']
}>

export type DocumentationToReviewComponent_EditDocumentationReviewMutation = {
  __typename?: 'Mutation'
  editDocumentationReview: {
    __typename?: 'Documentation'
    id: string
    topic: string
    instruction?: string | null
    content?: string | null
    url?: string | null
    editUrl?: string | null
    sourceType?: DocumentationsSourceTypeEnum | null
    source: DocumentationsSourceEnum
    externalPageId?: string | null
    documentationsToReview?: Array<{
      __typename?: 'DocumentationToReview'
      id: string
      createdAt: any
      oldDocumentationMarkdownText?: string | null
      newDocumentationMarkdownText?: string | null
      status: DocumentationToReviewStatusEnum
      reviewType: DocumentationToReviewReviewType
      externalCustomerConversation?: {
        __typename?: 'ExternalCustomerConversation'
        id: string
        externalId: string
        url?: string | null
      } | null
    }> | null
  }
}

export type DocumentationToReviewComponent_UnsnoozeDocumentationReviewMutationVariables = Exact<{
  documentationReviewRunTextId: Scalars['ID']['input']
}>

export type DocumentationToReviewComponent_UnsnoozeDocumentationReviewMutation = {
  __typename?: 'Mutation'
  unsnoozeDocumentationReview: { __typename?: 'Documentation'; id: string }
}

export type DocumentationToReviewComponent_ExcludeImageDocumentationReviewMutationVariables =
  Exact<{
    documentationReviewRunTextId: Scalars['ID']['input']
  }>

export type DocumentationToReviewComponent_ExcludeImageDocumentationReviewMutation = {
  __typename?: 'Mutation'
  excludeImageDocumentationReview: { __typename?: 'Documentation'; id: string }
}

export type DocumentationToReviewComponent_IncludeImageDocumentationReviewMutationVariables =
  Exact<{
    documentationReviewRunTextId: Scalars['ID']['input']
  }>

export type DocumentationToReviewComponent_IncludeImageDocumentationReviewMutation = {
  __typename?: 'Mutation'
  includeImageDocumentationReview: { __typename?: 'Documentation'; id: string }
}

export type DocumentationToReviewComponent_LinkDocumentationReviewToNewExternalTaskIssueMutationVariables =
  Exact<{
    documentationReviewRunTextId: Scalars['ID']['input']
  }>

export type DocumentationToReviewComponent_LinkDocumentationReviewToNewExternalTaskIssueMutation = {
  __typename?: 'Mutation'
  linkDocumentationReviewToNewExternalTaskIssue: { __typename?: 'Documentation'; id: string }
}

export type DocumentationToReviewComponent_UpdateLabelsDocumentationReviewMutationVariables =
  Exact<{
    documentationReviewRunTextId: Scalars['ID']['input']
    labelIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  }>

export type DocumentationToReviewComponent_UpdateLabelsDocumentationReviewMutation = {
  __typename?: 'Mutation'
  updateLabelsDocumentationReview: {
    __typename?: 'Documentation'
    id: string
    documentationsToReview?: Array<{
      __typename?: 'DocumentationToReview'
      id: string
      labels: Array<{ __typename?: 'ReleaseNoteLabel'; id: string; name: string }>
    }> | null
  }
}

export type DocumentationToReviewComponent_GetFeatureFlagInfoQueryVariables = Exact<{
  [key: string]: never
}>

export type DocumentationToReviewComponent_GetFeatureFlagInfoQuery = {
  __typename?: 'Query'
  getFeatureFlagInfo: {
    __typename?: 'FeatureFlagsInfo'
    fullyOnFeatureFlags: Array<string>
    partiallyOnFeatureFlags: Array<string>
    notFullyOnFeatureFlags: Array<string>
  }
}

export type DocumentationActionItems_PaginatedDocumentationActionItemsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  sourceType?: InputMaybe<DocumentationsSourceTypeEnum>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  changeReasons?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  labelIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  sortByCreatedAt?: InputMaybe<Scalars['Boolean']['input']>
  documentationProjectIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  documentationTaskId?: InputMaybe<Scalars['ID']['input']>
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>
  snoozedOnly?: InputMaybe<Scalars['Boolean']['input']>
  suggestionType?: InputMaybe<DocumentationToReviewSuggestionType>
  featureFlags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  featureFlagStatuses?: InputMaybe<Array<FeatureFlagStatus> | FeatureFlagStatus>
  eligibleForAutoApproveOnly?: InputMaybe<Scalars['Boolean']['input']>
}>

export type DocumentationActionItems_PaginatedDocumentationActionItemsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    business: {
      __typename?: 'Business'
      id: string
      activeReleaseNoteLabels?: Array<{
        __typename?: 'ReleaseNoteLabel'
        id: string
        name: string
      }> | null
    }
  }
  paginatedDocumentationActionItems: {
    __typename?: 'PaginatedDocumentationToReview'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'DocumentationToReview'
      id: string
      createdAt: any
      oldDocumentationMarkdownText?: string | null
      newDocumentationMarkdownText?: string | null
      suggestionType: DocumentationToReviewSuggestionType
      status: DocumentationToReviewStatusEnum
      reviewType: DocumentationToReviewReviewType
      sourceLinks?: Array<string> | null
      summarizedChange?: string | null
      assignee?: {
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
      } | null
      documentationTask?: { __typename?: 'DocumentationTask'; id: string; name: string } | null
      documentationProjects: Array<{
        __typename?: 'DocumentationProject'
        id: string
        name: string
      }>
      labels: Array<{ __typename?: 'ReleaseNoteLabel'; id: string; name: string }>
      externalTaskIssues: Array<{
        __typename?: 'ExternalTaskIssue'
        externalIdentifier: string
        url: string
      }>
      externalCustomerConversation?: {
        __typename?: 'ExternalCustomerConversation'
        id: string
        externalId: string
        url?: string | null
      } | null
      documentation: {
        __typename?: 'Documentation'
        id: string
        topic: string
        url?: string | null
        editUrl?: string | null
        sourceType?: DocumentationsSourceTypeEnum | null
      }
    }>
  }
}

export type DocumentationActionItems_UpdateAssigneeDocumentationReviewMutationVariables = Exact<{
  documentationReviewRunTextId: Scalars['ID']['input']
  assigneeId?: InputMaybe<Scalars['ID']['input']>
}>

export type DocumentationActionItems_UpdateAssigneeDocumentationReviewMutation = {
  __typename?: 'Mutation'
  updateAssigneeDocumentationReview: { __typename?: 'Documentation'; id: string }
}

export type DocumentationContentUpdatedSubscriptionSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type DocumentationContentUpdatedSubscriptionSubscription = {
  __typename?: 'Subscription'
  documentationContentUpdated: {
    __typename?: 'DocumentationContentUpdatedPayload'
    objId: string
    updatedDocumentationText: string
    responseAcknowledgingUsersInstruction: string
  }
}

export type DocumentationEditMode_AddNewContentToDocumentationMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  instruction: Scalars['String']['input']
}>

export type DocumentationEditMode_AddNewContentToDocumentationMutation = {
  __typename?: 'Mutation'
  addNewContentToDocumentation: { __typename?: 'Documentation'; id: string }
}

export type DocumentationEditMode_RephraseContentDocumentationMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  instruction: Scalars['String']['input']
}>

export type DocumentationEditMode_RephraseContentDocumentationMutation = {
  __typename?: 'Mutation'
  rephraseContentDocumentation: { __typename?: 'Documentation'; id: string }
}

export type DocumentationEditMode_AcceptNewContentToDocumentationMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  updatedDocumentationText: Scalars['String']['input']
}>

export type DocumentationEditMode_AcceptNewContentToDocumentationMutation = {
  __typename?: 'Mutation'
  acceptNewContentDocumentation: { __typename?: 'Documentation'; id: string }
}

export type DocumentationList_AllDocumentationQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  needsReview?: InputMaybe<Scalars['Boolean']['input']>
  sourceType?: InputMaybe<DocumentationsSourceTypeEnum>
  source?: InputMaybe<DocumentationsSourceEnum>
  archivedInSolo?: InputMaybe<Scalars['Boolean']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  documentationProjectIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  sortBy?: InputMaybe<DocumentationSortByEnum>
  sortByDirection?: InputMaybe<SortByDirectionEnum>
}>

export type DocumentationList_AllDocumentationQuery = {
  __typename?: 'Query'
  paginatedDocumentations?: {
    __typename?: 'PaginatedDocumentations'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'Documentation'
      id: string
      topic: string
      lastUpdatedAt?: any | null
      needsReview: boolean
      url?: string | null
      helpCenterName?: string | null
      authorName?: string | null
      isPublished: boolean
      sourceType?: DocumentationsSourceTypeEnum | null
      source: DocumentationsSourceEnum
      parentCollectionName?: string | null
      hasDraft: boolean
      isTranslated?: boolean | null
      numPendingDocumentationReviewRunTextsNotSnoozed: number
      activeDocumentationProjects: Array<{
        __typename?: 'DocumentationProject'
        id: string
        name: string
      }>
    }>
  } | null
}

export type DocumentationTasks_PaginatedSuccessfulCoverageQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  startDate: Scalars['ISO8601DateTime']['input']
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}>

export type DocumentationTasks_PaginatedSuccessfulCoverageQuery = {
  __typename?: 'Query'
  paginatedSuccessfulCoverage?: {
    __typename?: 'PaginatedSuccessfulCoverage'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'SuccessfulCoverageRow'
      uniqueConversationCount: number
      uniqueConversationSourceTypes: Array<string>
      topic: { __typename?: 'ExternalTopic'; id: string; archived: boolean; topic: string }
      subtopic: { __typename?: 'ExternalSubtopic'; id: string; archived: boolean; subtopic: string }
      documentation?: { __typename?: 'Documentation'; id: string } | null
    }>
  } | null
}

export type DocumentationTasks_PaginatedOpportunityThemesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}>

export type DocumentationTasks_PaginatedOpportunityThemesQuery = {
  __typename?: 'Query'
  paginatedOpportunityThemes?: {
    __typename?: 'PaginatedOpportunityThemes'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'OpportunityTheme'
      id: string
      themeDescription?: string | null
      numUniqueExternalCustomerQuestions: number
      uniqueSourceTypes: Array<string>
      externalTopic: {
        __typename?: 'ExternalTopic'
        id: string
        archived: boolean
        topic: string
        documentation?: { __typename?: 'Documentation'; id: string } | null
      }
      externalSubtopic?: {
        __typename?: 'ExternalSubtopic'
        id: string
        archived: boolean
        subtopic: string
      } | null
    }>
  } | null
}

export type Coverage_ArchiveOpportunityThemeMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type Coverage_ArchiveOpportunityThemeMutation = {
  __typename?: 'Mutation'
  archiveOpportunityTheme: string
}

export type Coverage_RestoreExternallyOpportunityThemeMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type Coverage_RestoreExternallyOpportunityThemeMutation = {
  __typename?: 'Mutation'
  resolveExternallyOpportunityTheme: string
}

export type DocumentationImages_FlowsQueryVariables = Exact<{ [key: string]: never }>

export type DocumentationImages_FlowsQuery = {
  __typename?: 'Query'
  loginFlows: Array<{
    __typename?: 'BrowserFlow'
    id: string
    name?: string | null
    updatedAt: any
    browserFlowRuns: Array<{
      __typename?: 'BrowserFlowRun'
      createdAt: any
      status: string
      imageUrl?: string | null
      sessionReplayUrl?: string | null
    }>
  }>
  imageFlows: Array<{
    __typename?: 'ImageFlow'
    id: string
    imageSource: string
    updatedAt: any
    browserFlow: {
      __typename?: 'BrowserFlow'
      browserFlowRuns: Array<{
        __typename?: 'BrowserFlowRun'
        createdAt: any
        imageUrl?: string | null
      }>
    }
  }>
}

export type DocumentationProjects_PaginatedDocumentationProjectsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
}>

export type DocumentationProjects_PaginatedDocumentationProjectsQuery = {
  __typename?: 'Query'
  paginatedDocumentationProjects?: {
    __typename?: 'PaginatedDocumentationProjects'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'DocumentationProject'
      id: string
      createdAt: any
      status: DocumentationProjectStatusType
      name: string
      description?: string | null
      numPendingDocumentationReviewRunTexts: number
      numDocumentation: number
      user: { __typename?: 'Users'; firstName?: string | null; lastName?: string | null }
    }>
  } | null
}

export type DocumentationProjects_ArchiveDocumentationProjectMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DocumentationProjects_ArchiveDocumentationProjectMutation = {
  __typename?: 'Mutation'
  archiveDocumentationProject: string
}

export type DocumentationTasks_PaginatedDocumentationTasksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type DocumentationTasks_PaginatedDocumentationTasksQuery = {
  __typename?: 'Query'
  paginatedDocumentationTasks?: {
    __typename?: 'PaginatedDocumentationTasks'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'DocumentationTask'
      id: string
      createdAt: any
      status: DocumentationTaskStatusType
      name: string
      description?: string | null
      numPendingDocumentationReviewRunTexts: number
      user?: { __typename?: 'Users'; firstName?: string | null; lastName?: string | null } | null
    }>
  } | null
}

export type DocumentationTasks_ArchiveDocumentationTaskMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DocumentationTasks_ArchiveDocumentationTaskMutation = {
  __typename?: 'Mutation'
  archiveDocumentationTask: { __typename?: 'DocumentationTask'; id: string }
}

export type DocumentationTasks_DocumentationTaskQueryVariables = Exact<{
  documentationTaskId: Scalars['ID']['input']
}>

export type DocumentationTasks_DocumentationTaskQuery = {
  __typename?: 'Query'
  documentationTask?: {
    __typename?: 'DocumentationTask'
    id: string
    name: string
    status: DocumentationTaskStatusType
    numPendingDocumentationReviewRunTexts: number
    numAllDocumentationReviewRunTexts: number
    documentationTaskSummaries: Array<{
      __typename?: 'DocumentationTaskSummary'
      id: string
      summary: string
      numPendingDocumentationReviewRunTexts: number
      documentation: { __typename?: 'Documentation'; id: string; topic: string }
    }>
  } | null
}

export type DocumentationPreview_GetDocumentationPreviewQueryVariables = Exact<{
  documentationUniqueId: Scalars['ID']['input']
}>

export type DocumentationPreview_GetDocumentationPreviewQuery = {
  __typename?: 'Query'
  documentationPreview?: {
    __typename?: 'Documentation'
    id: string
    uniqueId?: string | null
    topic: string
    instruction?: string | null
    content?: string | null
    externalContent?: string | null
    externalContentType?: string | null
    url?: string | null
    editUrl?: string | null
    sourceType?: DocumentationsSourceTypeEnum | null
    source: DocumentationsSourceEnum
    externalPageId?: string | null
    hasDraft: boolean
    documentationCssString?: string | null
  } | null
}

export type Integration_RepositoriesQueryVariables = Exact<{ [key: string]: never }>

export type Integration_RepositoriesQuery = {
  __typename?: 'Query'
  repositories: Array<{
    __typename?: 'Repository'
    id: string
    repoName: string
    shaIndexed?: string | null
  }>
}

export type Integration_ExistingSlackChannelsQueryVariables = Exact<{
  externalIntegrationId: Scalars['ID']['input']
  searchQuery?: InputMaybe<Scalars['String']['input']>
}>

export type Integration_ExistingSlackChannelsQuery = {
  __typename?: 'Query'
  externalSlackChannels: Array<{ __typename?: 'ExternalSlack'; id: string; name: string }>
}

export type Integration_AllIntegrationsQueryVariables = Exact<{
  externalIntegrationId: Scalars['ID']['input']
}>

export type Integration_AllIntegrationsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    business: { __typename?: 'Business'; availableChatSources: Array<AnswerTypeEnum> }
  }
  externalIntegrations: Array<{
    __typename?: 'ExternalIntegration'
    id: string
    externalBusinessName: string
    externalIntegrationType: string
    slackChannelConfigurations: Array<{
      __typename?: 'SlackConfiguration'
      id: string
      channelName: string
      repoNames: Array<string>
      chatSources: Array<AnswerTypeEnum>
    }>
  }>
}

export type Integration_CreateSlackChannelConfigurationMutationVariables = Exact<{
  externalIntegrationId: Scalars['ID']['input']
  channelName: Scalars['String']['input']
  channelId: Scalars['String']['input']
  repoNames: Array<Scalars['String']['input']> | Scalars['String']['input']
  showCodeSources: Scalars['Boolean']['input']
  showExpert: Scalars['Boolean']['input']
  succinctMode: Scalars['Boolean']['input']
  showVerifyAnswer: Scalars['Boolean']['input']
  chatSources?: InputMaybe<Array<AnswerTypeEnum> | AnswerTypeEnum>
}>

export type Integration_CreateSlackChannelConfigurationMutation = {
  __typename?: 'Mutation'
  createSlackChannelConfiguration: { __typename?: 'SlackConfiguration'; id: string }
}

export type Integration_DisconnectSlackExternalIntegrationMutationVariables = Exact<{
  externalIntegrationId: Scalars['ID']['input']
}>

export type Integration_DisconnectSlackExternalIntegrationMutation = {
  __typename?: 'Mutation'
  disconnectSlackExternalIntegration: string
}

export type BitbucketBranchPicker_GetRepositoriesQueryVariables = Exact<{ [key: string]: never }>

export type BitbucketBranchPicker_GetRepositoriesQuery = {
  __typename?: 'Query'
  repositories: Array<{
    __typename?: 'Repository'
    id: string
    repoName: string
    branchName?: string | null
  }>
}

export type BitBucketBranchPicker_UpdateRepositoryMutationVariables = Exact<{
  attributes: Array<RepositoryInputObject> | RepositoryInputObject
}>

export type BitBucketBranchPicker_UpdateRepositoryMutation = {
  __typename?: 'Mutation'
  updateRepository: string
}

export type IntegrationsList_AllIntegrationsQueryVariables = Exact<{ [key: string]: never }>

export type IntegrationsList_AllIntegrationsQuery = {
  __typename?: 'Query'
  externalIntegrations: Array<{
    __typename?: 'ExternalIntegration'
    externalBusinessName: string
    externalIntegrationType: string
    id: string
  }>
}

export type IntegrationBitbucketExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationBitbucketExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createBitbucketExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type IntegrationConfluenceExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationConfluenceExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createConfluenceExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type IntegrationFrontExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationFrontExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createFrontExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type IntegrationGithubDocsExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
  installationId: Scalars['String']['input']
}>

export type IntegrationGithubDocsExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createGithubDocsExternalIntegration?: { __typename?: 'ExternalIntegration'; id: string } | null
}

export type IntegrationGithubExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
  installationId: Scalars['String']['input']
}>

export type IntegrationGithubExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createGithubExternalIntegration?: { __typename?: 'ExternalIntegration'; id: string } | null
}

export type IntegrationGitlabExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationGitlabExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createGitlabExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type IntegrationHubspotExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationHubspotExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createHubspotExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type IntegrationIntercomExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationIntercomExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createIntercomExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type IntegrationJiraExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationJiraExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createJiraExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type IntegrationLaunchdarklyExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationLaunchdarklyExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createLaunchdarklyExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type IntegrationLinearExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationLinearExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createLinearExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type IntegrationNotionExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationNotionExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createNotionExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type IntegrationPendoMcpExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
  state: Scalars['String']['input']
}>

export type IntegrationPendoMcpExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createPendoMcpIntegration: { __typename?: 'Business'; id: string; pendoConnected: boolean }
}

export type IntegrationZendeskExchange_ExchangeCodeMutationVariables = Exact<{
  code: Scalars['String']['input']
}>

export type IntegrationZendeskExchange_ExchangeCodeMutation = {
  __typename?: 'Mutation'
  createZendeskExternalIntegration: { __typename?: 'ExternalIntegration'; id: string }
}

export type GithubBranchPicker_GetRepositoriesQueryVariables = Exact<{
  installationId: Scalars['String']['input']
}>

export type GithubBranchPicker_GetRepositoriesQuery = {
  __typename?: 'Query'
  getRepoNamesByInstallationId: Array<{ __typename?: 'Repository'; id: string; repoName: string }>
}

export type GithubBranchPicker_UpdateRepositoryMutationVariables = Exact<{
  attributes: Array<RepositoryInputObject> | RepositoryInputObject
}>

export type GithubBranchPicker_UpdateRepositoryMutation = {
  __typename?: 'Mutation'
  updateRepository: string
}

export type GithubDocsBranchPicker_GetRepositoriesQueryVariables = Exact<{
  installationId: Scalars['String']['input']
}>

export type GithubDocsBranchPicker_GetRepositoriesQuery = {
  __typename?: 'Query'
  getDocumentationRepoNamesByInstallationId: Array<{
    __typename?: 'Repository'
    id: string
    repoName: string
  }>
}

export type GithubDocsBranchPicker_UpdateRepositoryMutationVariables = Exact<{
  attributes: Array<RepositoryInputObject> | RepositoryInputObject
}>

export type GithubDocsBranchPicker_UpdateRepositoryMutation = {
  __typename?: 'Mutation'
  updateDocumentationRepo: string
}

export type GitlabBranchPicker_GetRepositoriesQueryVariables = Exact<{ [key: string]: never }>

export type GitlabBranchPicker_GetRepositoriesQuery = {
  __typename?: 'Query'
  repositories: Array<{
    __typename?: 'Repository'
    id: string
    repoName: string
    branchName?: string | null
  }>
}

export type GitlabBranchPicker_UpdateRepositoryMutationVariables = Exact<{
  attributes: Array<RepositoryInputObject> | RepositoryInputObject
}>

export type GitlabBranchPicker_UpdateRepositoryMutation = {
  __typename?: 'Mutation'
  updateRepository: string
}

export type Question_GetQuestionQueryVariables = Exact<{
  questionId: Scalars['ID']['input']
}>

export type Question_GetQuestionQuery = {
  __typename?: 'Query'
  question?: {
    __typename?: 'Answer'
    id: string
    question: string
    prettifiedQuestion: string
    answer: string
  } | null
}

export type QuestionsList_QuestionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}>

export type QuestionsList_QuestionsQuery = {
  __typename?: 'Query'
  paginatedQuestions?: {
    __typename?: 'PaginatedAnswers'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'Answer'
      id: string
      createdAt: any
      externalUserName?: string | null
      question: string
      prettifiedQuestion: string
      answer: string
      isDirectMessage: boolean
      markedUnhelpful: boolean
    }>
  } | null
}

export type ReleaseNote_GetTypedReleaseNoteQueryVariables = Exact<{
  typedReleaseNoteId: Scalars['ID']['input']
}>

export type ReleaseNote_GetTypedReleaseNoteQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    business: {
      __typename?: 'Business'
      id: string
      notionConnected: boolean
      activeReleaseNoteLabels?: Array<{
        __typename?: 'ReleaseNoteLabel'
        id: string
        name: string
      }> | null
    }
  }
  typedReleaseNote: {
    __typename?: 'TypedReleaseNote'
    id: string
    scheduleName?: string | null
    startDate: any
    endDate: any
    htmlText?: string | null
    markdownText: string
    markdownTextGroupedByLabel: string
    markdownTextForSlack: string
    markdownTextForSlackGroupedByLabel: string
    hasApprovedUsersIds: Array<string>
    approversUserIds: Array<string>
    hasBeenPublished: boolean
    markdownTextGroupedByLabelArray: Array<{
      __typename?: 'MarkdownTextLabel'
      labelName: string
      labelText: string
    }>
    markdownTextForSlackGroupedByLabelArray: Array<{
      __typename?: 'MarkdownTextLabel'
      labelName: string
      labelText: string
    }>
    releaseNoteItems: Array<{
      __typename?: 'TypedReleaseNoteItem'
      id: string
      summarizedTitle?: string | null
      change?: string | null
      whyItMatters?: string | null
      sourceLinks: Array<string>
      sourceLinkAuthors: Array<string | null>
      position: number
      featureFlags: Array<string>
      showMobileReleaseUx: boolean
      numPendingDocumentationReviewRunTexts: number
      processedRelatedDocumentation: boolean
      isCoveredByDoc: boolean
      relatedDocumentations: Array<{
        __typename?: 'Documentation'
        id: string
        topic: string
        url?: string | null
      }>
      documentationsCoveringFeature: Array<{
        __typename?: 'Documentation'
        id: string
        topic: string
        url?: string | null
      }>
      externalTaskIssues: Array<{
        __typename?: 'ExternalTaskIssue'
        id: string
        externalIdentifier: string
        sourceType: ExternalTaskIssueSourceTypeEnum
        url: string
      }>
      releaseNoteLabels: Array<{ __typename?: 'ReleaseNoteLabel'; id: string; name: string }>
      documentationProjects: Array<{
        __typename?: 'DocumentationProject'
        id: string
        name: string
      }>
      releaseNoteItemImagesAndVideosJson: Array<{
        __typename?: 'TypedReleaseNoteAttachment'
        id: string
        url: string
        contentType: string
      }>
      releaseNoteItemComments: Array<{
        __typename?: 'ReleaseNoteItemComment'
        id: string
        createdAt: any
        comment: string
        user: {
          __typename?: 'Users'
          id: string
          email: string
          firstName?: string | null
          lastName?: string | null
        }
      }>
    }>
  }
}

export type ReleaseNote_GetFeatureFlagInfoQueryVariables = Exact<{ [key: string]: never }>

export type ReleaseNote_GetFeatureFlagInfoQuery = {
  __typename?: 'Query'
  getFeatureFlagInfo: {
    __typename?: 'FeatureFlagsInfo'
    fullyOnFeatureFlags: Array<string>
    partiallyOnFeatureFlags: Array<string>
    notFullyOnFeatureFlags: Array<string>
  }
}

export type ReleaseNote_GenerateTypedReleaseNotesMutationVariables = Exact<{
  typedReleaseNoteId: Scalars['ID']['input']
}>

export type ReleaseNote_GenerateTypedReleaseNotesMutation = {
  __typename?: 'Mutation'
  generateTypedReleaseNote: { __typename?: 'TypedReleaseNote'; id: string }
}

export type ReleaseNote_UpdateTypedReleaseNotesItemMutationVariables = Exact<{
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemInput: ReleaseNoteItemInputObject
}>

export type ReleaseNote_UpdateTypedReleaseNotesItemMutation = {
  __typename?: 'Mutation'
  updateReleaseNoteItem: { __typename?: 'TypedReleaseNoteItem'; id: string }
}

export type ReleaseNote_DeleteTypedReleaseNotesItemMutationVariables = Exact<{
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemId: Scalars['ID']['input']
}>

export type ReleaseNote_DeleteTypedReleaseNotesItemMutation = {
  __typename?: 'Mutation'
  deleteReleaseNoteItem: { __typename?: 'TypedReleaseNote'; id: string }
}

export type ReleaseNote_DeleteReleaseNoteItemsMutationVariables = Exact<{
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type ReleaseNote_DeleteReleaseNoteItemsMutation = {
  __typename?: 'Mutation'
  deleteReleaseNoteItems: { __typename?: 'TypedReleaseNote'; id: string }
}

export type ReleaseNote_RemoveReleaseNoteItemAttachmentMutationVariables = Exact<{
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemId: Scalars['ID']['input']
  attachmentId: Scalars['ID']['input']
}>

export type ReleaseNote_RemoveReleaseNoteItemAttachmentMutation = {
  __typename?: 'Mutation'
  removeReleaseNoteItemAttachment: { __typename?: 'TypedReleaseNote'; id: string }
}

export type ReleaseNote_ManuallyAddReleaseNoteItemMutationVariables = Exact<{
  releaseNoteId: Scalars['ID']['input']
}>

export type ReleaseNote_ManuallyAddReleaseNoteItemMutation = {
  __typename?: 'Mutation'
  manuallyAddReleaseNoteItem: { __typename?: 'TypedReleaseNoteItem'; id: string }
}

export type ReleaseNote_ExportToCsvMutationVariables = Exact<{
  typedReleaseNoteId: Scalars['ID']['input']
}>

export type ReleaseNote_ExportToCsvMutation = {
  __typename?: 'Mutation'
  exportReleaseNotesToCsv?: string | null
}

export type ReleaseNote_ApproveReleaseNoteMutationVariables = Exact<{
  typedReleaseNoteId: Scalars['ID']['input']
}>

export type ReleaseNote_ApproveReleaseNoteMutation = {
  __typename?: 'Mutation'
  approveReleaseNote: { __typename?: 'TypedReleaseNote'; id: string }
}

export type ReleaseNote_ForcePublishReleaseNoteMutationVariables = Exact<{
  typedReleaseNoteId: Scalars['ID']['input']
}>

export type ReleaseNote_ForcePublishReleaseNoteMutation = {
  __typename?: 'Mutation'
  approveReleaseNote: { __typename?: 'TypedReleaseNote'; id: string }
}

export type ReleaseNote_ReorderTypedReleaseNotesItemMutationVariables = Exact<{
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemPositionInputs:
    | Array<ReleaseNoteItemPositionInputObject>
    | ReleaseNoteItemPositionInputObject
}>

export type ReleaseNote_ReorderTypedReleaseNotesItemMutation = {
  __typename?: 'Mutation'
  reorderReleaseNoteItems: string
}

export type ReleaseNote_UpdateHtmlTextMutationVariables = Exact<{
  typedReleaseNoteId: Scalars['ID']['input']
  htmlText: Scalars['String']['input']
}>

export type ReleaseNote_UpdateHtmlTextMutation = {
  __typename?: 'Mutation'
  updateHtmlText: { __typename?: 'TypedReleaseNote'; id: string }
}

export type TypedReleaseNotesSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>

export type TypedReleaseNotesSubscriptionSubscription = {
  __typename?: 'Subscription'
  typedReleaseNotesCreated: { __typename?: 'TypedReleaseNotesCreatedPayload'; objId: string }
}

export type ReleaseNotesList_AllTypedReleaseNotesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  scheduleName?: InputMaybe<Scalars['String']['input']>
}>

export type ReleaseNotesList_AllTypedReleaseNotesQuery = {
  __typename?: 'Query'
  paginatedTypedReleaseNotes?: {
    __typename?: 'PaginatedTypedReleaseNotes'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'TypedReleaseNote'
      id: string
      scheduleName?: string | null
      startDate: any
      endDate: any
    }>
  } | null
}

export type ReleaseNotesList_ReleaseNoteScheduleNamesQueryVariables = Exact<{
  [key: string]: never
}>

export type ReleaseNotesList_ReleaseNoteScheduleNamesQuery = {
  __typename?: 'Query'
  releaseNoteSchedules: Array<{
    __typename?: 'ReleaseNoteSchedule'
    id: string
    scheduleName?: string | null
  }>
}

export type DocumentationsReport_PaginatedDocumentationReportQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  activityTypes?: InputMaybe<Array<UsersActivityTypeEnum> | UsersActivityTypeEnum>
  actionDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>
  actionDateTo?: InputMaybe<Scalars['ISO8601Date']['input']>
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type DocumentationsReport_PaginatedDocumentationReportQuery = {
  __typename?: 'Query'
  paginatedDocumentationReport: {
    __typename?: 'PaginatedDocumentationToReview'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number }
    data: Array<{
      __typename?: 'DocumentationToReview'
      id: string
      createdAt: any
      suggestionType: DocumentationToReviewSuggestionType
      status: DocumentationToReviewStatusEnum
      summarizedChange?: string | null
      userActivity?: {
        __typename?: 'UserActivity'
        id: string
        updatedAt: any
        user: {
          __typename?: 'Users'
          id: string
          firstName?: string | null
          lastName?: string | null
          email: string
        }
      } | null
      documentation: { __typename?: 'Documentation'; id: string; topic: string }
    }>
  }
}

export type Repository_GetRepositoryQueryVariables = Exact<{
  repositoryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type Repository_GetRepositoryQuery = {
  __typename?: 'Query'
  repositories: Array<{
    __typename?: 'Repository'
    id: string
    repoName: string
    branchName?: string | null
    accessToken: string
  }>
}

export type RepositoriesList_AllRepositoriesQueryVariables = Exact<{ [key: string]: never }>

export type RepositoriesList_AllRepositoriesQuery = {
  __typename?: 'Query'
  repositories: Array<{
    __typename?: 'Repository'
    id: string
    repoName: string
    branchName?: string | null
    shaIndexed?: string | null
  }>
}

export type ForgotPassword_AuthPasswordResetRequestMutationVariables = Exact<{
  email: Scalars['String']['input']
}>

export type ForgotPassword_AuthPasswordResetRequestMutation = {
  __typename?: 'Mutation'
  authPasswordResetRequest: string
}

export type ResetPassword_ResetPasswordAllowedQueryVariables = Exact<{
  resetPasswordToken: Scalars['String']['input']
}>

export type ResetPassword_ResetPasswordAllowedQuery = {
  __typename?: 'Query'
  resetPasswordAllowed: boolean
}

export type ResetPassword_ResetPasswordMutationVariables = Exact<{
  resetPasswordToken: Scalars['String']['input']
  newPassword: Scalars['String']['input']
}>

export type ResetPassword_ResetPasswordMutation = {
  __typename?: 'Mutation'
  authResetPassword: string
}

export type EmailVerify_EmailVerifyAllowedQueryVariables = Exact<{
  emailVerificationCode: Scalars['String']['input']
}>

export type EmailVerify_EmailVerifyAllowedQuery = {
  __typename?: 'Query'
  emailVerifyAllowed?: {
    __typename?: 'Users'
    firstName?: string | null
    lastName?: string | null
    email: string
    emailVerifyFromUrl?: string | null
  } | null
}

export type ActivityLog_UsersActivitiesQueryVariables = Exact<{ [key: string]: never }>

export type ActivityLog_UsersActivitiesQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    usersActivities: Array<{
      __typename?: 'UsersActivity'
      id: string
      createdAt: any
      activityType: UsersActivityTypeEnum
      documentationReviewRunText?: {
        __typename?: 'DocumentationToReview'
        id: string
        documentation: { __typename?: 'Documentation'; id: string; topic: string }
      } | null
      releaseNoteItem?: {
        __typename?: 'TypedReleaseNoteItem'
        id: string
        typedReleaseNote: {
          __typename?: 'TypedReleaseNote'
          id: string
          startDate: any
          endDate: any
        }
      } | null
    }>
  }
}

export type DocumentDisplay_ImageFlowByImageSourceQueryVariables = Exact<{
  imageSource: Scalars['String']['input']
}>

export type DocumentDisplay_ImageFlowByImageSourceQuery = {
  __typename?: 'Query'
  getImageFlowByImageSource?: { __typename?: 'ImageFlow'; id: string; imageSource: string } | null
}

export type IntroCallDialogManager_CompleteOnboardingMutationVariables = Exact<{
  [key: string]: never
}>

export type IntroCallDialogManager_CompleteOnboardingMutation = {
  __typename?: 'Mutation'
  hasSeenDemoScreen: { __typename?: 'Business'; id: string; hasSeenDemoScreen: boolean }
}

export type Navigation_MarkReadUsersActivitiesMutationVariables = Exact<{ [key: string]: never }>

export type Navigation_MarkReadUsersActivitiesMutation = {
  __typename?: 'Mutation'
  markReadUsersActivities: boolean
}

export type UsersUpdateFragment = {
  __typename?: 'Users'
  id: string
  firstName?: string | null
  lastName?: string | null
}

export type AccountSettingsDialog_UserQueryVariables = Exact<{ [key: string]: never }>

export type AccountSettingsDialog_UserQuery = {
  __typename?: 'Query'
  user: { __typename?: 'Users'; id: string; firstName?: string | null; lastName?: string | null }
}

export type AccountSettingsDialog_BusinessQueryVariables = Exact<{ [key: string]: never }>

export type AccountSettingsDialog_BusinessQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    business: {
      __typename?: 'Business'
      id: string
      name: string
      succinctMode?: boolean | null
      showCodeSources: boolean
      showExpert: boolean
      showVerifyAnswer: boolean
      plan: SubscriptionPlanEnum
      enableAutoApproveDocumentation: boolean
      testModeAutoApproveDocumentation: boolean
      autoApprovePrompt?: string | null
      autoApproveFeatureFlag?: AutoApproveFeatureFlagEnum | null
      imageFlowInstructions?: string | null
      releaseNotesVoice?: { __typename?: 'BusinessVoice'; id: string; voice: string } | null
      releaseNotesTemplate?: {
        __typename?: 'BusinessTemplate'
        id: string
        template: string
      } | null
      externalDocumentationVoice?: {
        __typename?: 'BusinessVoice'
        id: string
        voice: string
      } | null
      externalDocumentationTemplate?: {
        __typename?: 'BusinessTemplate'
        id: string
        template: string
      } | null
      users?: Array<{
        __typename?: 'Users'
        id: string
        email: string
        role: UsersRoleEnum
        verified: boolean
        isSuperadmin: boolean
      }> | null
      billingPlans: Array<{
        __typename?: 'BillingPlan'
        id: string
        billingType: BillingTypeEnum
        perUnit: number
      }>
    }
  }
}

export type AccountSettingsDialog_PaymentMethodsQueryVariables = Exact<{ [key: string]: never }>

export type AccountSettingsDialog_PaymentMethodsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    business: {
      __typename?: 'Business'
      paymentMethods?: Array<{
        __typename?: 'PaymentMethod'
        brand?: string | null
        last4?: string | null
        expMonth?: string | null
        expYear?: string | null
      }> | null
    }
  }
}

export type AccountSettingsDialog_UpdateBusinessMutationVariables = Exact<{
  name: Scalars['String']['input']
  showVerifyAnswer?: InputMaybe<Scalars['Boolean']['input']>
  showCodeSources?: InputMaybe<Scalars['Boolean']['input']>
  showExpert?: InputMaybe<Scalars['Boolean']['input']>
  releaseNotesVoice?: InputMaybe<Scalars['String']['input']>
  releaseNotesTemplate?: InputMaybe<Scalars['String']['input']>
  externalDocumentationVoice?: InputMaybe<Scalars['String']['input']>
  externalDocumentationTemplate?: InputMaybe<Scalars['String']['input']>
  imageFlowInstructions?: InputMaybe<Scalars['String']['input']>
  enableAutoApproveDocumentation?: InputMaybe<Scalars['Boolean']['input']>
  testModeAutoApproveDocumentation?: InputMaybe<Scalars['Boolean']['input']>
  autoApprovePrompt?: InputMaybe<Scalars['String']['input']>
  autoApproveFeatureFlag?: InputMaybe<AutoApproveFeatureFlagEnum>
}>

export type AccountSettingsDialog_UpdateBusinessMutation = {
  __typename?: 'Mutation'
  updateBusiness: {
    __typename?: 'Business'
    id: string
    name: string
    succinctMode?: boolean | null
    showCodeSources: boolean
    showExpert: boolean
    imageFlowInstructions?: string | null
    enableAutoApproveDocumentation: boolean
    testModeAutoApproveDocumentation: boolean
    autoApprovePrompt?: string | null
    autoApproveFeatureFlag?: AutoApproveFeatureFlagEnum | null
    releaseNotesVoice?: { __typename?: 'BusinessVoice'; id: string; voice: string } | null
    releaseNotesTemplate?: { __typename?: 'BusinessTemplate'; id: string; template: string } | null
    externalDocumentationVoice?: { __typename?: 'BusinessVoice'; id: string; voice: string } | null
    externalDocumentationTemplate?: {
      __typename?: 'BusinessTemplate'
      id: string
      template: string
    } | null
  }
}

export type AccountSettingsDialog_UserChangeRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input']
  role: UsersRoleEnum
}>

export type AccountSettingsDialog_UserChangeRoleMutation = {
  __typename?: 'Mutation'
  userChangeRole?: { __typename?: 'Users'; id: string; role: UsersRoleEnum } | null
}

export type AccountSettingsDialog_UserRemoveMutationVariables = Exact<{
  userId: Scalars['ID']['input']
}>

export type AccountSettingsDialog_UserRemoveMutation = {
  __typename?: 'Mutation'
  userRemove?: boolean | null
}

export type AccountSettingsDialog_IntercomManualSyncMutationVariables = Exact<{
  [key: string]: never
}>

export type AccountSettingsDialog_IntercomManualSyncMutation = {
  __typename?: 'Mutation'
  intercomManualSync: string
}

export type AccountSettingsDialog_ZendeskManualSyncMutationVariables = Exact<{
  [key: string]: never
}>

export type AccountSettingsDialog_ZendeskManualSyncMutation = {
  __typename?: 'Mutation'
  zendeskManualSync: string
}

export type AccountSettingsDialog_InviteTeamMemberMutationVariables = Exact<{
  email: Scalars['String']['input']
  role?: InputMaybe<UsersRoleEnum>
}>

export type AccountSettingsDialog_InviteTeamMemberMutation = {
  __typename?: 'Mutation'
  userInvite?: { __typename?: 'Users'; id: string } | null
}

export type AccountSettingsDialog_UpdateZendeskSubdomainMutationVariables = Exact<{
  zendeskSubdomain: Scalars['String']['input']
}>

export type AccountSettingsDialog_UpdateZendeskSubdomainMutation = {
  __typename?: 'Mutation'
  updateZendeskSubdomain: { __typename?: 'Business'; id: string }
}

export type AccountSettingsDialog_UpdateUserMutationVariables = Exact<{
  attributes: UsersInputObject
}>

export type AccountSettingsDialog_UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'Users'
    id: string
    firstName?: string | null
    lastName?: string | null
  }
}

export type AccountSettingsDialog_PaymentCollectMutationVariables = Exact<{ [key: string]: never }>

export type AccountSettingsDialog_PaymentCollectMutation = {
  __typename?: 'Mutation'
  paymentsCollect: string
}

export type AccountSettingsDialog_BillingPortalUrlMutationVariables = Exact<{
  [key: string]: never
}>

export type AccountSettingsDialog_BillingPortalUrlMutation = {
  __typename?: 'Mutation'
  billingPortalUrl: string
}

export type AccountSettingsDialog_BeginPendoMcpIntegrationMutationVariables = Exact<{
  [key: string]: never
}>

export type AccountSettingsDialog_BeginPendoMcpIntegrationMutation = {
  __typename?: 'Mutation'
  beginPendoMcpIntegration: string
}

export type DocumentationUploadFileDialog_UploadFileMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  uploadSignedId: Scalars['ID']['input']
}>

export type DocumentationUploadFileDialog_UploadFileMutation = {
  __typename?: 'Mutation'
  uploadDocumentationFiles: { __typename?: 'Documentation'; id: string }
}

export type DocumentationVersionDialog_DocumentationVersionsQueryVariables = Exact<{
  documentationId: Scalars['ID']['input']
}>

export type DocumentationVersionDialog_DocumentationVersionsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    business: { __typename?: 'Business'; documentationCssString?: string | null }
  }
  documentations: Array<{
    __typename?: 'Documentation'
    id: string
    sourceType?: DocumentationsSourceTypeEnum | null
  }>
  documentationVersions: Array<{
    __typename?: 'DocumentationVersion'
    id: string
    createdAt: any
    content: string
    user?: {
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    } | null
  }>
}

export type DocumentationVersionDialog_UpdateContentMutationVariables = Exact<{
  documentationId: Scalars['ID']['input']
  content: Scalars['String']['input']
}>

export type DocumentationVersionDialog_UpdateContentMutation = {
  __typename?: 'Mutation'
  updateDocumentationContent: { __typename?: 'Documentation'; id: string }
}

export type LinkDocumentationReviewToNewExternalTaskIssueDialog_SearchExternalTaskIssuesQueryVariables =
  Exact<{
    query: Scalars['String']['input']
  }>

export type LinkDocumentationReviewToNewExternalTaskIssueDialog_SearchExternalTaskIssuesQuery = {
  __typename?: 'Query'
  searchExternalTaskIssues: Array<{
    __typename?: 'ExternalTaskIssue'
    id: string
    externalIdentifier: string
    sourceType: ExternalTaskIssueSourceTypeEnum
    name: string
  }>
}

export type LinkDocumentationReviewToNewExternalTaskIssueDialog_LinkDocumentationReviewToExistingExternalTaskIssuesMutationVariables =
  Exact<{
    documentationReviewRunTextId: Scalars['ID']['input']
    externalTaskIssueIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  }>

export type LinkDocumentationReviewToNewExternalTaskIssueDialog_LinkDocumentationReviewToExistingExternalTaskIssuesMutation =
  {
    __typename?: 'Mutation'
    linkDocumentationReviewToExistingExternalTaskIssues: {
      __typename?: 'Documentation'
      id: string
    }
  }

export type NewDocumentationDialog_CreateDocumentationMutationVariables = Exact<{
  topic: Scalars['String']['input']
  instruction?: InputMaybe<Scalars['String']['input']>
  uploadSignedIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  sections?: InputMaybe<Scalars['String']['input']>
  repoNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  manuallyWrite?: InputMaybe<Scalars['Boolean']['input']>
}>

export type NewDocumentationDialog_CreateDocumentationMutation = {
  __typename?: 'Mutation'
  createDocumentation: { __typename?: 'Documentation'; id: string }
}

export type NewDocumentationDialog_RepositoriesQueryVariables = Exact<{ [key: string]: never }>

export type NewDocumentationDialog_RepositoriesQuery = {
  __typename?: 'Query'
  repositories: Array<{
    __typename?: 'Repository'
    id: string
    repoName: string
    shaIndexed?: string | null
  }>
}

export type NewDocumentationProjectDialog_CreateDocumentationProjectMutationVariables = Exact<{
  name: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  uploadSignedIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  projectLinks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  knowledgeBaseAudit?: InputMaybe<Scalars['Boolean']['input']>
}>

export type NewDocumentationProjectDialog_CreateDocumentationProjectMutation = {
  __typename?: 'Mutation'
  createDocumentationProject: { __typename?: 'DocumentationProject'; id: string }
}

export type NewDocumentationProjectDialog_UpdateDocumentationProjectMutationVariables = Exact<{
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  description: Scalars['String']['input']
  uploadSignedIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  existingBlobIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  projectLinks: Array<Scalars['String']['input']> | Scalars['String']['input']
  knowledgeBaseAudit?: InputMaybe<Scalars['Boolean']['input']>
}>

export type NewDocumentationProjectDialog_UpdateDocumentationProjectMutation = {
  __typename?: 'Mutation'
  updateDocumentationProject: { __typename?: 'DocumentationProject'; id: string }
}

export type NewDocumentationProjectDialog_FindDocumentationForProjectsMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type NewDocumentationProjectDialog_FindDocumentationForProjectsMutation = {
  __typename?: 'Mutation'
  findDocumentationForProjects: string
}

export type NewDocumentationProjectDialog_UpdateDocumentationManuallyForProjectMutationVariables =
  Exact<{
    id: Scalars['ID']['input']
    documentationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  }>

export type NewDocumentationProjectDialog_UpdateDocumentationManuallyForProjectMutation = {
  __typename?: 'Mutation'
  updateDocumentationManuallyForProject: { __typename?: 'DocumentationProject'; id: string }
}

export type NewDocumentationProjectDialog_SearchDocumentationsQueryVariables = Exact<{
  query: Scalars['String']['input']
}>

export type NewDocumentationProjectDialog_SearchDocumentationsQuery = {
  __typename?: 'Query'
  searchDocumentations: Array<{ __typename?: 'Documentation'; id: string; topic: string }>
}

export type NewDocumentationProjectDialog_DocumentationProjectQueryVariables = Exact<{
  documentationProjectId: Scalars['ID']['input']
}>

export type NewDocumentationProjectDialog_DocumentationProjectQuery = {
  __typename?: 'Query'
  documentationProject?: {
    __typename?: 'DocumentationProject'
    id: string
    name: string
    description?: string | null
    projectLinks: Array<string>
    knowledgeBaseAudit: boolean
    documentationFilesJson: Array<{
      __typename?: 'DocumentationProjectAttachment'
      id: string
      name: string
      url: string
      contentType: string
    }>
    documentations: Array<{ __typename?: 'Documentation'; id: string; topic: string }>
  } | null
}

export type DocumentationAttachedToProjectSubscriptionSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type DocumentationAttachedToProjectSubscriptionSubscription = {
  __typename?: 'Subscription'
  documentationAttachedToProject: {
    __typename?: 'DocumentationAttachedToProjectPayload'
    documentationProjectId: string
  }
}

export type NewDocumentationTaskDialog_CreateDocumentationTaskMutationVariables = Exact<{
  name: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  uploadSignedIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
  taskLinks?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  pullFromCodebase?: InputMaybe<Scalars['Boolean']['input']>
  documentationId?: InputMaybe<Scalars['ID']['input']>
  releaseNoteItemId?: InputMaybe<Scalars['ID']['input']>
}>

export type NewDocumentationTaskDialog_CreateDocumentationTaskMutation = {
  __typename?: 'Mutation'
  createDocumentationTask: { __typename?: 'DocumentationTask'; id: string }
}

export type NewDocumentationTaskDialog_UpdateDocumentationTaskMutationVariables = Exact<{
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  description: Scalars['String']['input']
  uploadSignedIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  existingBlobIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
  taskLinks: Array<Scalars['String']['input']> | Scalars['String']['input']
  pullFromCodebase?: InputMaybe<Scalars['Boolean']['input']>
  documentationId?: InputMaybe<Scalars['ID']['input']>
}>

export type NewDocumentationTaskDialog_UpdateDocumentationTaskMutation = {
  __typename?: 'Mutation'
  updateDocumentationTask: { __typename?: 'DocumentationTask'; id: string }
}

export type NewDocumentationTaskDialog_FindDocumentationForTaskMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type NewDocumentationTaskDialog_FindDocumentationForTaskMutation = {
  __typename?: 'Mutation'
  findDocumentationForTask: string
}

export type NewDocumentationTaskDialog_ArchiveDocumentationTaskMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type NewDocumentationTaskDialog_ArchiveDocumentationTaskMutation = {
  __typename?: 'Mutation'
  archiveDocumentationTask: { __typename?: 'DocumentationTask'; id: string }
}

export type NewDocumentationTaskDialog_UpdateDocumentationManuallyAndRunTaskMutationVariables =
  Exact<{
    id: Scalars['ID']['input']
    documentationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
    rerunTask?: InputMaybe<Scalars['Boolean']['input']>
  }>

export type NewDocumentationTaskDialog_UpdateDocumentationManuallyAndRunTaskMutation = {
  __typename?: 'Mutation'
  updateDocumentationManuallyAndRunTask: { __typename?: 'DocumentationTask'; id: string }
}

export type NewDocumentationTaskDialog_SearchDocumentationsQueryVariables = Exact<{
  query: Scalars['String']['input']
}>

export type NewDocumentationTaskDialog_SearchDocumentationsQuery = {
  __typename?: 'Query'
  searchDocumentations: Array<{ __typename?: 'Documentation'; id: string; topic: string }>
}

export type NewDocumentationTaskDialog_DocumentationTaskQueryVariables = Exact<{
  documentationTaskId: Scalars['ID']['input']
}>

export type NewDocumentationTaskDialog_DocumentationTaskQuery = {
  __typename?: 'Query'
  documentationTask?: {
    __typename?: 'DocumentationTask'
    id: string
    name: string
    description?: string | null
    taskLinks: Array<string>
    pullFromCodebase: boolean
    documentationTaskFilesJson: Array<{
      __typename?: 'DocumentationTaskAttachment'
      id: string
      name: string
      url: string
      contentType: string
    }>
    documentations: Array<{ __typename?: 'Documentation'; id: string; topic: string }>
  } | null
}

export type DocumentationAttachedToTaskSubscriptionSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type DocumentationAttachedToTaskSubscriptionSubscription = {
  __typename?: 'Subscription'
  documentationAttachedToTask: {
    __typename?: 'DocumentationAttachedToTaskPayload'
    documentationTaskId: string
  }
}

export type NewRepositoryDialog_CreateRepositoryMutationVariables = Exact<{
  repoName: Scalars['String']['input']
  branchName: Scalars['String']['input']
  accessToken: Scalars['String']['input']
}>

export type NewRepositoryDialog_CreateRepositoryMutation = {
  __typename?: 'Mutation'
  createRepository: { __typename?: 'Repository'; id: string }
}

export type NewTypedReleaseNoteDialog_CreateTypedReleaseNoteMutationVariables = Exact<{
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}>

export type NewTypedReleaseNoteDialog_CreateTypedReleaseNoteMutation = {
  __typename?: 'Mutation'
  manuallyCreateTypedReleaseNote: { __typename?: 'TypedReleaseNote'; id: string }
}

export type PublishDocumentationDialog_DocumentationQueryVariables = Exact<{ [key: string]: never }>

export type PublishDocumentationDialog_DocumentationQuery = {
  __typename?: 'Query'
  documentations: Array<{
    __typename?: 'Documentation'
    id: string
    topic: string
    externalPageId?: string | null
    sourceType?: DocumentationsSourceTypeEnum | null
  }>
}

export type PublishDocumentationDialog_IntercomCollectionsQueryVariables = Exact<{
  [key: string]: never
}>

export type PublishDocumentationDialog_IntercomCollectionsQuery = {
  __typename?: 'Query'
  intercomGetCollections?: Array<{
    __typename?: 'IntercomExternalCollection'
    id?: string | null
    name?: string | null
  }> | null
}

export type PublishDocumentationDialog_HelpScoutCollectionsQueryVariables = Exact<{
  [key: string]: never
}>

export type PublishDocumentationDialog_HelpScoutCollectionsQuery = {
  __typename?: 'Query'
  helpScoutGetCollections?: Array<{
    __typename?: 'HelpScoutExternalCollection'
    id?: string | null
    name?: string | null
    siteName?: string | null
  }> | null
}

export type PublishDocumentationDialog_PylonCollectionsQueryVariables = Exact<{
  [key: string]: never
}>

export type PublishDocumentationDialog_PylonCollectionsQuery = {
  __typename?: 'Query'
  pylonGetCollections?: Array<{
    __typename?: 'PylonExternalCollection'
    id?: string | null
    name?: string | null
    knowledgeBaseName?: string | null
  }> | null
}

export type PublishDocumentationDialog_Document360CollectionsQueryVariables = Exact<{
  [key: string]: never
}>

export type PublishDocumentationDialog_Document360CollectionsQuery = {
  __typename?: 'Query'
  document360GetCollections?: Array<{
    __typename?: 'Document360ExternalCollection'
    id?: string | null
    name?: string | null
    projectId?: string | null
    projectName?: string | null
    workspaceId?: string | null
    workspaceName?: string | null
  }> | null
}

export type PublishDocumentationDialog_TeamsupportGetAllKnowledgeBaseCategoriesQueryVariables =
  Exact<{ [key: string]: never }>

export type PublishDocumentationDialog_TeamsupportGetAllKnowledgeBaseCategoriesQuery = {
  __typename?: 'Query'
  teamsupportGetAllKnowledgeBaseCategories?: Array<{
    __typename?: 'TeamsupportExternalKnowledgeBaseCategory'
    id?: string | null
    name?: string | null
  }> | null
}

export type PublishDocumentationDialog_FrontCategoriesQueryVariables = Exact<{
  [key: string]: never
}>

export type PublishDocumentationDialog_FrontCategoriesQuery = {
  __typename?: 'Query'
  frontGetCategories?: Array<{
    __typename?: 'FrontExternalCategory'
    id?: string | null
    name?: string | null
    knowledgeBaseName?: string | null
  }> | null
}

export type PublishDocumentationDialog_ZendeskSectionsQueryVariables = Exact<{
  [key: string]: never
}>

export type PublishDocumentationDialog_ZendeskSectionsQuery = {
  __typename?: 'Query'
  zendeskGetSections?: Array<{
    __typename?: 'ZendeskExternalSection'
    id?: string | null
    categoryName?: string | null
    name?: string | null
  }> | null
}

export type PublishDocumentationDialog_HubspotCollectionsQueryVariables = Exact<{
  [key: string]: never
}>

export type PublishDocumentationDialog_HubspotCollectionsQuery = {
  __typename?: 'Query'
  hubspotGetCollections?: Array<{
    __typename?: 'HubspotExternalCollection'
    id?: string | null
    name?: string | null
    knowledgeBaseId?: string | null
    parentCategoryId?: string | null
    parentCategoryName?: string | null
    language?: string | null
  }> | null
}

export type PublishDocumentationDialog_SectionsQueryVariables = Exact<{ [key: string]: never }>

export type PublishDocumentationDialog_SectionsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    business: {
      __typename?: 'Business'
      featurebaseCollections?: Array<{
        __typename?: 'FeaturebaseExternalCollection'
        id?: string | null
        name?: string | null
      }> | null
    }
  }
}

export type PublishDocumentationDialog_GetDocumentationQueryVariables = Exact<{
  documentationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type PublishDocumentationDialog_GetDocumentationQuery = {
  __typename?: 'Query'
  documentations: Array<{
    __typename?: 'Documentation'
    id: string
    pageCollections: Array<string>
  }>
}

export type PublishDocumentationTaskDialog_SearchDocumentationsQueryVariables = Exact<{
  query: Scalars['String']['input']
  sourceType?: InputMaybe<DocumentationsSourceTypeEnum>
}>

export type PublishDocumentationTaskDialog_SearchDocumentationsQuery = {
  __typename?: 'Query'
  searchDocumentations: Array<{
    __typename?: 'Documentation'
    id: string
    topic: string
    externalPageId?: string | null
  }>
}

export type PublishReleaseNoteExternallyDialog_PublishReleaseNoteExternallyMutationVariables =
  Exact<{
    typedReleaseNoteId: Scalars['ID']['input']
    documentationId: Scalars['ID']['input']
  }>

export type PublishReleaseNoteExternallyDialog_PublishReleaseNoteExternallyMutation = {
  __typename?: 'Mutation'
  publishReleaseNoteExternally: { __typename?: 'Documentation'; id: string }
}

export type PublishReleaseNoteExternallyDialog_SearchDocumentationsQueryVariables = Exact<{
  query: Scalars['String']['input']
}>

export type PublishReleaseNoteExternallyDialog_SearchDocumentationsQuery = {
  __typename?: 'Query'
  searchDocumentations: Array<{ __typename?: 'Documentation'; id: string; topic: string }>
}

export type DocumentationAttachedToReleaseNoteItemSubscriptionSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type DocumentationAttachedToReleaseNoteItemSubscriptionSubscription = {
  __typename?: 'Subscription'
  documentationAttachedToReleaseNoteItem: {
    __typename?: 'DocumentationAttachedToReleaseNoteItemPayload'
    releaseNoteItemId: string
    relatedDocumentations: Array<{
      __typename?: 'Documentation'
      id: string
      topic: string
      url?: string | null
    }>
  }
}

export type RelatedDocumentationDialog_FindDocumentationForReleaseNoteItemMutationVariables =
  Exact<{
    releaseNoteItemId: Scalars['ID']['input']
  }>

export type RelatedDocumentationDialog_FindDocumentationForReleaseNoteItemMutation = {
  __typename?: 'Mutation'
  findDocumentationForReleaseNoteItem?: string | null
}

export type ReleaseNoteItemUploadImageDialog_UploadImagesAndVideoMutationVariables = Exact<{
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemId: Scalars['ID']['input']
  uploadSignedId: Scalars['ID']['input']
}>

export type ReleaseNoteItemUploadImageDialog_UploadImagesAndVideoMutation = {
  __typename?: 'Mutation'
  uploadImagesAndVideo: { __typename?: 'TypedReleaseNote'; id: string }
}

export type ReleaseNotesScheduleDialog_UpsertReleaseNoteScheduleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>
  startDate: Scalars['ISO8601DateTime']['input']
  frequencyType: ReleaseNoteScheduleFrequencyTypeEnum
  externalChannelId?: InputMaybe<Scalars['String']['input']>
  publishDelay?: InputMaybe<ReleaseNoteSchedulePublishDelayEnum>
  ownersToNotify?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  requireApproval?: InputMaybe<Scalars['Boolean']['input']>
  repoNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  scheduleName?: InputMaybe<Scalars['String']['input']>
}>

export type ReleaseNotesScheduleDialog_UpsertReleaseNoteScheduleMutation = {
  __typename?: 'Mutation'
  upsertReleaseNoteSchedule: {
    __typename?: 'ReleaseNoteSchedule'
    id: string
    createdAt: any
    frequencyType: ReleaseNoteScheduleFrequencyTypeEnum
    startDate: any
    externalChannelId?: string | null
    publishDelay: ReleaseNoteSchedulePublishDelayEnum
    scheduleName?: string | null
    repoNames: Array<string>
    requireApproval: boolean
    ownersToNotifyUsers: Array<{
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    }>
  }
}

export type ReleaseNotesScheduleDialog_ReleaseNoteSchedulesQueryVariables = Exact<{
  [key: string]: never
}>

export type ReleaseNotesScheduleDialog_ReleaseNoteSchedulesQuery = {
  __typename?: 'Query'
  releaseNoteSchedules: Array<{
    __typename?: 'ReleaseNoteSchedule'
    id: string
    createdAt: any
    frequencyType: ReleaseNoteScheduleFrequencyTypeEnum
    startDate: any
    externalChannelId?: string | null
    publishDelay: ReleaseNoteSchedulePublishDelayEnum
    repoNames: Array<string>
    scheduleName?: string | null
    requireApproval: boolean
    ownersToNotifyUsers: Array<{
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
    }>
  }>
}

export type ReleaseNotesScheduleDialog_ExistingSlackChannelsQueryVariables = Exact<{
  searchQuery?: InputMaybe<Scalars['String']['input']>
}>

export type ReleaseNotesScheduleDialog_ExistingSlackChannelsQuery = {
  __typename?: 'Query'
  externalSlackChannels: Array<{ __typename?: 'ExternalSlack'; id: string; name: string }>
}

export type ReleaseNotesScheduleDialog_UsersQueryVariables = Exact<{ [key: string]: never }>

export type ReleaseNotesScheduleDialog_UsersQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    business: {
      __typename?: 'Business'
      verifiedUsers?: Array<{
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
        email: string
      }> | null
    }
  }
}

export type ReleaseNotesScheduleDialog_RepositoriesQueryVariables = Exact<{ [key: string]: never }>

export type ReleaseNotesScheduleDialog_RepositoriesQuery = {
  __typename?: 'Query'
  repositories: Array<{
    __typename?: 'Repository'
    id: string
    repoName: string
    shaIndexed?: string | null
  }>
}

export type ReplaceImageDialog_ReplaceDocumentationReviewImageMutationVariables = Exact<{
  documentationReviewRunTextId: Scalars['ID']['input']
  uploadSignedId: Scalars['ID']['input']
}>

export type ReplaceImageDialog_ReplaceDocumentationReviewImageMutation = {
  __typename?: 'Mutation'
  replaceDocumentationReviewImage: {
    __typename?: 'Documentation'
    id: string
    documentationsToReview?: Array<{
      __typename?: 'DocumentationToReview'
      id: string
      newDocumentationMarkdownText?: string | null
    }> | null
  }
}

export type ReplaceImageDialog_GetDocumentationToReviewQueryVariables = Exact<{
  documentationToReviewId: Scalars['ID']['input']
}>

export type ReplaceImageDialog_GetDocumentationToReviewQuery = {
  __typename?: 'Query'
  getDocumentationToReview: {
    __typename?: 'DocumentationToReview'
    id: string
    allImageVersions?: Array<{
      __typename?: 'AllImageVersion'
      createdAt: any
      newDocumentationMarkdownText: string
    }> | null
  }
}

export type SnoozeDocumentationReviewDialog_SnoozeDocumentationReviewMutationVariables = Exact<{
  documentationReviewRunTextId: Scalars['ID']['input']
  snoozeUntilDate: Scalars['ISO8601DateTime']['input']
  snoozeUntilFlagChange?: InputMaybe<Scalars['Boolean']['input']>
}>

export type SnoozeDocumentationReviewDialog_SnoozeDocumentationReviewMutation = {
  __typename?: 'Mutation'
  snoozeDocumentationReview: { __typename?: 'Documentation'; id: string }
}

export type SnoozeReleaseNoteItemDialog_SnoozeReleaseNoteItemMutationVariables = Exact<{
  releaseNoteItemId: Scalars['ID']['input']
  snoozeType: TypedReleaseNoteSnoozeTypeEnum
  snoozeUntilDate: Scalars['ISO8601DateTime']['input']
}>

export type SnoozeReleaseNoteItemDialog_SnoozeReleaseNoteItemMutation = {
  __typename?: 'Mutation'
  snoozeReleaseNoteItem: { __typename?: 'TypedReleaseNote'; id: string }
}

export type SourceDocumentationReviewDialog_GetDocumentationToReviewQueryVariables = Exact<{
  documentationToReviewId: Scalars['ID']['input']
}>

export type SourceDocumentationReviewDialog_GetDocumentationToReviewQuery = {
  __typename?: 'Query'
  getDocumentationToReview: {
    __typename?: 'DocumentationToReview'
    id: string
    sourceLinks?: Array<string> | null
    sourceLinkAuthors?: Array<string> | null
    sourceLinkDates?: Array<any | null> | null
    sourceLinkCommitMessages?: Array<string> | null
  }
}

export type UpsertFlowDialog_BrowserFlowFragment = {
  __typename?: 'BrowserFlow'
  id: string
  name?: string | null
  startUrl?: string | null
  flowType: BrowserFlowType
  browserFlowSteps: Array<{
    __typename?: 'BrowserFlowStep'
    id: string
    position: number
    flowExecutionType: string
    rawJsCode?: string | null
    stepDescription?: string | null
    referencedFlow?: { __typename?: 'BrowserFlow'; id: string; flowType: BrowserFlowType } | null
  }>
  browserFlowRuns: Array<{
    __typename?: 'BrowserFlowRun'
    createdAt: any
    status: string
    imageUrl?: string | null
    sessionReplayUrl?: string | null
    sessionReplayUrls: Array<string>
  }>
  mostRecentCompletedBrowserFlowRun?: { __typename?: 'BrowserFlowRun'; url?: string | null } | null
}

export type UpsertFlowDialog_ImageFlowFragment = {
  __typename?: 'ImageFlow'
  id: string
  imageSource: string
  browserFlow: {
    __typename?: 'BrowserFlow'
    id: string
    name?: string | null
    startUrl?: string | null
    flowType: BrowserFlowType
    browserFlowSteps: Array<{
      __typename?: 'BrowserFlowStep'
      id: string
      position: number
      flowExecutionType: string
      rawJsCode?: string | null
      stepDescription?: string | null
      referencedFlow?: { __typename?: 'BrowserFlow'; id: string; flowType: BrowserFlowType } | null
    }>
    browserFlowRuns: Array<{
      __typename?: 'BrowserFlowRun'
      createdAt: any
      status: string
      imageUrl?: string | null
      sessionReplayUrl?: string | null
      sessionReplayUrls: Array<string>
    }>
    mostRecentCompletedBrowserFlowRun?: {
      __typename?: 'BrowserFlowRun'
      url?: string | null
    } | null
  }
}

export type UpsertFlowDialog_LoginFlowQueryVariables = Exact<{
  browserFlowId: Scalars['ID']['input']
}>

export type UpsertFlowDialog_LoginFlowQuery = {
  __typename?: 'Query'
  loginFlow?: {
    __typename?: 'BrowserFlow'
    id: string
    name?: string | null
    startUrl?: string | null
    flowType: BrowserFlowType
    browserFlowSteps: Array<{
      __typename?: 'BrowserFlowStep'
      id: string
      position: number
      flowExecutionType: string
      rawJsCode?: string | null
      stepDescription?: string | null
      referencedFlow?: { __typename?: 'BrowserFlow'; id: string; flowType: BrowserFlowType } | null
    }>
    browserFlowRuns: Array<{
      __typename?: 'BrowserFlowRun'
      createdAt: any
      status: string
      imageUrl?: string | null
      sessionReplayUrl?: string | null
      sessionReplayUrls: Array<string>
    }>
    mostRecentCompletedBrowserFlowRun?: {
      __typename?: 'BrowserFlowRun'
      url?: string | null
    } | null
  } | null
}

export type UpsertFlowDialog_LoginFlowsQueryVariables = Exact<{ [key: string]: never }>

export type UpsertFlowDialog_LoginFlowsQuery = {
  __typename?: 'Query'
  loginFlows: Array<{
    __typename?: 'BrowserFlow'
    id: string
    name?: string | null
    startUrl?: string | null
    flowType: BrowserFlowType
    browserFlowSteps: Array<{
      __typename?: 'BrowserFlowStep'
      id: string
      position: number
      flowExecutionType: string
      rawJsCode?: string | null
      stepDescription?: string | null
      referencedFlow?: { __typename?: 'BrowserFlow'; id: string; flowType: BrowserFlowType } | null
    }>
    browserFlowRuns: Array<{
      __typename?: 'BrowserFlowRun'
      createdAt: any
      status: string
      imageUrl?: string | null
      sessionReplayUrl?: string | null
      sessionReplayUrls: Array<string>
    }>
    mostRecentCompletedBrowserFlowRun?: {
      __typename?: 'BrowserFlowRun'
      url?: string | null
    } | null
  }>
}

export type UpsertFlowDialog_ImageFlowQueryVariables = Exact<{
  imageFlowId: Scalars['ID']['input']
}>

export type UpsertFlowDialog_ImageFlowQuery = {
  __typename?: 'Query'
  imageFlow?: {
    __typename?: 'ImageFlow'
    id: string
    imageSource: string
    browserFlow: {
      __typename?: 'BrowserFlow'
      id: string
      name?: string | null
      startUrl?: string | null
      flowType: BrowserFlowType
      browserFlowSteps: Array<{
        __typename?: 'BrowserFlowStep'
        id: string
        position: number
        flowExecutionType: string
        rawJsCode?: string | null
        stepDescription?: string | null
        referencedFlow?: {
          __typename?: 'BrowserFlow'
          id: string
          flowType: BrowserFlowType
        } | null
      }>
      browserFlowRuns: Array<{
        __typename?: 'BrowserFlowRun'
        createdAt: any
        status: string
        imageUrl?: string | null
        sessionReplayUrl?: string | null
        sessionReplayUrls: Array<string>
      }>
      mostRecentCompletedBrowserFlowRun?: {
        __typename?: 'BrowserFlowRun'
        url?: string | null
      } | null
    }
  } | null
}

export type UpsertFlowDialog_UpsertImageFlowWithCodeMutationVariables = Exact<{
  imageFlowId?: InputMaybe<Scalars['ID']['input']>
  rawJsCode?: InputMaybe<Scalars['String']['input']>
  imageSource: Scalars['String']['input']
  loginBrowserFlowId?: InputMaybe<Scalars['ID']['input']>
  startUrl?: InputMaybe<Scalars['String']['input']>
  stepDescription?: InputMaybe<Scalars['String']['input']>
}>

export type UpsertFlowDialog_UpsertImageFlowWithCodeMutation = {
  __typename?: 'Mutation'
  upsertImageFlowWithCode: {
    __typename?: 'ImageFlow'
    id: string
    imageSource: string
    browserFlow: {
      __typename?: 'BrowserFlow'
      id: string
      name?: string | null
      startUrl?: string | null
      flowType: BrowserFlowType
      browserFlowSteps: Array<{
        __typename?: 'BrowserFlowStep'
        id: string
        position: number
        flowExecutionType: string
        rawJsCode?: string | null
        stepDescription?: string | null
        referencedFlow?: {
          __typename?: 'BrowserFlow'
          id: string
          flowType: BrowserFlowType
        } | null
      }>
      browserFlowRuns: Array<{
        __typename?: 'BrowserFlowRun'
        createdAt: any
        status: string
        imageUrl?: string | null
        sessionReplayUrl?: string | null
        sessionReplayUrls: Array<string>
      }>
      mostRecentCompletedBrowserFlowRun?: {
        __typename?: 'BrowserFlowRun'
        url?: string | null
      } | null
    }
  }
}

export type UpsertFlowDialog_UpsertLoginFlowWithCodeMutationVariables = Exact<{
  browserFlowId?: InputMaybe<Scalars['ID']['input']>
  rawJsCode?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  startUrl?: InputMaybe<Scalars['String']['input']>
  stepDescription?: InputMaybe<Scalars['String']['input']>
}>

export type UpsertFlowDialog_UpsertLoginFlowWithCodeMutation = {
  __typename?: 'Mutation'
  upsertLoginFlowWithCode: {
    __typename?: 'BrowserFlow'
    id: string
    name?: string | null
    startUrl?: string | null
    flowType: BrowserFlowType
    browserFlowSteps: Array<{
      __typename?: 'BrowserFlowStep'
      id: string
      position: number
      flowExecutionType: string
      rawJsCode?: string | null
      stepDescription?: string | null
      referencedFlow?: { __typename?: 'BrowserFlow'; id: string; flowType: BrowserFlowType } | null
    }>
    browserFlowRuns: Array<{
      __typename?: 'BrowserFlowRun'
      createdAt: any
      status: string
      imageUrl?: string | null
      sessionReplayUrl?: string | null
      sessionReplayUrls: Array<string>
    }>
    mostRecentCompletedBrowserFlowRun?: {
      __typename?: 'BrowserFlowRun'
      url?: string | null
    } | null
  }
}

export type UpsertFlowDialog_RunBrowserFlowMutationVariables = Exact<{
  browserFlowId: Scalars['ID']['input']
}>

export type UpsertFlowDialog_RunBrowserFlowMutation = {
  __typename?: 'Mutation'
  runBrowserFlow: {
    __typename?: 'BrowserFlow'
    id: string
    name?: string | null
    startUrl?: string | null
    flowType: BrowserFlowType
    browserFlowSteps: Array<{
      __typename?: 'BrowserFlowStep'
      id: string
      position: number
      flowExecutionType: string
      rawJsCode?: string | null
      stepDescription?: string | null
      referencedFlow?: { __typename?: 'BrowserFlow'; id: string; flowType: BrowserFlowType } | null
    }>
    browserFlowRuns: Array<{
      __typename?: 'BrowserFlowRun'
      createdAt: any
      status: string
      imageUrl?: string | null
      sessionReplayUrl?: string | null
      sessionReplayUrls: Array<string>
    }>
    mostRecentCompletedBrowserFlowRun?: {
      __typename?: 'BrowserFlowRun'
      url?: string | null
    } | null
  }
}

export type DocumentationImages_BrowserFlowImageSubscriptionVariables = Exact<{
  [key: string]: never
}>

export type DocumentationImages_BrowserFlowImageSubscription = {
  __typename?: 'Subscription'
  browserFlowImage: {
    __typename?: 'BrowserFlowImagePayload'
    browserFlowId: string
    browserFlowRunId: string
    imageUrl?: string | null
    status: string
    lastRun?: boolean | null
  }
}

export type DocumentationTasks_PaginatedOpportunityThemeConversationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  themeId: Scalars['ID']['input']
}>

export type DocumentationTasks_PaginatedOpportunityThemeConversationsQuery = {
  __typename?: 'Query'
  paginatedOpportunityThemeConversations?: {
    __typename?: 'PaginatedOpportunityThemeConversations'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number; totalCount: number }
    data: Array<{
      __typename?: 'ExternalCustomerQuestion'
      id: string
      summarizedQuestion?: string | null
      summarizedAnswer?: string | null
      externalCustomerConversation: {
        __typename?: 'ExternalCustomerConversation'
        id: string
        conversationCreatedAt?: any | null
        url?: string | null
        sourceType: string
      }
    }>
  } | null
}

export type DocumentationReviewCommmentSheet_AddCommentToDocumentation_ReviewMutationVariables =
  Exact<{
    documentationReviewRunTextId: Scalars['ID']['input']
    comment: Scalars['String']['input']
  }>

export type DocumentationReviewCommmentSheet_AddCommentToDocumentation_ReviewMutation = {
  __typename?: 'Mutation'
  addCommentToDocumentationReview: { __typename?: 'Documentation'; id: string }
}

export type DocumentationReviewCommmentSheet_UsersQueryVariables = Exact<{ [key: string]: never }>

export type DocumentationReviewCommmentSheet_UsersQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    business: {
      __typename?: 'Business'
      users?: Array<{
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
        email: string
      }> | null
    }
  }
}

export type DocumentationSheet_GetDocumentationQueryVariables = Exact<{
  documentationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>
}>

export type DocumentationSheet_GetDocumentationQuery = {
  __typename?: 'Query'
  documentations: Array<{
    __typename?: 'Documentation'
    id: string
    topic: string
    instruction?: string | null
    externalContent?: string | null
    externalContentType?: string | null
    url?: string | null
    editUrl?: string | null
    sourceType?: DocumentationsSourceTypeEnum | null
    source: DocumentationsSourceEnum
    externalPageId?: string | null
    lastUpdatedAt?: any | null
    externalCreatedAt?: any | null
    helpCenterName?: string | null
    authorName?: string | null
    isPublished: boolean
  }>
}

export type ReleaseNoteItemCommmentSheet_AddCommentToReleaseNoteItemMutationVariables = Exact<{
  releaseNoteItemId: Scalars['ID']['input']
  comment: Scalars['String']['input']
}>

export type ReleaseNoteItemCommmentSheet_AddCommentToReleaseNoteItemMutation = {
  __typename?: 'Mutation'
  addCommentToReleaseNoteItem: { __typename?: 'TypedReleaseNote'; id: string }
}

export type ReleaseNoteItemCommmentSheet_ReleaseNoteItemCommentsQueryVariables = Exact<{
  releaseNoteItemId: Scalars['ID']['input']
}>

export type ReleaseNoteItemCommmentSheet_ReleaseNoteItemCommentsQuery = {
  __typename?: 'Query'
  releaseNoteItemComments: Array<{
    __typename?: 'ReleaseNoteItemComment'
    id: string
    createdAt: any
    comment: string
    user: {
      __typename?: 'Users'
      id: string
      email: string
      firstName?: string | null
      lastName?: string | null
    }
  }>
}

export type ReleaseNoteItemCommmentSheet_UsersQueryVariables = Exact<{ [key: string]: never }>

export type ReleaseNoteItemCommmentSheet_UsersQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    business: {
      __typename?: 'Business'
      users?: Array<{
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
        email: string
      }> | null
    }
  }
}

export type TypedReleaseNotesItemAnsweredSubscriptionVariables = Exact<{ [key: string]: never }>

export type TypedReleaseNotesItemAnsweredSubscription = {
  __typename?: 'Subscription'
  releaseNoteItemAnswered: {
    __typename?: 'ReleaseNoteItemAnsweredPayload'
    objId: string
    answer: string
  }
}

export type ReleaseNoteItemQuestionSheet_ReleaseNoteItemAskQuestionMutationVariables = Exact<{
  releaseNoteId: Scalars['ID']['input']
  releaseNoteItemId: Scalars['ID']['input']
  question: Scalars['String']['input']
  previousMessages?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
}>

export type ReleaseNoteItemQuestionSheet_ReleaseNoteItemAskQuestionMutation = {
  __typename?: 'Mutation'
  releaseNoteItemAskQuestion: { __typename?: 'TypedReleaseNote'; id: string }
}

export type DocumentationTasks_PaginatedSuccessfulCoverageConversationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  perPage?: InputMaybe<Scalars['Int']['input']>
  externalTopicId: Scalars['ID']['input']
  externalSubtopicId: Scalars['ID']['input']
}>

export type DocumentationTasks_PaginatedSuccessfulCoverageConversationsQuery = {
  __typename?: 'Query'
  paginatedSuccessfulCoverageConversations?: {
    __typename?: 'PaginatedSuccessfulCoverageConversations'
    pagination: { __typename?: 'Pagination'; page: number; totalPages: number; totalCount: number }
    data: Array<{
      __typename?: 'ExternalCustomerQuestion'
      id: string
      summarizedQuestion?: string | null
      summarizedAnswer?: string | null
      externalCustomerConversation: {
        __typename?: 'ExternalCustomerConversation'
        id: string
        conversationCreatedAt?: any | null
        url?: string | null
        sourceType: string
      }
    }>
  } | null
}

export type DocumentationActionItemsToolbar_AvailableChangeReasonsQueryVariables = Exact<{
  [key: string]: never
}>

export type DocumentationActionItemsToolbar_AvailableChangeReasonsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    business: {
      __typename?: 'Business'
      allPendingChangeReasons?: Array<string> | null
      activeReleaseNoteLabels?: Array<{
        __typename?: 'ReleaseNoteLabel'
        id: string
        name: string
      }> | null
    }
  }
}

export type DocumentationActionItemsToolbar_ShowEnableBulkAcceptAllDocumentationReviewQueryVariables =
  Exact<{ [key: string]: never }>

export type DocumentationActionItemsToolbar_ShowEnableBulkAcceptAllDocumentationReviewQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    business: { __typename?: 'Business'; showEnableBulkAcceptAllDocumentationReview: boolean }
  }
}

export type DocumentationActionItemsToolbar_AvailableFeatureFlagsQueryVariables = Exact<{
  [key: string]: never
}>

export type DocumentationActionItemsToolbar_AvailableFeatureFlagsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    business: {
      __typename?: 'Business'
      pendingDocumentationReviewRunTextsFeatureFlags: Array<string>
    }
  }
}

export type DocumentationActionItemsToolbar_BulkAcceptAllDocumentationReviewMutationVariables =
  Exact<{
    branchName?: InputMaybe<Scalars['String']['input']>
  }>

export type DocumentationActionItemsToolbar_BulkAcceptAllDocumentationReviewMutation = {
  __typename?: 'Mutation'
  bulkAcceptAllDocumentationReview: string
}

export type DocumentationActionItemsToolbar_SearchDocumentationTasksQueryVariables = Exact<{
  query: Scalars['String']['input']
}>

export type DocumentationActionItemsToolbar_SearchDocumentationTasksQuery = {
  __typename?: 'Query'
  searchDocumentationTasks: Array<{ __typename?: 'DocumentationTask'; id: string; name: string }>
}

export type QuestionsToolbar_ExportToCsvMutationVariables = Exact<{
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}>

export type QuestionsToolbar_ExportToCsvMutation = {
  __typename?: 'Mutation'
  exportToCsv?: string | null
}

export type TypedReleaseNotesToolbar_SearchReleaseNotesQueryVariables = Exact<{
  query: Scalars['String']['input']
}>

export type TypedReleaseNotesToolbar_SearchReleaseNotesQuery = {
  __typename?: 'Query'
  searchReleaseNotes?: Array<{
    __typename?: 'TypedReleaseNoteItem'
    id: string
    summarizedTitle?: string | null
    typedReleaseNote: { __typename?: 'TypedReleaseNote'; id: string; startDate: any; endDate: any }
  }> | null
}

export type TypedReleaseNotesToolbar_ReleaseNoteScheduleNamesQueryVariables = Exact<{
  [key: string]: never
}>

export type TypedReleaseNotesToolbar_ReleaseNoteScheduleNamesQuery = {
  __typename?: 'Query'
  releaseNoteSchedules: Array<{
    __typename?: 'ReleaseNoteSchedule'
    id: string
    scheduleName?: string | null
  }>
}

export type AddBusinessNameForm_CreateReleaseNoteLabelMutationVariables = Exact<{
  releaseNoteLabels?: InputMaybe<Array<ReleaseNoteLabelInputObject> | ReleaseNoteLabelInputObject>
}>

export type AddBusinessNameForm_CreateReleaseNoteLabelMutation = {
  __typename?: 'Mutation'
  createReleaseNoteLabel: Array<{ __typename?: 'ReleaseNoteLabel'; id: string }>
}

export type AddBusinessNameForm_UpdateReleaseNoteLabelMutationVariables = Exact<{
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  description: Scalars['String']['input']
}>

export type AddBusinessNameForm_UpdateReleaseNoteLabelMutation = {
  __typename?: 'Mutation'
  updateReleaseNoteLabel: { __typename?: 'ReleaseNoteLabel'; id: string }
}

export type AddBusinessNameForm_DeleteReleaseNoteLabelMutationVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type AddBusinessNameForm_DeleteReleaseNoteLabelMutation = {
  __typename?: 'Mutation'
  deleteReleaseNoteLabel: { __typename?: 'ReleaseNoteLabel'; id: string }
}

export type AddBusinessNameForm_ReorderReleaseNoteLabelMutationVariables = Exact<{
  releaseNoteLabelIds: Array<Scalars['ID']['input']> | Scalars['ID']['input']
}>

export type AddBusinessNameForm_ReorderReleaseNoteLabelMutation = {
  __typename?: 'Mutation'
  reorderReleaseNoteLabels: Array<{ __typename?: 'ReleaseNoteLabel'; id: string }>
}

export type AddBusinessNameForm_ReleaseNoteLabelsQueryVariables = Exact<{ [key: string]: never }>

export type AddBusinessNameForm_ReleaseNoteLabelsQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    business: {
      __typename?: 'Business'
      id: string
      activeReleaseNoteLabels?: Array<{
        __typename?: 'ReleaseNoteLabel'
        id: string
        name: string
        description: string
        assignee?: {
          __typename?: 'Users'
          id: string
          firstName?: string | null
          lastName?: string | null
        } | null
      }> | null
    }
  }
}

export type AddBusinessNameForm_UpdateAssigneeReleaseNoteLabelsMutationVariables = Exact<{
  releaseNoteLabelId: Scalars['ID']['input']
  assigneeId?: InputMaybe<Scalars['ID']['input']>
}>

export type AddBusinessNameForm_UpdateAssigneeReleaseNoteLabelsMutation = {
  __typename?: 'Mutation'
  updateAssigneeReleaseNoteLabels: { __typename?: 'ReleaseNoteLabel'; id: string }
}

export type AuthResponseFragment = {
  __typename?: 'AuthResponse'
  token?: string | null
  user?: {
    __typename?: 'Users'
    id: string
    business: { __typename?: 'Business'; id: string; name: string }
  } | null
}

export type ProviderAuthenticationMutationVariables = Exact<{
  data: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  provider: AuthProviderTypeEnum
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
}>

export type ProviderAuthenticationMutation = {
  __typename?: 'Mutation'
  authProviderAuthenticate: {
    __typename?: 'AuthResponse'
    token?: string | null
    user?: {
      __typename?: 'Users'
      id: string
      business: { __typename?: 'Business'; id: string; name: string }
    } | null
  }
}

export type CredentialsAuthenticationSignInMutationVariables = Exact<{
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}>

export type CredentialsAuthenticationSignInMutation = {
  __typename?: 'Mutation'
  authSignIn: {
    __typename?: 'AuthResponse'
    token?: string | null
    user?: {
      __typename?: 'Users'
      id: string
      business: { __typename?: 'Business'; id: string; name: string }
    } | null
  }
}

export type CredentialsAuthenticationSignUpMutationVariables = Exact<{
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  referredByUserUniqueId?: InputMaybe<Scalars['ID']['input']>
  resumeUniqueId?: InputMaybe<Scalars['ID']['input']>
  emailVerifyFromUrl?: InputMaybe<Scalars['String']['input']>
}>

export type CredentialsAuthenticationSignUpMutation = {
  __typename?: 'Mutation'
  authSignUp: {
    __typename?: 'AuthResponse'
    token?: string | null
    user?: {
      __typename?: 'Users'
      id: string
      business: { __typename?: 'Business'; id: string; name: string }
    } | null
  }
}

export type CredentialsAuthenticationEmailVerifyMutationVariables = Exact<{
  emailVerificationCode: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  password: Scalars['String']['input']
}>

export type CredentialsAuthenticationEmailVerifyMutation = {
  __typename?: 'Mutation'
  userEmailVerify: {
    __typename?: 'AuthResponse'
    token?: string | null
    user?: {
      __typename?: 'Users'
      id: string
      business: { __typename?: 'Business'; id: string; name: string }
    } | null
  }
}

export type RootQueryVariables = Exact<{ [key: string]: never }>

export type RootQuery = {
  __typename?: 'Query'
  user: { __typename?: 'Users'; id: string; role: UsersRoleEnum }
}

export type UsersFragment = {
  __typename?: 'Users'
  id: string
  email: string
  firstName?: string | null
  lastName?: string | null
  role: UsersRoleEnum
  isSuperadmin: boolean
  verified: boolean
  unreadUsersActivitiesCount: number
  business: {
    __typename?: 'Business'
    id: string
    name: string
    codeConnected: boolean
    codeIndexing: boolean
    documentationCodeConnected: boolean
    documentationCodeIndexing: boolean
    documentationRepoNamePath?: string | null
    githubConnected: boolean
    gitlabConnected: boolean
    slackConnected: boolean
    notionConnected: boolean
    notionIndexing: boolean
    intercomConnected: boolean
    intercomIndexing: boolean
    zendeskConnected: boolean
    zendeskIndexing: boolean
    featurebaseConnected: boolean
    bitbucketConnected: boolean
    confluenceConnected: boolean
    confluenceIndexing: boolean
    jiraConnected: boolean
    launchdarklyConnected: boolean
    linearConnected: boolean
    frontConnected: boolean
    pendoConnected: boolean
    hubspotConnected: boolean
    plan: SubscriptionPlanEnum
    availableDocumentationSources: Array<AnswerTypeEnum>
    defaultChatSources: Array<AnswerTypeEnum>
    availableChatSources: Array<AnswerTypeEnum>
    availableChatSourcesAndCommitHistory: Array<AnswerTypeEnum>
    hasSeenDemoScreen: boolean
    featureFlagFullLink?: string | null
    disableManualReleaseNotesGeneration: boolean
    hideReleaseNoteItemHeaders: boolean
    enableManualDocumentationAuditing: boolean
    enableCoverageFeature: boolean
    hasDocumentationStyleGuide: boolean
    enableExternalForReleaseNoteApprovals: boolean
    hasTranslatedDocumentation: boolean
    skipDocumentationFindingStepForTasks: boolean
    branchNamesAcceptedDocumentationReviewRunTextsInGithub: Array<string>
    defaultDocumentationForExternalReleaseNoteApprovals?: {
      __typename?: 'Documentation'
      id: string
      topic: string
    } | null
    documentationProjects: Array<{ __typename?: 'DocumentationProject'; id: string; name: string }>
    users?: Array<{
      __typename?: 'Users'
      id: string
      firstName?: string | null
      lastName?: string | null
      email: string
    }> | null
  }
}

export type UseCurrentUser_UsersQueryVariables = Exact<{ [key: string]: never }>

export type UseCurrentUser_UsersQuery = {
  __typename?: 'Query'
  user: {
    __typename?: 'Users'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    role: UsersRoleEnum
    isSuperadmin: boolean
    verified: boolean
    unreadUsersActivitiesCount: number
    business: {
      __typename?: 'Business'
      id: string
      name: string
      codeConnected: boolean
      codeIndexing: boolean
      documentationCodeConnected: boolean
      documentationCodeIndexing: boolean
      documentationRepoNamePath?: string | null
      githubConnected: boolean
      gitlabConnected: boolean
      slackConnected: boolean
      notionConnected: boolean
      notionIndexing: boolean
      intercomConnected: boolean
      intercomIndexing: boolean
      zendeskConnected: boolean
      zendeskIndexing: boolean
      featurebaseConnected: boolean
      bitbucketConnected: boolean
      confluenceConnected: boolean
      confluenceIndexing: boolean
      jiraConnected: boolean
      launchdarklyConnected: boolean
      linearConnected: boolean
      frontConnected: boolean
      pendoConnected: boolean
      hubspotConnected: boolean
      plan: SubscriptionPlanEnum
      availableDocumentationSources: Array<AnswerTypeEnum>
      defaultChatSources: Array<AnswerTypeEnum>
      availableChatSources: Array<AnswerTypeEnum>
      availableChatSourcesAndCommitHistory: Array<AnswerTypeEnum>
      hasSeenDemoScreen: boolean
      featureFlagFullLink?: string | null
      disableManualReleaseNotesGeneration: boolean
      hideReleaseNoteItemHeaders: boolean
      enableManualDocumentationAuditing: boolean
      enableCoverageFeature: boolean
      hasDocumentationStyleGuide: boolean
      enableExternalForReleaseNoteApprovals: boolean
      hasTranslatedDocumentation: boolean
      skipDocumentationFindingStepForTasks: boolean
      branchNamesAcceptedDocumentationReviewRunTextsInGithub: Array<string>
      defaultDocumentationForExternalReleaseNoteApprovals?: {
        __typename?: 'Documentation'
        id: string
        topic: string
      } | null
      documentationProjects: Array<{
        __typename?: 'DocumentationProject'
        id: string
        name: string
      }>
      users?: Array<{
        __typename?: 'Users'
        id: string
        firstName?: string | null
        lastName?: string | null
        email: string
      }> | null
    }
  }
}

export const UsersUpdateFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersUpdate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersUpdateFragment, unknown>
export const UpsertFlowDialog_BrowserFlowFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BrowserFlow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowSteps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flowExecutionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawJsCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'referencedFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stepDescription' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowRuns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrls' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentCompletedBrowserFlowRun' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsertFlowDialog_BrowserFlowFragment, unknown>
export const UpsertFlowDialog_ImageFlowFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpsertFlowDialog_imageFlow' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageFlow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageSource' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BrowserFlow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowSteps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flowExecutionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawJsCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'referencedFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stepDescription' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowRuns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrls' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentCompletedBrowserFlowRun' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsertFlowDialog_ImageFlowFragment, unknown>
export const AuthResponseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuthResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthResponseFragment, unknown>
export const UsersFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Users' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuperadmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verified' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadUsersActivitiesCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'business' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'codeConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'codeIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentationCodeConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentationCodeIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentationRepoNamePath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'githubConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gitlabConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slackConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notionConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notionIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intercomConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intercomIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zendeskConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zendeskIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featurebaseConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bitbucketConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confluenceConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confluenceIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jiraConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'launchdarklyConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linearConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frontConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendoConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hubspotConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availableDocumentationSources' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultChatSources' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availableChatSources' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableChatSourcesAndCommitHistory' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasSeenDemoScreen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlagFullLink' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disableManualReleaseNotesGeneration' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hideReleaseNoteItemHeaders' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enableManualDocumentationAuditing' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'enableCoverageFeature' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDocumentationStyleGuide' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enableExternalForReleaseNoteApprovals' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasTranslatedDocumentation' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skipDocumentationFindingStepForTasks' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'branchNamesAcceptedDocumentationReviewRunTextsInGithub',
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'defaultDocumentationForExternalReleaseNoteApprovals',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationProjects' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersFragment, unknown>
export const AddBusinessNameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addBusinessName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBusiness' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddBusinessNameMutation, AddBusinessNameMutationVariables>
export const ChatAnsweredDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ChatAnswered' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chatAnswered' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'answerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'chatId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sources' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatAnsweredSubscription, ChatAnsweredSubscriptionVariables>
export const Chat_AnswerQuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Chat_answerQuestion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'question' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chatId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'answerTypes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'AnswerTypeEnum' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answerQuestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'question' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'question' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'chatId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'chatId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'answerTypes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'answerTypes' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Chat_AnswerQuestionMutation, Chat_AnswerQuestionMutationVariables>
export const Chat_IncorrectInChatDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Chat_incorrectInChat' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'answerId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'incorrectInChat' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'answerId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'answerId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Chat_IncorrectInChatMutation, Chat_IncorrectInChatMutationVariables>
export const Chat_ChatMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Chat_chatMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chatId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chatMessages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'chatId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'chatId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'answerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sources' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasIncorrectAnswerFeedback' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Chat_ChatMessagesQuery, Chat_ChatMessagesQueryVariables>
export const Chat_PreviousChatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Chat_previousChats' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previousChats' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageActualThreadExternalId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Chat_PreviousChatsQuery, Chat_PreviousChatsQueryVariables>
export const IntegrationExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationExchange_ExchangeCodeMutation,
  IntegrationExchange_ExchangeCodeMutationVariables
>
export const AllDocumentationToReview_GetDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllDocumentationToReview_getDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeReleaseNoteLabels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentationCssString' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instruction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentLastCreatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'editUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDraft' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeDocumentationCommentAnchors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startOffset' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endOffset' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentationComments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationsToReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'oldDocumentationMarkdownText' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newDocumentationMarkdownText' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reviewType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSnoozed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summarizedChange' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'suggestionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showMobileReleaseUx' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAccepting' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentationTask' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkedExternalTaskIssues' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalIdentifier' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalTaskIssues' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalIdentifier' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalCustomerConversation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentationReviewComments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllDocumentationToReview_GetDocumentationQuery,
  AllDocumentationToReview_GetDocumentationQueryVariables
>
export const AllDocumentationToReview_DocumentationToReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllDocumentationToReview_documentationToReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'unreviewedOnly' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'snoozedOnly' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentationToReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'unreviewedOnly' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'unreviewedOnly' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'snoozedOnly' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'snoozedOnly' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'oldDocumentationMarkdownText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newDocumentationMarkdownText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSnoozed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'previewText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summarizedChange' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestionReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suggestionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceLinks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'didFindBlocksPublished' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showMobileReleaseUx' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disableImageRecording' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'githubPrUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAccepting' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eligibleForAutoApprove' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAutoApproved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoApproveFeatureFlagStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoApproveConditionsMet' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoApproveConditionsNotMet' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labels' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalTaskIssues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalIdentifier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkedExternalTaskIssues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalIdentifier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalCustomerConversation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationTask' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'browserFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'imageFlow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mostRecentCompletedBrowserFlowRun' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationReviewComments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllDocumentationToReview_DocumentationToReviewQuery,
  AllDocumentationToReview_DocumentationToReviewQueryVariables
>
export const AllDocumentationToReview_NextDocumentationWithDocumentationReviewRunTextForUserDocument =
  {
    kind: 'Document',
    definitions: [
      {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
          kind: 'Name',
          value: 'AllDocumentationToReview_nextDocumentationWithDocumentationReviewRunTextForUser',
        },
        variableDefinitions: [
          {
            kind: 'VariableDefinition',
            variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        ],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [
            {
              kind: 'Field',
              name: {
                kind: 'Name',
                value: 'nextDocumentationWithDocumentationReviewRunTextForUser',
              },
              arguments: [
                {
                  kind: 'Argument',
                  name: { kind: 'Name', value: 'documentationId' },
                  value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
                },
              ],
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    AllDocumentationToReview_NextDocumentationWithDocumentationReviewRunTextForUserQuery,
    AllDocumentationToReview_NextDocumentationWithDocumentationReviewRunTextForUserQueryVariables
  >
export const AllDocumentationToReview_CancelDocumentationDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AllDocumentationToReview_cancelDocumentationDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelDocumentationDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllDocumentationToReview_CancelDocumentationDraftMutation,
  AllDocumentationToReview_CancelDocumentationDraftMutationVariables
>
export const AllDocumentationToReview_PublishDocumentationDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AllDocumentationToReview_publishDocumentationDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'branchName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishDocumentationDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'branchName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'branchName' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllDocumentationToReview_PublishDocumentationDraftMutation,
  AllDocumentationToReview_PublishDocumentationDraftMutationVariables
>
export const AllDocumentationToReview_AcceptAllDocumentationReviewForDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'AllDocumentationToReview_acceptAllDocumentationReviewForDocumentation',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'branchName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptAllDocumentationReviewForDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'branchName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'branchName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllDocumentationToReview_AcceptAllDocumentationReviewForDocumentationMutation,
  AllDocumentationToReview_AcceptAllDocumentationReviewForDocumentationMutationVariables
>
export const AllDocumentationToReview_RejectAllDocumentationReviewForDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'AllDocumentationToReview_rejectAllDocumentationReviewForDocumentation',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rejectAllDocumentationReviewForDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllDocumentationToReview_RejectAllDocumentationReviewForDocumentationMutation,
  AllDocumentationToReview_RejectAllDocumentationReviewForDocumentationMutationVariables
>
export const AllDocumentationToReview_MarkOutdatedDocumentationReviewForDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'AllDocumentationToReview_markOutdatedDocumentationReviewForDocumentation',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markOutdatedDocumentationReviewForDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextIds' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllDocumentationToReview_MarkOutdatedDocumentationReviewForDocumentationMutation,
  AllDocumentationToReview_MarkOutdatedDocumentationReviewForDocumentationMutationVariables
>
export const Documentation_GetDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Documentation_getDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notionConnected' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instruction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sections' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'editUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'findForOutOfDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'containsZendeskContentBlockTexts' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'prUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isGeneratingContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDraft' } },
                { kind: 'Field', name: { kind: 'Name', value: 'manuallyWrite' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasContentEditedVersion' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeDocumentationCommentAnchors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startOffset' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endOffset' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentationComments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationFilesJson' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_GetDocumentationQuery,
  Documentation_GetDocumentationQueryVariables
>
export const Documentation_GenerateDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_generateDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'regenerating' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'regenerating' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'regenerating' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_GenerateDocumentationMutation,
  Documentation_GenerateDocumentationMutationVariables
>
export const Documentation_UpdateDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_updateDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instruction' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sections' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'topic' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instruction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instruction' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sections' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sections' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sections' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instruction' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_UpdateDocumentationMutation,
  Documentation_UpdateDocumentationMutationVariables
>
export const Documentation_RemoveDocumentationFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_removeDocumentationFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeDocumentationFile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fileId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_RemoveDocumentationFileMutation,
  Documentation_RemoveDocumentationFileMutationVariables
>
export const Documentation_ArchiveDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_archiveDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveInSolo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_ArchiveDocumentationMutation,
  Documentation_ArchiveDocumentationMutationVariables
>
export const Documentation_UpdateDocumentationContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_updateDocumentationContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocumentationContent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_UpdateDocumentationContentMutation,
  Documentation_UpdateDocumentationContentMutationVariables
>
export const Documentation_UpdateDocumentationHiddenDraftContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_updateDocumentationHiddenDraftContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hiddenDraftContent' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateHiddenDraftContent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hiddenDraftContent' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hiddenDraftContent' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_UpdateDocumentationHiddenDraftContentMutation,
  Documentation_UpdateDocumentationHiddenDraftContentMutationVariables
>
export const Documentation_MarkForFindForOutOfDateDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_markForFindForOutOfDateDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markForFindForOutOfDateDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_MarkForFindForOutOfDateDocumentationMutation,
  Documentation_MarkForFindForOutOfDateDocumentationMutationVariables
>
export const Documentation_UnmarkForFindForOutOfDateDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_unmarkForFindForOutOfDateDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unmarkForFindForOutOfDateDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_UnmarkForFindForOutOfDateDocumentationMutation,
  Documentation_UnmarkForFindForOutOfDateDocumentationMutationVariables
>
export const Documentation_CreateDocumentationAnchorAndAddCommentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_createDocumentationAnchorAndAddComment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startOffset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endOffset' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDocumentationAnchorAndAddComment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startOffset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startOffset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endOffset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endOffset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'comment' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_CreateDocumentationAnchorAndAddCommentMutation,
  Documentation_CreateDocumentationAnchorAndAddCommentMutationVariables
>
export const Documentation_AddCommentToExistingAnchorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_addCommentToExistingAnchor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationCommentAnchorId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addCommentToExistingAnchor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationCommentAnchorId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationCommentAnchorId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'comment' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_AddCommentToExistingAnchorMutation,
  Documentation_AddCommentToExistingAnchorMutationVariables
>
export const Documentation_ResolveCommentAnchorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_resolveCommentAnchor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationCommentAnchorId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resolveCommentAnchor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationCommentAnchorId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationCommentAnchorId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_ResolveCommentAnchorMutation,
  Documentation_ResolveCommentAnchorMutationVariables
>
export const Documentation_PublishDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_publishDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'parentPageId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationSource' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AnswerTypeEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isPublished' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'relatedArticleIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'parentPageId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'parentPageId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationSource' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isPublished' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isPublished' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'keywords' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'keywords' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'relatedArticleIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'relatedArticleIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_PublishDocumentationMutation,
  Documentation_PublishDocumentationMutationVariables
>
export const Documentation_AcceptDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_acceptDocumentationReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applyToDraft' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'branchName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'applyToDraft' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'applyToDraft' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'branchName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'branchName' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_AcceptDocumentationReviewMutation,
  Documentation_AcceptDocumentationReviewMutationVariables
>
export const Documentation_RejectDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_rejectDocumentationReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rejectionReason' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rejectDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rejectionReason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rejectionReason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_RejectDocumentationReviewMutation,
  Documentation_RejectDocumentationReviewMutationVariables
>
export const Documentation_MarkOutdatedDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Documentation_markOutdatedDocumentationReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markOutdatedDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Documentation_MarkOutdatedDocumentationReviewMutation,
  Documentation_MarkOutdatedDocumentationReviewMutationVariables
>
export const DocumentationSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'DocumentationSubscription' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'objId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationSubscriptionSubscription,
  DocumentationSubscriptionSubscriptionVariables
>
export const DocumentationToReviewComponent_EditDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DocumentationToReviewComponent_editDocumentationReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newDocumentationMarkdownText' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'newDocumentationMarkdownText' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'newDocumentationMarkdownText' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instruction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'editUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPageId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationsToReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'oldDocumentationMarkdownText' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newDocumentationMarkdownText' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reviewType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalCustomerConversation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationToReviewComponent_EditDocumentationReviewMutation,
  DocumentationToReviewComponent_EditDocumentationReviewMutationVariables
>
export const DocumentationToReviewComponent_UnsnoozeDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DocumentationToReviewComponent_unsnoozeDocumentationReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unsnoozeDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationToReviewComponent_UnsnoozeDocumentationReviewMutation,
  DocumentationToReviewComponent_UnsnoozeDocumentationReviewMutationVariables
>
export const DocumentationToReviewComponent_ExcludeImageDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'DocumentationToReviewComponent_excludeImageDocumentationReview',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'excludeImageDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationToReviewComponent_ExcludeImageDocumentationReviewMutation,
  DocumentationToReviewComponent_ExcludeImageDocumentationReviewMutationVariables
>
export const DocumentationToReviewComponent_IncludeImageDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'DocumentationToReviewComponent_includeImageDocumentationReview',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'includeImageDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationToReviewComponent_IncludeImageDocumentationReviewMutation,
  DocumentationToReviewComponent_IncludeImageDocumentationReviewMutationVariables
>
export const DocumentationToReviewComponent_LinkDocumentationReviewToNewExternalTaskIssueDocument =
  {
    kind: 'Document',
    definitions: [
      {
        kind: 'OperationDefinition',
        operation: 'mutation',
        name: {
          kind: 'Name',
          value: 'DocumentationToReviewComponent_linkDocumentationReviewToNewExternalTaskIssue',
        },
        variableDefinitions: [
          {
            kind: 'VariableDefinition',
            variable: {
              kind: 'Variable',
              name: { kind: 'Name', value: 'documentationReviewRunTextId' },
            },
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        ],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [
            {
              kind: 'Field',
              name: { kind: 'Name', value: 'linkDocumentationReviewToNewExternalTaskIssue' },
              arguments: [
                {
                  kind: 'Argument',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                  value: {
                    kind: 'Variable',
                    name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                  },
                },
              ],
              selectionSet: {
                kind: 'SelectionSet',
                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    DocumentationToReviewComponent_LinkDocumentationReviewToNewExternalTaskIssueMutation,
    DocumentationToReviewComponent_LinkDocumentationReviewToNewExternalTaskIssueMutationVariables
  >
export const DocumentationToReviewComponent_UpdateLabelsDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'DocumentationToReviewComponent_updateLabelsDocumentationReview',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'labelIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLabelsDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'labelIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'labelIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationsToReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationToReviewComponent_UpdateLabelsDocumentationReviewMutation,
  DocumentationToReviewComponent_UpdateLabelsDocumentationReviewMutationVariables
>
export const DocumentationToReviewComponent_GetFeatureFlagInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationToReviewComponent_getFeatureFlagInfo' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFeatureFlagInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fullyOnFeatureFlags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'partiallyOnFeatureFlags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notFullyOnFeatureFlags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationToReviewComponent_GetFeatureFlagInfoQuery,
  DocumentationToReviewComponent_GetFeatureFlagInfoQueryVariables
>
export const DocumentationActionItems_PaginatedDocumentationActionItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationActionItems_paginatedDocumentationActionItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceType' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentationsSourceTypeEnum' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'changeReasons' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'labelIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortByCreatedAt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationProjectIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationTaskId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assigneeIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeUnassigned' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'snoozedOnly' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'suggestionType' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentationToReviewSuggestionType' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'featureFlags' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'featureFlagStatuses' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'FeatureFlagStatus' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'eligibleForAutoApproveOnly' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeReleaseNoteLabels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedDocumentationActionItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'changeReasons' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'changeReasons' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'labelIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'labelIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortByCreatedAt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortByCreatedAt' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationProjectIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationProjectIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationTaskId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationTaskId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assigneeIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'assigneeIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeUnassigned' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'includeUnassigned' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'snoozedOnly' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'snoozedOnly' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'suggestionType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'suggestionType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'featureFlags' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'featureFlags' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'featureFlagStatuses' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'featureFlagStatuses' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eligibleForAutoApproveOnly' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'eligibleForAutoApproveOnly' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'oldDocumentationMarkdownText' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newDocumentationMarkdownText' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'suggestionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reviewType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceLinks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summarizedChange' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'assignee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentationTask' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentationProjects' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'labels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalTaskIssues' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'externalIdentifier' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalCustomerConversation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'editUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationActionItems_PaginatedDocumentationActionItemsQuery,
  DocumentationActionItems_PaginatedDocumentationActionItemsQueryVariables
>
export const DocumentationActionItems_UpdateAssigneeDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DocumentationActionItems_updateAssigneeDocumentationReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assigneeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAssigneeDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assigneeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'assigneeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationActionItems_UpdateAssigneeDocumentationReviewMutation,
  DocumentationActionItems_UpdateAssigneeDocumentationReviewMutationVariables
>
export const DocumentationContentUpdatedSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'DocumentationContentUpdatedSubscription' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentationContentUpdated' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'objId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedDocumentationText' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responseAcknowledgingUsersInstruction' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationContentUpdatedSubscriptionSubscription,
  DocumentationContentUpdatedSubscriptionSubscriptionVariables
>
export const DocumentationEditMode_AddNewContentToDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DocumentationEditMode_addNewContentToDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instruction' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addNewContentToDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instruction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instruction' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationEditMode_AddNewContentToDocumentationMutation,
  DocumentationEditMode_AddNewContentToDocumentationMutationVariables
>
export const DocumentationEditMode_RephraseContentDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DocumentationEditMode_rephraseContentDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instruction' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rephraseContentDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instruction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instruction' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationEditMode_RephraseContentDocumentationMutation,
  DocumentationEditMode_RephraseContentDocumentationMutationVariables
>
export const DocumentationEditMode_AcceptNewContentToDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DocumentationEditMode_acceptNewContentToDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updatedDocumentationText' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptNewContentDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updatedDocumentationText' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'updatedDocumentationText' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationEditMode_AcceptNewContentToDocumentationMutation,
  DocumentationEditMode_AcceptNewContentToDocumentationMutationVariables
>
export const DocumentationList_AllDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationList_allDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'needsReview' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceType' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentationsSourceTypeEnum' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'source' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentationsSourceEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedInSolo' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationProjectIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentationSortByEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortByDirection' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortByDirectionEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedDocumentations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'needsReview' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'needsReview' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'source' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'source' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'archivedInSolo' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedInSolo' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationProjectIds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationProjectIds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortByDirection' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortByDirection' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastUpdatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'needsReview' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'helpCenterName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'authorName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentCollectionName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasDraft' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isTranslated' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'numPendingDocumentationReviewRunTextsNotSnoozed',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeDocumentationProjects' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationList_AllDocumentationQuery,
  DocumentationList_AllDocumentationQueryVariables
>
export const DocumentationTasks_PaginatedSuccessfulCoverageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationTasks_paginatedSuccessfulCoverage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedSuccessfulCoverage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topic' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subtopic' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subtopic' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqueConversationCount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uniqueConversationSourceTypes' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationTasks_PaginatedSuccessfulCoverageQuery,
  DocumentationTasks_PaginatedSuccessfulCoverageQueryVariables
>
export const DocumentationTasks_PaginatedOpportunityThemesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationTasks_paginatedOpportunityThemes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedOpportunityThemes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'themeDescription' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numUniqueExternalCustomerQuestions' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalTopic' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'documentation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalSubtopic' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subtopic' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqueSourceTypes' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationTasks_PaginatedOpportunityThemesQuery,
  DocumentationTasks_PaginatedOpportunityThemesQueryVariables
>
export const Coverage_ArchiveOpportunityThemeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Coverage_archiveOpportunityTheme' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveOpportunityTheme' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Coverage_ArchiveOpportunityThemeMutation,
  Coverage_ArchiveOpportunityThemeMutationVariables
>
export const Coverage_RestoreExternallyOpportunityThemeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Coverage_restoreExternallyOpportunityTheme' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resolveExternallyOpportunityTheme' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Coverage_RestoreExternallyOpportunityThemeMutation,
  Coverage_RestoreExternallyOpportunityThemeMutationVariables
>
export const DocumentationImages_FlowsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationImages_flows' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginFlows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'browserFlowRuns' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrl' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageFlows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'browserFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'browserFlowRuns' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationImages_FlowsQuery,
  DocumentationImages_FlowsQueryVariables
>
export const DocumentationProjects_PaginatedDocumentationProjectsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationProjects_paginatedDocumentationProjects' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedDocumentationProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numPendingDocumentationReviewRunTexts' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'numDocumentation' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationProjects_PaginatedDocumentationProjectsQuery,
  DocumentationProjects_PaginatedDocumentationProjectsQueryVariables
>
export const DocumentationProjects_ArchiveDocumentationProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DocumentationProjects_archiveDocumentationProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveDocumentationProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationProjects_ArchiveDocumentationProjectMutation,
  DocumentationProjects_ArchiveDocumentationProjectMutationVariables
>
export const DocumentationTasks_PaginatedDocumentationTasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationTasks_paginatedDocumentationTasks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedDocumentationTasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numPendingDocumentationReviewRunTexts' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationTasks_PaginatedDocumentationTasksQuery,
  DocumentationTasks_PaginatedDocumentationTasksQueryVariables
>
export const DocumentationTasks_ArchiveDocumentationTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DocumentationTasks_archiveDocumentationTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveDocumentationTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationTasks_ArchiveDocumentationTaskMutation,
  DocumentationTasks_ArchiveDocumentationTaskMutationVariables
>
export const DocumentationTasks_DocumentationTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationTasks_documentationTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationTaskId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentationTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationTaskId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationTaskId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numPendingDocumentationReviewRunTexts' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numAllDocumentationReviewRunTexts' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationTaskSummaries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summary' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numPendingDocumentationReviewRunTexts' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationTasks_DocumentationTaskQuery,
  DocumentationTasks_DocumentationTaskQueryVariables
>
export const DocumentationPreview_GetDocumentationPreviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationPreview_getDocumentationPreview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationUniqueId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentationPreview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationUniqueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationUniqueId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instruction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'editUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDraft' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentationCssString' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationPreview_GetDocumentationPreviewQuery,
  DocumentationPreview_GetDocumentationPreviewQueryVariables
>
export const Integration_RepositoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Integration_repositories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repositories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'repoName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shaIndexed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Integration_RepositoriesQuery, Integration_RepositoriesQueryVariables>
export const Integration_ExistingSlackChannelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Integration_existingSlackChannels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalIntegrationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchQuery' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalSlackChannels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalIntegrationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalIntegrationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchQuery' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchQuery' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Integration_ExistingSlackChannelsQuery,
  Integration_ExistingSlackChannelsQueryVariables
>
export const Integration_AllIntegrationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Integration_allIntegrations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalIntegrationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'availableChatSources' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalIntegrations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalIntegrationIds' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'Variable', name: { kind: 'Name', value: 'externalIntegrationId' } },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalBusinessName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalIntegrationType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slackChannelConfigurations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'channelName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'repoNames' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'chatSources' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Integration_AllIntegrationsQuery,
  Integration_AllIntegrationsQueryVariables
>
export const Integration_CreateSlackChannelConfigurationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Integration_createSlackChannelConfiguration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalIntegrationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'repoNames' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showCodeSources' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showExpert' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'succinctMode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showVerifyAnswer' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'chatSources' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'AnswerTypeEnum' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSlackChannelConfiguration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalIntegrationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalIntegrationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channelName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'channelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'channelId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'repoNames' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'repoNames' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showCodeSources' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showCodeSources' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showExpert' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showExpert' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'succinctMode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'succinctMode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showVerifyAnswer' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showVerifyAnswer' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'chatSources' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'chatSources' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Integration_CreateSlackChannelConfigurationMutation,
  Integration_CreateSlackChannelConfigurationMutationVariables
>
export const Integration_DisconnectSlackExternalIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Integration_disconnectSlackExternalIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalIntegrationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disconnectSlackExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalIntegrationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalIntegrationId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  Integration_DisconnectSlackExternalIntegrationMutation,
  Integration_DisconnectSlackExternalIntegrationMutationVariables
>
export const BitbucketBranchPicker_GetRepositoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BitbucketBranchPicker_getRepositories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repositories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'repoName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'branchName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BitbucketBranchPicker_GetRepositoriesQuery,
  BitbucketBranchPicker_GetRepositoriesQueryVariables
>
export const BitBucketBranchPicker_UpdateRepositoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BitBucketBranchPicker_updateRepository' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'RepositoryInputObject' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRepository' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BitBucketBranchPicker_UpdateRepositoryMutation,
  BitBucketBranchPicker_UpdateRepositoryMutationVariables
>
export const IntegrationsList_AllIntegrationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IntegrationsList_allIntegrations' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalIntegrations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'externalBusinessName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalIntegrationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationsList_AllIntegrationsQuery,
  IntegrationsList_AllIntegrationsQueryVariables
>
export const IntegrationBitbucketExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationBitbucketExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBitbucketExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationBitbucketExchange_ExchangeCodeMutation,
  IntegrationBitbucketExchange_ExchangeCodeMutationVariables
>
export const IntegrationConfluenceExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationConfluenceExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConfluenceExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationConfluenceExchange_ExchangeCodeMutation,
  IntegrationConfluenceExchange_ExchangeCodeMutationVariables
>
export const IntegrationFrontExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationFrontExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFrontExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationFrontExchange_ExchangeCodeMutation,
  IntegrationFrontExchange_ExchangeCodeMutationVariables
>
export const IntegrationGithubDocsExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationGithubDocsExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'installationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createGithubDocsExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'installationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'installationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationGithubDocsExchange_ExchangeCodeMutation,
  IntegrationGithubDocsExchange_ExchangeCodeMutationVariables
>
export const IntegrationGithubExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationGithubExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'installationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createGithubExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'installationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'installationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationGithubExchange_ExchangeCodeMutation,
  IntegrationGithubExchange_ExchangeCodeMutationVariables
>
export const IntegrationGitlabExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationGitlabExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createGitlabExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationGitlabExchange_ExchangeCodeMutation,
  IntegrationGitlabExchange_ExchangeCodeMutationVariables
>
export const IntegrationHubspotExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationHubspotExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHubspotExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationHubspotExchange_ExchangeCodeMutation,
  IntegrationHubspotExchange_ExchangeCodeMutationVariables
>
export const IntegrationIntercomExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationIntercomExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createIntercomExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationIntercomExchange_ExchangeCodeMutation,
  IntegrationIntercomExchange_ExchangeCodeMutationVariables
>
export const IntegrationJiraExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationJiraExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createJiraExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationJiraExchange_ExchangeCodeMutation,
  IntegrationJiraExchange_ExchangeCodeMutationVariables
>
export const IntegrationLaunchdarklyExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationLaunchdarklyExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLaunchdarklyExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationLaunchdarklyExchange_ExchangeCodeMutation,
  IntegrationLaunchdarklyExchange_ExchangeCodeMutationVariables
>
export const IntegrationLinearExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationLinearExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLinearExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationLinearExchange_ExchangeCodeMutation,
  IntegrationLinearExchange_ExchangeCodeMutationVariables
>
export const IntegrationNotionExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationNotionExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNotionExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationNotionExchange_ExchangeCodeMutation,
  IntegrationNotionExchange_ExchangeCodeMutationVariables
>
export const IntegrationPendoMcpExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationPendoMcpExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPendoMcpIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'state' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendoConnected' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationPendoMcpExchange_ExchangeCodeMutation,
  IntegrationPendoMcpExchange_ExchangeCodeMutationVariables
>
export const IntegrationZendeskExchange_ExchangeCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntegrationZendeskExchange_exchangeCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createZendeskExternalIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntegrationZendeskExchange_ExchangeCodeMutation,
  IntegrationZendeskExchange_ExchangeCodeMutationVariables
>
export const GithubBranchPicker_GetRepositoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GithubBranchPicker_getRepositories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'installationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRepoNamesByInstallationId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'installationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'installationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'repoName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GithubBranchPicker_GetRepositoriesQuery,
  GithubBranchPicker_GetRepositoriesQueryVariables
>
export const GithubBranchPicker_UpdateRepositoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GithubBranchPicker_updateRepository' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'RepositoryInputObject' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRepository' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GithubBranchPicker_UpdateRepositoryMutation,
  GithubBranchPicker_UpdateRepositoryMutationVariables
>
export const GithubDocsBranchPicker_GetRepositoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GithubDocsBranchPicker_getRepositories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'installationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDocumentationRepoNamesByInstallationId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'installationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'installationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'repoName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GithubDocsBranchPicker_GetRepositoriesQuery,
  GithubDocsBranchPicker_GetRepositoriesQueryVariables
>
export const GithubDocsBranchPicker_UpdateRepositoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GithubDocsBranchPicker_updateRepository' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'RepositoryInputObject' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocumentationRepo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GithubDocsBranchPicker_UpdateRepositoryMutation,
  GithubDocsBranchPicker_UpdateRepositoryMutationVariables
>
export const GitlabBranchPicker_GetRepositoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GitlabBranchPicker_getRepositories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repositories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceType' },
                value: { kind: 'EnumValue', value: 'GITLAB' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'repoName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'branchName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GitlabBranchPicker_GetRepositoriesQuery,
  GitlabBranchPicker_GetRepositoriesQueryVariables
>
export const GitlabBranchPicker_UpdateRepositoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GitlabBranchPicker_updateRepository' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'RepositoryInputObject' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRepository' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GitlabBranchPicker_UpdateRepositoryMutation,
  GitlabBranchPicker_UpdateRepositoryMutationVariables
>
export const Question_GetQuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Question_getQuestion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'question' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'questionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prettifiedQuestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Question_GetQuestionQuery, Question_GetQuestionQueryVariables>
export const QuestionsList_QuestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'QuestionsList_questions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedQuestions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fromDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalUserName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'prettifiedQuestion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDirectMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'markedUnhelpful' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuestionsList_QuestionsQuery, QuestionsList_QuestionsQueryVariables>
export const ReleaseNote_GetTypedReleaseNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReleaseNote_getTypedReleaseNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notionConnected' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeReleaseNoteLabels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'typedReleaseNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'typedReleaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'htmlText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'markdownText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'markdownTextGroupedByLabel' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'markdownTextGroupedByLabelArray' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'labelText' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'markdownTextForSlack' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'markdownTextForSlackGroupedByLabel' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'markdownTextForSlackGroupedByLabelArray' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'labelName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'labelText' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasApprovedUsersIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approversUserIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasBeenPublished' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'releaseNoteItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summarizedTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'change' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'whyItMatters' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceLinks' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceLinkAuthors' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showMobileReleaseUx' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numPendingDocumentationReviewRunTexts' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processedRelatedDocumentation' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'relatedDocumentations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentationsCoveringFeature' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCoveredByDoc' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalTaskIssues' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalIdentifier' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'releaseNoteLabels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentationProjects' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'releaseNoteItemImagesAndVideosJson' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'releaseNoteItemComments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_GetTypedReleaseNoteQuery,
  ReleaseNote_GetTypedReleaseNoteQueryVariables
>
export const ReleaseNote_GetFeatureFlagInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReleaseNote_getFeatureFlagInfo' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFeatureFlagInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fullyOnFeatureFlags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'partiallyOnFeatureFlags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notFullyOnFeatureFlags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_GetFeatureFlagInfoQuery,
  ReleaseNote_GetFeatureFlagInfoQueryVariables
>
export const ReleaseNote_GenerateTypedReleaseNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNote_generateTypedReleaseNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateTypedReleaseNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'typedReleaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_GenerateTypedReleaseNotesMutation,
  ReleaseNote_GenerateTypedReleaseNotesMutationVariables
>
export const ReleaseNote_UpdateTypedReleaseNotesItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNote_updateTypedReleaseNotesItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemInput' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReleaseNoteItemInputObject' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateReleaseNoteItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemInput' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemInput' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_UpdateTypedReleaseNotesItemMutation,
  ReleaseNote_UpdateTypedReleaseNotesItemMutationVariables
>
export const ReleaseNote_DeleteTypedReleaseNotesItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNote_deleteTypedReleaseNotesItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteReleaseNoteItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_DeleteTypedReleaseNotesItemMutation,
  ReleaseNote_DeleteTypedReleaseNotesItemMutationVariables
>
export const ReleaseNote_DeleteReleaseNoteItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNote_deleteReleaseNoteItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteReleaseNoteItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_DeleteReleaseNoteItemsMutation,
  ReleaseNote_DeleteReleaseNoteItemsMutationVariables
>
export const ReleaseNote_RemoveReleaseNoteItemAttachmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNote_removeReleaseNoteItemAttachment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attachmentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeReleaseNoteItemAttachment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attachmentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attachmentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_RemoveReleaseNoteItemAttachmentMutation,
  ReleaseNote_RemoveReleaseNoteItemAttachmentMutationVariables
>
export const ReleaseNote_ManuallyAddReleaseNoteItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNote_manuallyAddReleaseNoteItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manuallyAddReleaseNoteItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_ManuallyAddReleaseNoteItemMutation,
  ReleaseNote_ManuallyAddReleaseNoteItemMutationVariables
>
export const ReleaseNote_ExportToCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNote_exportToCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportReleaseNotesToCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'typedReleaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_ExportToCsvMutation,
  ReleaseNote_ExportToCsvMutationVariables
>
export const ReleaseNote_ApproveReleaseNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNote_approveReleaseNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approveReleaseNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'typedReleaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_ApproveReleaseNoteMutation,
  ReleaseNote_ApproveReleaseNoteMutationVariables
>
export const ReleaseNote_ForcePublishReleaseNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNote_forcePublishReleaseNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approveReleaseNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'typedReleaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'forcePublish' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_ForcePublishReleaseNoteMutation,
  ReleaseNote_ForcePublishReleaseNoteMutationVariables
>
export const ReleaseNote_ReorderTypedReleaseNotesItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNote_reorderTypedReleaseNotesItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'releaseNoteItemPositionInputs' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'ReleaseNoteItemPositionInputObject' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reorderReleaseNoteItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemPositionInputs' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'releaseNoteItemPositionInputs' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_ReorderTypedReleaseNotesItemMutation,
  ReleaseNote_ReorderTypedReleaseNotesItemMutationVariables
>
export const ReleaseNote_UpdateHtmlTextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNote_updateHtmlText' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'htmlText' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateHtmlText' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'typedReleaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'htmlText' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'htmlText' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNote_UpdateHtmlTextMutation,
  ReleaseNote_UpdateHtmlTextMutationVariables
>
export const TypedReleaseNotesSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'TypedReleaseNotesSubscription' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'typedReleaseNotesCreated' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'objId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TypedReleaseNotesSubscriptionSubscription,
  TypedReleaseNotesSubscriptionSubscriptionVariables
>
export const ReleaseNotesList_AllTypedReleaseNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReleaseNotesList_allTypedReleaseNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedTypedReleaseNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleName' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNotesList_AllTypedReleaseNotesQuery,
  ReleaseNotesList_AllTypedReleaseNotesQueryVariables
>
export const ReleaseNotesList_ReleaseNoteScheduleNamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReleaseNotesList_releaseNoteScheduleNames' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'releaseNoteSchedules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNotesList_ReleaseNoteScheduleNamesQuery,
  ReleaseNotesList_ReleaseNoteScheduleNamesQueryVariables
>
export const DocumentationsReport_PaginatedDocumentationReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationsReport_paginatedDocumentationReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'activityTypes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersActivityTypeEnum' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionDateFrom' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionDateTo' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedDocumentationReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchTerm' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'activityTypes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'activityTypes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actionDateFrom' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionDateFrom' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actionDateTo' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionDateTo' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'suggestionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summarizedChange' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userActivity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationsReport_PaginatedDocumentationReportQuery,
  DocumentationsReport_PaginatedDocumentationReportQueryVariables
>
export const Repository_GetRepositoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Repository_getRepository' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'repositoryIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repositories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'repositoryIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'repositoryIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'repoName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'branchName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Repository_GetRepositoryQuery, Repository_GetRepositoryQueryVariables>
export const RepositoriesList_AllRepositoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RepositoriesList_allRepositories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repositories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'repoName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'branchName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shaIndexed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RepositoriesList_AllRepositoriesQuery,
  RepositoriesList_AllRepositoriesQueryVariables
>
export const ForgotPassword_AuthPasswordResetRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ForgotPassword_authPasswordResetRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authPasswordResetRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForgotPassword_AuthPasswordResetRequestMutation,
  ForgotPassword_AuthPasswordResetRequestMutationVariables
>
export const ResetPassword_ResetPasswordAllowedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResetPassword_resetPasswordAllowed' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resetPasswordToken' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetPasswordAllowed' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resetPasswordToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resetPasswordToken' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetPassword_ResetPasswordAllowedQuery,
  ResetPassword_ResetPasswordAllowedQueryVariables
>
export const ResetPassword_ResetPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetPassword_resetPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resetPasswordToken' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'newPassword' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authResetPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resetPasswordToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resetPasswordToken' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'newPassword' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'newPassword' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetPassword_ResetPasswordMutation,
  ResetPassword_ResetPasswordMutationVariables
>
export const EmailVerify_EmailVerifyAllowedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EmailVerify_emailVerifyAllowed' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emailVerificationCode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailVerifyAllowed' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailVerificationCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emailVerificationCode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emailVerifyFromUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EmailVerify_EmailVerifyAllowedQuery,
  EmailVerify_EmailVerifyAllowedQueryVariables
>
export const ActivityLog_UsersActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActivityLog_usersActivities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'usersActivities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documentationReviewRunText' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'documentation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'releaseNoteItem' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'typedReleaseNote' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActivityLog_UsersActivitiesQuery,
  ActivityLog_UsersActivitiesQueryVariables
>
export const DocumentDisplay_ImageFlowByImageSourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentDisplay_imageFlowByImageSource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageSource' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getImageFlowByImageSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imageSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'imageSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageSource' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentDisplay_ImageFlowByImageSourceQuery,
  DocumentDisplay_ImageFlowByImageSourceQueryVariables
>
export const IntroCallDialogManager_CompleteOnboardingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IntroCallDialogManager_completeOnboarding' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasSeenDemoScreen' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasSeenDemoScreen' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntroCallDialogManager_CompleteOnboardingMutation,
  IntroCallDialogManager_CompleteOnboardingMutationVariables
>
export const Navigation_MarkReadUsersActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Navigation_markReadUsersActivities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markReadUsersActivities' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  Navigation_MarkReadUsersActivitiesMutation,
  Navigation_MarkReadUsersActivitiesMutationVariables
>
export const AccountSettingsDialog_UserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountSettingsDialog_user' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersUpdate' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersUpdate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_UserQuery,
  AccountSettingsDialog_UserQueryVariables
>
export const AccountSettingsDialog_BusinessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountSettingsDialog_business' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'succinctMode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showCodeSources' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showExpert' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'showVerifyAnswer' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'releaseNotesVoice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'releaseNotesTemplate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'template' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalDocumentationVoice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalDocumentationTemplate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'template' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'enableAutoApproveDocumentation' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'testModeAutoApproveDocumentation' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoApprovePrompt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'autoApproveFeatureFlag' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageFlowInstructions' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'users' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'verified' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuperadmin' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billingPlans' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'billingType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'perUnit' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_BusinessQuery,
  AccountSettingsDialog_BusinessQueryVariables
>
export const AccountSettingsDialog_PaymentMethodsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountSettingsDialog_paymentMethods' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentMethods' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expMonth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expYear' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_PaymentMethodsQuery,
  AccountSettingsDialog_PaymentMethodsQueryVariables
>
export const AccountSettingsDialog_UpdateBusinessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_updateBusiness' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showVerifyAnswer' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showCodeSources' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showExpert' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNotesVoice' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNotesTemplate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'externalDocumentationVoice' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'externalDocumentationTemplate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageFlowInstructions' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'enableAutoApproveDocumentation' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'testModeAutoApproveDocumentation' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoApprovePrompt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoApproveFeatureFlag' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AutoApproveFeatureFlagEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBusiness' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showVerifyAnswer' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showVerifyAnswer' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showCodeSources' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showCodeSources' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showExpert' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showExpert' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNotesVoice' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNotesVoice' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNotesTemplate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNotesTemplate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalDocumentationVoice' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'externalDocumentationVoice' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalDocumentationTemplate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'externalDocumentationTemplate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imageFlowInstructions' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'imageFlowInstructions' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'enableAutoApproveDocumentation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'enableAutoApproveDocumentation' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'testModeAutoApproveDocumentation' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'testModeAutoApproveDocumentation' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'autoApprovePrompt' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'autoApprovePrompt' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'autoApproveFeatureFlag' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'autoApproveFeatureFlag' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'succinctMode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showCodeSources' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showExpert' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'releaseNotesVoice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'releaseNotesTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'template' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalDocumentationVoice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'voice' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'externalDocumentationTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'template' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'imageFlowInstructions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enableAutoApproveDocumentation' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'testModeAutoApproveDocumentation' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'autoApprovePrompt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoApproveFeatureFlag' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_UpdateBusinessMutation,
  AccountSettingsDialog_UpdateBusinessMutationVariables
>
export const AccountSettingsDialog_UserChangeRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_userChangeRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersRoleEnum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userChangeRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'role' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_UserChangeRoleMutation,
  AccountSettingsDialog_UserChangeRoleMutationVariables
>
export const AccountSettingsDialog_UserRemoveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_userRemove' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userRemove' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_UserRemoveMutation,
  AccountSettingsDialog_UserRemoveMutationVariables
>
export const AccountSettingsDialog_IntercomManualSyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_intercomManualSync' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'intercomManualSync' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_IntercomManualSyncMutation,
  AccountSettingsDialog_IntercomManualSyncMutationVariables
>
export const AccountSettingsDialog_ZendeskManualSyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_zendeskManualSync' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'zendeskManualSync' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_ZendeskManualSyncMutation,
  AccountSettingsDialog_ZendeskManualSyncMutationVariables
>
export const AccountSettingsDialog_InviteTeamMemberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_inviteTeamMember' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersRoleEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'role' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_InviteTeamMemberMutation,
  AccountSettingsDialog_InviteTeamMemberMutationVariables
>
export const AccountSettingsDialog_UpdateZendeskSubdomainDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_updateZendeskSubdomain' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'zendeskSubdomain' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateZendeskSubdomain' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'zendeskSubdomain' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'zendeskSubdomain' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_UpdateZendeskSubdomainMutation,
  AccountSettingsDialog_UpdateZendeskSubdomainMutationVariables
>
export const AccountSettingsDialog_UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_updateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersInputObject' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attributes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attributes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UsersUpdate' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UsersUpdate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_UpdateUserMutation,
  AccountSettingsDialog_UpdateUserMutationVariables
>
export const AccountSettingsDialog_PaymentCollectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_paymentCollect' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'paymentsCollect' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_PaymentCollectMutation,
  AccountSettingsDialog_PaymentCollectMutationVariables
>
export const AccountSettingsDialog_BillingPortalUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_billingPortalUrl' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'billingPortalUrl' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_BillingPortalUrlMutation,
  AccountSettingsDialog_BillingPortalUrlMutationVariables
>
export const AccountSettingsDialog_BeginPendoMcpIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSettingsDialog_beginPendoMcpIntegration' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'beginPendoMcpIntegration' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSettingsDialog_BeginPendoMcpIntegrationMutation,
  AccountSettingsDialog_BeginPendoMcpIntegrationMutationVariables
>
export const DocumentationUploadFileDialog_UploadFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DocumentationUploadFileDialog_uploadFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadDocumentationFiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationUploadFileDialog_UploadFileMutation,
  DocumentationUploadFileDialog_UploadFileMutationVariables
>
export const DocumentationVersionDialog_DocumentationVersionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationVersionDialog_documentationVersions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentationCssString' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationIds' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentationVersions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationVersionDialog_DocumentationVersionsQuery,
  DocumentationVersionDialog_DocumentationVersionsQueryVariables
>
export const DocumentationVersionDialog_UpdateContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DocumentationVersionDialog_updateContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocumentationContent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationVersionDialog_UpdateContentMutation,
  DocumentationVersionDialog_UpdateContentMutationVariables
>
export const LinkDocumentationReviewToNewExternalTaskIssueDialog_SearchExternalTaskIssuesDocument =
  {
    kind: 'Document',
    definitions: [
      {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
          kind: 'Name',
          value: 'LinkDocumentationReviewToNewExternalTaskIssueDialog_searchExternalTaskIssues',
        },
        variableDefinitions: [
          {
            kind: 'VariableDefinition',
            variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        ],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [
            {
              kind: 'Field',
              name: { kind: 'Name', value: 'searchExternalTaskIssues' },
              arguments: [
                {
                  kind: 'Argument',
                  name: { kind: 'Name', value: 'query' },
                  value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
                },
              ],
              selectionSet: {
                kind: 'SelectionSet',
                selections: [
                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                  { kind: 'Field', name: { kind: 'Name', value: 'externalIdentifier' } },
                  { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                ],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    LinkDocumentationReviewToNewExternalTaskIssueDialog_SearchExternalTaskIssuesQuery,
    LinkDocumentationReviewToNewExternalTaskIssueDialog_SearchExternalTaskIssuesQueryVariables
  >
export const LinkDocumentationReviewToNewExternalTaskIssueDialog_LinkDocumentationReviewToExistingExternalTaskIssuesDocument =
  {
    kind: 'Document',
    definitions: [
      {
        kind: 'OperationDefinition',
        operation: 'mutation',
        name: {
          kind: 'Name',
          value:
            'LinkDocumentationReviewToNewExternalTaskIssueDialog_linkDocumentationReviewToExistingExternalTaskIssues',
        },
        variableDefinitions: [
          {
            kind: 'VariableDefinition',
            variable: {
              kind: 'Variable',
              name: { kind: 'Name', value: 'documentationReviewRunTextId' },
            },
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
          {
            kind: 'VariableDefinition',
            variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalTaskIssueIds' } },
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'ListType',
                type: {
                  kind: 'NonNullType',
                  type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                },
              },
            },
          },
        ],
        selectionSet: {
          kind: 'SelectionSet',
          selections: [
            {
              kind: 'Field',
              name: { kind: 'Name', value: 'linkDocumentationReviewToExistingExternalTaskIssues' },
              arguments: [
                {
                  kind: 'Argument',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                  value: {
                    kind: 'Variable',
                    name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                  },
                },
                {
                  kind: 'Argument',
                  name: { kind: 'Name', value: 'externalTaskIssueIds' },
                  value: {
                    kind: 'Variable',
                    name: { kind: 'Name', value: 'externalTaskIssueIds' },
                  },
                },
              ],
              selectionSet: {
                kind: 'SelectionSet',
                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
              },
            },
          ],
        },
      },
    ],
  } as unknown as DocumentNode<
    LinkDocumentationReviewToNewExternalTaskIssueDialog_LinkDocumentationReviewToExistingExternalTaskIssuesMutation,
    LinkDocumentationReviewToNewExternalTaskIssueDialog_LinkDocumentationReviewToExistingExternalTaskIssuesMutationVariables
  >
export const NewDocumentationDialog_CreateDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewDocumentationDialog_createDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'instruction' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sections' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'repoNames' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'manuallyWrite' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDocumentation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'topic' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'instruction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'instruction' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sections' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sections' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'repoNames' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'repoNames' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'manuallyWrite' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'manuallyWrite' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationDialog_CreateDocumentationMutation,
  NewDocumentationDialog_CreateDocumentationMutationVariables
>
export const NewDocumentationDialog_RepositoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewDocumentationDialog_repositories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repositories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'repoName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shaIndexed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationDialog_RepositoriesQuery,
  NewDocumentationDialog_RepositoriesQueryVariables
>
export const NewDocumentationProjectDialog_CreateDocumentationProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewDocumentationProjectDialog_createDocumentationProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectLinks' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'knowledgeBaseAudit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDocumentationProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectLinks' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectLinks' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'knowledgeBaseAudit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'knowledgeBaseAudit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationProjectDialog_CreateDocumentationProjectMutation,
  NewDocumentationProjectDialog_CreateDocumentationProjectMutationVariables
>
export const NewDocumentationProjectDialog_UpdateDocumentationProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewDocumentationProjectDialog_updateDocumentationProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'existingBlobIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectLinks' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'knowledgeBaseAudit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocumentationProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectLinks' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectLinks' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'existingBlobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'existingBlobIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'knowledgeBaseAudit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'knowledgeBaseAudit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationProjectDialog_UpdateDocumentationProjectMutation,
  NewDocumentationProjectDialog_UpdateDocumentationProjectMutationVariables
>
export const NewDocumentationProjectDialog_FindDocumentationForProjectsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewDocumentationProjectDialog_findDocumentationForProjects' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findDocumentationForProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationProjectDialog_FindDocumentationForProjectsMutation,
  NewDocumentationProjectDialog_FindDocumentationForProjectsMutationVariables
>
export const NewDocumentationProjectDialog_UpdateDocumentationManuallyForProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'NewDocumentationProjectDialog_updateDocumentationManuallyForProject',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocumentationManuallyForProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationProjectDialog_UpdateDocumentationManuallyForProjectMutation,
  NewDocumentationProjectDialog_UpdateDocumentationManuallyForProjectMutationVariables
>
export const NewDocumentationProjectDialog_SearchDocumentationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewDocumentationProjectDialog_searchDocumentations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchDocumentations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationProjectDialog_SearchDocumentationsQuery,
  NewDocumentationProjectDialog_SearchDocumentationsQueryVariables
>
export const NewDocumentationProjectDialog_DocumentationProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewDocumentationProjectDialog_documentationProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationProjectId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentationProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationProjectId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationProjectId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectLinks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'knowledgeBaseAudit' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationFilesJson' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationProjectDialog_DocumentationProjectQuery,
  NewDocumentationProjectDialog_DocumentationProjectQueryVariables
>
export const DocumentationAttachedToProjectSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'DocumentationAttachedToProjectSubscription' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentationAttachedToProject' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentationProjectId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationAttachedToProjectSubscriptionSubscription,
  DocumentationAttachedToProjectSubscriptionSubscriptionVariables
>
export const NewDocumentationTaskDialog_CreateDocumentationTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewDocumentationTaskDialog_createDocumentationTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskLinks' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pullFromCodebase' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDocumentationTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskLinks' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskLinks' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pullFromCodebase' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pullFromCodebase' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationTaskDialog_CreateDocumentationTaskMutation,
  NewDocumentationTaskDialog_CreateDocumentationTaskMutationVariables
>
export const NewDocumentationTaskDialog_UpdateDocumentationTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewDocumentationTaskDialog_updateDocumentationTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'existingBlobIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskLinks' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pullFromCodebase' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocumentationTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskLinks' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskLinks' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'existingBlobIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'existingBlobIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pullFromCodebase' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pullFromCodebase' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationTaskDialog_UpdateDocumentationTaskMutation,
  NewDocumentationTaskDialog_UpdateDocumentationTaskMutationVariables
>
export const NewDocumentationTaskDialog_FindDocumentationForTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewDocumentationTaskDialog_findDocumentationForTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findDocumentationForTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationTaskDialog_FindDocumentationForTaskMutation,
  NewDocumentationTaskDialog_FindDocumentationForTaskMutationVariables
>
export const NewDocumentationTaskDialog_ArchiveDocumentationTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewDocumentationTaskDialog_archiveDocumentationTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveDocumentationTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationTaskDialog_ArchiveDocumentationTaskMutation,
  NewDocumentationTaskDialog_ArchiveDocumentationTaskMutationVariables
>
export const NewDocumentationTaskDialog_UpdateDocumentationManuallyAndRunTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'NewDocumentationTaskDialog_updateDocumentationManuallyAndRunTask',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rerunTask' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDocumentationManuallyAndRunTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rerunTask' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rerunTask' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationTaskDialog_UpdateDocumentationManuallyAndRunTaskMutation,
  NewDocumentationTaskDialog_UpdateDocumentationManuallyAndRunTaskMutationVariables
>
export const NewDocumentationTaskDialog_SearchDocumentationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewDocumentationTaskDialog_searchDocumentations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchDocumentations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationTaskDialog_SearchDocumentationsQuery,
  NewDocumentationTaskDialog_SearchDocumentationsQueryVariables
>
export const NewDocumentationTaskDialog_DocumentationTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NewDocumentationTaskDialog_documentationTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationTaskId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentationTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationTaskId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationTaskId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taskLinks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pullFromCodebase' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationTaskFilesJson' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewDocumentationTaskDialog_DocumentationTaskQuery,
  NewDocumentationTaskDialog_DocumentationTaskQueryVariables
>
export const DocumentationAttachedToTaskSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'DocumentationAttachedToTaskSubscription' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentationAttachedToTask' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'documentationTaskId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationAttachedToTaskSubscriptionSubscription,
  DocumentationAttachedToTaskSubscriptionSubscriptionVariables
>
export const NewRepositoryDialog_CreateRepositoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewRepositoryDialog_createRepository' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'repoName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'branchName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'accessToken' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRepository' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'repoName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'repoName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'branchName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'branchName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accessToken' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'accessToken' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewRepositoryDialog_CreateRepositoryMutation,
  NewRepositoryDialog_CreateRepositoryMutationVariables
>
export const NewTypedReleaseNoteDialog_CreateTypedReleaseNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'NewTypedReleaseNoteDialog_createTypedReleaseNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manuallyCreateTypedReleaseNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewTypedReleaseNoteDialog_CreateTypedReleaseNoteMutation,
  NewTypedReleaseNoteDialog_CreateTypedReleaseNoteMutationVariables
>
export const PublishDocumentationDialog_DocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishDocumentationDialog_documentation' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationDialog_DocumentationQuery,
  PublishDocumentationDialog_DocumentationQueryVariables
>
export const PublishDocumentationDialog_IntercomCollectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishDocumentationDialog_intercomCollections' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'intercomGetCollections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationDialog_IntercomCollectionsQuery,
  PublishDocumentationDialog_IntercomCollectionsQueryVariables
>
export const PublishDocumentationDialog_HelpScoutCollectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishDocumentationDialog_helpScoutCollections' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'helpScoutGetCollections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'siteName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationDialog_HelpScoutCollectionsQuery,
  PublishDocumentationDialog_HelpScoutCollectionsQueryVariables
>
export const PublishDocumentationDialog_PylonCollectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishDocumentationDialog_pylonCollections' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pylonGetCollections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'knowledgeBaseName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationDialog_PylonCollectionsQuery,
  PublishDocumentationDialog_PylonCollectionsQueryVariables
>
export const PublishDocumentationDialog_Document360CollectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishDocumentationDialog_document360Collections' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'document360GetCollections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workspaceName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationDialog_Document360CollectionsQuery,
  PublishDocumentationDialog_Document360CollectionsQueryVariables
>
export const PublishDocumentationDialog_TeamsupportGetAllKnowledgeBaseCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'PublishDocumentationDialog_teamsupportGetAllKnowledgeBaseCategories',
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'teamsupportGetAllKnowledgeBaseCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationDialog_TeamsupportGetAllKnowledgeBaseCategoriesQuery,
  PublishDocumentationDialog_TeamsupportGetAllKnowledgeBaseCategoriesQueryVariables
>
export const PublishDocumentationDialog_FrontCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishDocumentationDialog_frontCategories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'frontGetCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'knowledgeBaseName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationDialog_FrontCategoriesQuery,
  PublishDocumentationDialog_FrontCategoriesQueryVariables
>
export const PublishDocumentationDialog_ZendeskSectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishDocumentationDialog_zendeskSections' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'zendeskGetSections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'categoryName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationDialog_ZendeskSectionsQuery,
  PublishDocumentationDialog_ZendeskSectionsQueryVariables
>
export const PublishDocumentationDialog_HubspotCollectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishDocumentationDialog_hubspotCollections' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hubspotGetCollections' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'knowledgeBaseId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCategoryId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'parentCategoryName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationDialog_HubspotCollectionsQuery,
  PublishDocumentationDialog_HubspotCollectionsQueryVariables
>
export const PublishDocumentationDialog_SectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishDocumentationDialog_sections' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featurebaseCollections' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationDialog_SectionsQuery,
  PublishDocumentationDialog_SectionsQueryVariables
>
export const PublishDocumentationDialog_GetDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishDocumentationDialog_getDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageCollections' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationDialog_GetDocumentationQuery,
  PublishDocumentationDialog_GetDocumentationQueryVariables
>
export const PublishDocumentationTaskDialog_SearchDocumentationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishDocumentationTaskDialog_searchDocumentations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceType' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DocumentationsSourceTypeEnum' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchDocumentations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPageId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishDocumentationTaskDialog_SearchDocumentationsQuery,
  PublishDocumentationTaskDialog_SearchDocumentationsQueryVariables
>
export const PublishReleaseNoteExternallyDialog_PublishReleaseNoteExternallyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'PublishReleaseNoteExternallyDialog_publishReleaseNoteExternally',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishReleaseNoteExternally' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'typedReleaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'typedReleaseNoteId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishReleaseNoteExternallyDialog_PublishReleaseNoteExternallyMutation,
  PublishReleaseNoteExternallyDialog_PublishReleaseNoteExternallyMutationVariables
>
export const PublishReleaseNoteExternallyDialog_SearchDocumentationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublishReleaseNoteExternallyDialog_searchDocumentations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchDocumentations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublishReleaseNoteExternallyDialog_SearchDocumentationsQuery,
  PublishReleaseNoteExternallyDialog_SearchDocumentationsQueryVariables
>
export const DocumentationAttachedToReleaseNoteItemSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'DocumentationAttachedToReleaseNoteItemSubscription' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentationAttachedToReleaseNoteItem' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'releaseNoteItemId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'relatedDocumentations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationAttachedToReleaseNoteItemSubscriptionSubscription,
  DocumentationAttachedToReleaseNoteItemSubscriptionSubscriptionVariables
>
export const RelatedDocumentationDialog_FindDocumentationForReleaseNoteItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'RelatedDocumentationDialog_findDocumentationForReleaseNoteItem',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findDocumentationForReleaseNoteItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RelatedDocumentationDialog_FindDocumentationForReleaseNoteItemMutation,
  RelatedDocumentationDialog_FindDocumentationForReleaseNoteItemMutationVariables
>
export const ReleaseNoteItemUploadImageDialog_UploadImagesAndVideoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNoteItemUploadImageDialog_uploadImagesAndVideo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadImagesAndVideo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNoteItemUploadImageDialog_UploadImagesAndVideoMutation,
  ReleaseNoteItemUploadImageDialog_UploadImagesAndVideoMutationVariables
>
export const ReleaseNotesScheduleDialog_UpsertReleaseNoteScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNotesScheduleDialog_upsertReleaseNoteSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'frequencyType' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReleaseNoteScheduleFrequencyTypeEnum' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalChannelId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'publishDelay' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ReleaseNoteSchedulePublishDelayEnum' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ownersToNotify' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'requireApproval' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'repoNames' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertReleaseNoteSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'frequencyType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'frequencyType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalChannelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalChannelId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publishDelay' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'publishDelay' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ownersToNotify' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ownersToNotify' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'requireApproval' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'requireApproval' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'repoNames' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'repoNames' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleName' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frequencyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalChannelId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishDelay' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'repoNames' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ownersToNotifyUsers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'requireApproval' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNotesScheduleDialog_UpsertReleaseNoteScheduleMutation,
  ReleaseNotesScheduleDialog_UpsertReleaseNoteScheduleMutationVariables
>
export const ReleaseNotesScheduleDialog_ReleaseNoteSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReleaseNotesScheduleDialog_releaseNoteSchedules' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'releaseNoteSchedules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frequencyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalChannelId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishDelay' } },
                { kind: 'Field', name: { kind: 'Name', value: 'repoNames' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ownersToNotifyUsers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'requireApproval' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNotesScheduleDialog_ReleaseNoteSchedulesQuery,
  ReleaseNotesScheduleDialog_ReleaseNoteSchedulesQueryVariables
>
export const ReleaseNotesScheduleDialog_ExistingSlackChannelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReleaseNotesScheduleDialog_existingSlackChannels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchQuery' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalSlackChannels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchQuery' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchQuery' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNotesScheduleDialog_ExistingSlackChannelsQuery,
  ReleaseNotesScheduleDialog_ExistingSlackChannelsQueryVariables
>
export const ReleaseNotesScheduleDialog_UsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReleaseNotesScheduleDialog_users' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'verifiedUsers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNotesScheduleDialog_UsersQuery,
  ReleaseNotesScheduleDialog_UsersQueryVariables
>
export const ReleaseNotesScheduleDialog_RepositoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReleaseNotesScheduleDialog_repositories' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'repositories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'repoName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shaIndexed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNotesScheduleDialog_RepositoriesQuery,
  ReleaseNotesScheduleDialog_RepositoriesQueryVariables
>
export const ReplaceImageDialog_ReplaceDocumentationReviewImageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReplaceImageDialog_replaceDocumentationReviewImage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'replaceDocumentationReviewImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uploadSignedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadSignedId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationsToReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newDocumentationMarkdownText' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReplaceImageDialog_ReplaceDocumentationReviewImageMutation,
  ReplaceImageDialog_ReplaceDocumentationReviewImageMutationVariables
>
export const ReplaceImageDialog_GetDocumentationToReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReplaceImageDialog_getDocumentationToReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationToReviewId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDocumentationToReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationToReviewId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationToReviewId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allImageVersions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'newDocumentationMarkdownText' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReplaceImageDialog_GetDocumentationToReviewQuery,
  ReplaceImageDialog_GetDocumentationToReviewQueryVariables
>
export const SnoozeDocumentationReviewDialog_SnoozeDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SnoozeDocumentationReviewDialog_snoozeDocumentationReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'snoozeUntilDate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'snoozeUntilFlagChange' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'snoozeDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'snoozeUntilDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'snoozeUntilDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'snoozeUntilFlagChange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'snoozeUntilFlagChange' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SnoozeDocumentationReviewDialog_SnoozeDocumentationReviewMutation,
  SnoozeDocumentationReviewDialog_SnoozeDocumentationReviewMutationVariables
>
export const SnoozeReleaseNoteItemDialog_SnoozeReleaseNoteItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SnoozeReleaseNoteItemDialog_snoozeReleaseNoteItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'snoozeType' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TypedReleaseNoteSnoozeTypeEnum' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'snoozeUntilDate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'snoozeReleaseNoteItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'snoozeUntilDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'snoozeUntilDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'snoozeType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'snoozeType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SnoozeReleaseNoteItemDialog_SnoozeReleaseNoteItemMutation,
  SnoozeReleaseNoteItemDialog_SnoozeReleaseNoteItemMutationVariables
>
export const SourceDocumentationReviewDialog_GetDocumentationToReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SourceDocumentationReviewDialog_getDocumentationToReview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationToReviewId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDocumentationToReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationToReviewId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationToReviewId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceLinks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceLinkAuthors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceLinkDates' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceLinkCommitMessages' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SourceDocumentationReviewDialog_GetDocumentationToReviewQuery,
  SourceDocumentationReviewDialog_GetDocumentationToReviewQueryVariables
>
export const UpsertFlowDialog_LoginFlowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpsertFlowDialog_loginFlow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'browserFlowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginFlow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'browserFlowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'browserFlowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BrowserFlow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowSteps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flowExecutionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawJsCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'referencedFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stepDescription' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowRuns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrls' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentCompletedBrowserFlowRun' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertFlowDialog_LoginFlowQuery,
  UpsertFlowDialog_LoginFlowQueryVariables
>
export const UpsertFlowDialog_LoginFlowsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpsertFlowDialog_loginFlows' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginFlows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BrowserFlow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowSteps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flowExecutionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawJsCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'referencedFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stepDescription' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowRuns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrls' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentCompletedBrowserFlowRun' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertFlowDialog_LoginFlowsQuery,
  UpsertFlowDialog_LoginFlowsQueryVariables
>
export const UpsertFlowDialog_ImageFlowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UpsertFlowDialog_imageFlow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageFlowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'imageFlow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imageFlowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'imageFlowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UpsertFlowDialog_imageFlow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BrowserFlow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowSteps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flowExecutionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawJsCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'referencedFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stepDescription' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowRuns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrls' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentCompletedBrowserFlowRun' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpsertFlowDialog_imageFlow' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageFlow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageSource' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertFlowDialog_ImageFlowQuery,
  UpsertFlowDialog_ImageFlowQueryVariables
>
export const UpsertFlowDialog_UpsertImageFlowWithCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertFlowDialog_upsertImageFlowWithCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageFlowId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rawJsCode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'imageSource' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'loginBrowserFlowId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startUrl' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stepDescription' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertImageFlowWithCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imageFlowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'imageFlowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rawJsCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rawJsCode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'imageSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'imageSource' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'loginBrowserFlowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'loginBrowserFlowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startUrl' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startUrl' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stepDescription' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'stepDescription' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UpsertFlowDialog_imageFlow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BrowserFlow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowSteps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flowExecutionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawJsCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'referencedFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stepDescription' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowRuns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrls' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentCompletedBrowserFlowRun' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpsertFlowDialog_imageFlow' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ImageFlow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageSource' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertFlowDialog_UpsertImageFlowWithCodeMutation,
  UpsertFlowDialog_UpsertImageFlowWithCodeMutationVariables
>
export const UpsertFlowDialog_UpsertLoginFlowWithCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertFlowDialog_upsertLoginFlowWithCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'browserFlowId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rawJsCode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startUrl' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stepDescription' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertLoginFlowWithCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'browserFlowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'browserFlowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rawJsCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rawJsCode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startUrl' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startUrl' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stepDescription' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'stepDescription' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BrowserFlow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowSteps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flowExecutionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawJsCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'referencedFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stepDescription' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowRuns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrls' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentCompletedBrowserFlowRun' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertFlowDialog_UpsertLoginFlowWithCodeMutation,
  UpsertFlowDialog_UpsertLoginFlowWithCodeMutationVariables
>
export const UpsertFlowDialog_RunBrowserFlowDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertFlowDialog_runBrowserFlow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'browserFlowId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'runBrowserFlow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'browserFlowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'browserFlowId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpsertFlowDialog_browserFlow' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BrowserFlow' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowSteps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flowExecutionType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawJsCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'referencedFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flowType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stepDescription' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowRuns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sessionReplayUrls' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mostRecentCompletedBrowserFlowRun' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertFlowDialog_RunBrowserFlowMutation,
  UpsertFlowDialog_RunBrowserFlowMutationVariables
>
export const DocumentationImages_BrowserFlowImageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'DocumentationImages_browserFlowImage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'browserFlowImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'browserFlowId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'browserFlowRunId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastRun' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationImages_BrowserFlowImageSubscription,
  DocumentationImages_BrowserFlowImageSubscriptionVariables
>
export const DocumentationTasks_PaginatedOpportunityThemeConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationTasks_paginatedOpportunityThemeConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'themeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedOpportunityThemeConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'themeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'themeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summarizedQuestion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summarizedAnswer' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalCustomerConversation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conversationCreatedAt' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationTasks_PaginatedOpportunityThemeConversationsQuery,
  DocumentationTasks_PaginatedOpportunityThemeConversationsQueryVariables
>
export const DocumentationReviewCommmentSheet_AddCommentToDocumentation_ReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'DocumentationReviewCommmentSheet_addCommentToDocumentation_review',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'documentationReviewRunTextId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addCommentToDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'documentationReviewRunTextId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'comment' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationReviewCommmentSheet_AddCommentToDocumentation_ReviewMutation,
  DocumentationReviewCommmentSheet_AddCommentToDocumentation_ReviewMutationVariables
>
export const DocumentationReviewCommmentSheet_UsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationReviewCommmentSheet_Users' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'users' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationReviewCommmentSheet_UsersQuery,
  DocumentationReviewCommmentSheet_UsersQueryVariables
>
export const DocumentationSheet_GetDocumentationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationSheet_getDocumentation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'documentations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentationIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentationIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                { kind: 'Field', name: { kind: 'Name', value: 'instruction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalContent' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalContentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'editUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalPageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalCreatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'helpCenterName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authorName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationSheet_GetDocumentationQuery,
  DocumentationSheet_GetDocumentationQueryVariables
>
export const ReleaseNoteItemCommmentSheet_AddCommentToReleaseNoteItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNoteItemCommmentSheet_addCommentToReleaseNoteItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addCommentToReleaseNoteItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'comment' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNoteItemCommmentSheet_AddCommentToReleaseNoteItemMutation,
  ReleaseNoteItemCommmentSheet_AddCommentToReleaseNoteItemMutationVariables
>
export const ReleaseNoteItemCommmentSheet_ReleaseNoteItemCommentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReleaseNoteItemCommmentSheet_releaseNoteItemComments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'releaseNoteItemComments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'comment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNoteItemCommmentSheet_ReleaseNoteItemCommentsQuery,
  ReleaseNoteItemCommmentSheet_ReleaseNoteItemCommentsQueryVariables
>
export const ReleaseNoteItemCommmentSheet_UsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReleaseNoteItemCommmentSheet_Users' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'users' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNoteItemCommmentSheet_UsersQuery,
  ReleaseNoteItemCommmentSheet_UsersQueryVariables
>
export const TypedReleaseNotesItemAnsweredDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'TypedReleaseNotesItemAnswered' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'releaseNoteItemAnswered' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'objId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TypedReleaseNotesItemAnsweredSubscription,
  TypedReleaseNotesItemAnsweredSubscriptionVariables
>
export const ReleaseNoteItemQuestionSheet_ReleaseNoteItemAskQuestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReleaseNoteItemQuestionSheet_releaseNoteItemAskQuestion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'question' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'previousMessages' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'releaseNoteItemAskQuestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteItemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteItemId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'question' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'question' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'previousMessages' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'previousMessages' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReleaseNoteItemQuestionSheet_ReleaseNoteItemAskQuestionMutation,
  ReleaseNoteItemQuestionSheet_ReleaseNoteItemAskQuestionMutationVariables
>
export const DocumentationTasks_PaginatedSuccessfulCoverageConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationTasks_paginatedSuccessfulCoverageConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalTopicId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalSubtopicId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paginatedSuccessfulCoverageConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalTopicId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalTopicId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalSubtopicId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalSubtopicId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summarizedQuestion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'summarizedAnswer' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalCustomerConversation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conversationCreatedAt' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sourceType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationTasks_PaginatedSuccessfulCoverageConversationsQuery,
  DocumentationTasks_PaginatedSuccessfulCoverageConversationsQueryVariables
>
export const DocumentationActionItemsToolbar_AvailableChangeReasonsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationActionItemsToolbar_availableChangeReasons' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'allPendingChangeReasons' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeReleaseNoteLabels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationActionItemsToolbar_AvailableChangeReasonsQuery,
  DocumentationActionItemsToolbar_AvailableChangeReasonsQueryVariables
>
export const DocumentationActionItemsToolbar_ShowEnableBulkAcceptAllDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'DocumentationActionItemsToolbar_showEnableBulkAcceptAllDocumentationReview',
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'showEnableBulkAcceptAllDocumentationReview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationActionItemsToolbar_ShowEnableBulkAcceptAllDocumentationReviewQuery,
  DocumentationActionItemsToolbar_ShowEnableBulkAcceptAllDocumentationReviewQueryVariables
>
export const DocumentationActionItemsToolbar_AvailableFeatureFlagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationActionItemsToolbar_availableFeatureFlags' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'pendingDocumentationReviewRunTextsFeatureFlags',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationActionItemsToolbar_AvailableFeatureFlagsQuery,
  DocumentationActionItemsToolbar_AvailableFeatureFlagsQueryVariables
>
export const DocumentationActionItemsToolbar_BulkAcceptAllDocumentationReviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'DocumentationActionItemsToolbar_bulkAcceptAllDocumentationReview',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'branchName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkAcceptAllDocumentationReview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'branchName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'branchName' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationActionItemsToolbar_BulkAcceptAllDocumentationReviewMutation,
  DocumentationActionItemsToolbar_BulkAcceptAllDocumentationReviewMutationVariables
>
export const DocumentationActionItemsToolbar_SearchDocumentationTasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DocumentationActionItemsToolbar_searchDocumentationTasks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchDocumentationTasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentationActionItemsToolbar_SearchDocumentationTasksQuery,
  DocumentationActionItemsToolbar_SearchDocumentationTasksQueryVariables
>
export const QuestionsToolbar_ExportToCsvDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'QuestionsToolbar_exportToCsv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportToCsv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fromDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fromDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toDate' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  QuestionsToolbar_ExportToCsvMutation,
  QuestionsToolbar_ExportToCsvMutationVariables
>
export const TypedReleaseNotesToolbar_SearchReleaseNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TypedReleaseNotesToolbar_searchReleaseNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchReleaseNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'summarizedTitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typedReleaseNote' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TypedReleaseNotesToolbar_SearchReleaseNotesQuery,
  TypedReleaseNotesToolbar_SearchReleaseNotesQueryVariables
>
export const TypedReleaseNotesToolbar_ReleaseNoteScheduleNamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TypedReleaseNotesToolbar_releaseNoteScheduleNames' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'releaseNoteSchedules' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TypedReleaseNotesToolbar_ReleaseNoteScheduleNamesQuery,
  TypedReleaseNotesToolbar_ReleaseNoteScheduleNamesQueryVariables
>
export const AddBusinessNameForm_CreateReleaseNoteLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddBusinessNameForm_createReleaseNoteLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteLabels' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ReleaseNoteLabelInputObject' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createReleaseNoteLabel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteLabels' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteLabels' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddBusinessNameForm_CreateReleaseNoteLabelMutation,
  AddBusinessNameForm_CreateReleaseNoteLabelMutationVariables
>
export const AddBusinessNameForm_UpdateReleaseNoteLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddBusinessNameForm_updateReleaseNoteLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateReleaseNoteLabel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddBusinessNameForm_UpdateReleaseNoteLabelMutation,
  AddBusinessNameForm_UpdateReleaseNoteLabelMutationVariables
>
export const AddBusinessNameForm_DeleteReleaseNoteLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddBusinessNameForm_deleteReleaseNoteLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteReleaseNoteLabel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddBusinessNameForm_DeleteReleaseNoteLabelMutation,
  AddBusinessNameForm_DeleteReleaseNoteLabelMutationVariables
>
export const AddBusinessNameForm_ReorderReleaseNoteLabelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddBusinessNameForm_reorderReleaseNoteLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteLabelIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reorderReleaseNoteLabels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteLabelIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteLabelIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddBusinessNameForm_ReorderReleaseNoteLabelMutation,
  AddBusinessNameForm_ReorderReleaseNoteLabelMutationVariables
>
export const AddBusinessNameForm_ReleaseNoteLabelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AddBusinessNameForm_releaseNoteLabels' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeReleaseNoteLabels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'assignee' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddBusinessNameForm_ReleaseNoteLabelsQuery,
  AddBusinessNameForm_ReleaseNoteLabelsQueryVariables
>
export const AddBusinessNameForm_UpdateAssigneeReleaseNoteLabelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddBusinessNameForm_updateAssigneeReleaseNoteLabels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteLabelId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assigneeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAssigneeReleaseNoteLabels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'releaseNoteLabelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'releaseNoteLabelId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assigneeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'assigneeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddBusinessNameForm_UpdateAssigneeReleaseNoteLabelsMutation,
  AddBusinessNameForm_UpdateAssigneeReleaseNoteLabelsMutationVariables
>
export const ProviderAuthenticationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ProviderAuthentication' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthProviderTypeEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeUniqueId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referredByUserUniqueId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authProviderAuthenticate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'provider' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeUniqueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeUniqueId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referredByUserUniqueId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'referredByUserUniqueId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuthResponse' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuthResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProviderAuthenticationMutation,
  ProviderAuthenticationMutationVariables
>
export const CredentialsAuthenticationSignInDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CredentialsAuthenticationSignIn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authSignIn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuthResponse' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuthResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CredentialsAuthenticationSignInMutation,
  CredentialsAuthenticationSignInMutationVariables
>
export const CredentialsAuthenticationSignUpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CredentialsAuthenticationSignUp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referredByUserUniqueId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resumeUniqueId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emailVerifyFromUrl' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authSignUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referredByUserUniqueId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'referredByUserUniqueId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resumeUniqueId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resumeUniqueId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailVerifyFromUrl' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emailVerifyFromUrl' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuthResponse' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuthResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CredentialsAuthenticationSignUpMutation,
  CredentialsAuthenticationSignUpMutationVariables
>
export const CredentialsAuthenticationEmailVerifyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CredentialsAuthenticationEmailVerify' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emailVerificationCode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userEmailVerify' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailVerificationCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emailVerificationCode' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AuthResponse' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AuthResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AuthResponse' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'token' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'business' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CredentialsAuthenticationEmailVerifyMutation,
  CredentialsAuthenticationEmailVerifyMutationVariables
>
export const RootDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Root' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RootQuery, RootQueryVariables>
export const UseCurrentUser_UsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'useCurrentUser_users' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Users' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Users' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Users' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuperadmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'verified' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadUsersActivitiesCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'business' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'codeConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'codeIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentationCodeConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentationCodeIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentationRepoNamePath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'githubConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gitlabConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slackConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notionConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notionIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intercomConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'intercomIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zendeskConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zendeskIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featurebaseConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bitbucketConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confluenceConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confluenceIndexing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jiraConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'launchdarklyConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linearConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frontConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendoConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hubspotConnected' } },
                { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availableDocumentationSources' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultChatSources' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availableChatSources' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableChatSourcesAndCommitHistory' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasSeenDemoScreen' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlagFullLink' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'disableManualReleaseNotesGeneration' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hideReleaseNoteItemHeaders' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enableManualDocumentationAuditing' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'enableCoverageFeature' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasDocumentationStyleGuide' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'enableExternalForReleaseNoteApprovals' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasTranslatedDocumentation' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skipDocumentationFindingStepForTasks' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'branchNamesAcceptedDocumentationReviewRunTextsInGithub',
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'defaultDocumentationForExternalReleaseNoteApprovals',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documentationProjects' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseCurrentUser_UsersQuery, UseCurrentUser_UsersQueryVariables>
